
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb7ae"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb7ae"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("i8qGU", function(module, exports) {
"use strict";
module.exports = JSON.parse("{\"achievements\":{\"Beginner\":{\"threshold\":50,\"earned\":false,\"messageKey\":\"achievements.beginner\"},\"CarrotSnatcher\":{\"threshold\":100,\"earned\":false,\"messageKey\":\"achievements.carrotSnatcher\"},\"BunnyBerserker\":{\"threshold\":200,\"earned\":false,\"messageKey\":\"achievements.bunnyBerserker\"},\"HopPunk\":{\"threshold\":300,\"earned\":false,\"messageKey\":\"achievements.hopPunk\"},\"BunnyNinja\":{\"threshold\":400,\"earned\":false,\"messageKey\":\"achievements.bunnyNinja\"},\"Expert\":{\"threshold\":500,\"earned\":false,\"messageKey\":\"achievements.expert\"},\"Master\":{\"threshold\":1000,\"earned\":false,\"messageKey\":\"achievements.master\"},\"Carrotpocalypse\":{\"threshold\":2000,\"earned\":false,\"messageKey\":\"achievements.carrotpocalypse\"},\"BunnyOverlord\":{\"threshold\":3000,\"earned\":false,\"messageKey\":\"achievements.bunnyOverlord\"},\"ChaosHare\":{\"threshold\":4000,\"earned\":false,\"messageKey\":\"achievements.chaosHare\"},\"CarrotCultist\":{\"threshold\":5000,\"earned\":false,\"messageKey\":\"achievements.carrotCultist\"},\"BunnyberryPie\":{\"threshold\":6000,\"earned\":false,\"messageKey\":\"achievements.bunnyberryPie\"},\"RabbitHole\":{\"threshold\":7000,\"earned\":false,\"messageKey\":\"achievements.rabbitHole\"},\"MoonRabbit\":{\"threshold\":8000,\"earned\":false,\"messageKey\":\"achievements.moonRabbit\"},\"BunnyDoom\":{\"threshold\":9000,\"earned\":false,\"messageKey\":\"achievements.bunnyDoom\"},\"CarrotNuke\":{\"threshold\":10000,\"earned\":false,\"messageKey\":\"achievements.carrotNuke\"},\"BunnyMatrix\":{\"threshold\":15000,\"earned\":false,\"messageKey\":\"achievements.bunnyMatrix\"},\"CosmicHare\":{\"threshold\":25000,\"earned\":false,\"messageKey\":\"achievements.cosmicHare\"},\"WarrenSingularity\":{\"threshold\":42000,\"earned\":false,\"messageKey\":\"achievements.warrenSingularity\"},\"EternalBunny\":{\"threshold\":50000,\"earned\":false,\"messageKey\":\"achievements.eternalBunny\"}}}");

});

parcelRegister("lVnrG", function(module, exports) {
"use strict";
module.exports = JSON.parse("{\"messages\":[{\"clicks\":13,\"messageKey\":\"messages.prophecy\"},{\"clicks\":42,\"messageKey\":\"messages.cosmic\"},{\"clicks\":67,\"messageKey\":\"messages.astral\"},{\"clicks\":87,\"messageKey\":\"messages.speaking\"},{\"clicks\":110,\"messageKey\":\"messages.ancient\"},{\"clicks\":133,\"messageKey\":\"messages.sages\"},{\"clicks\":156,\"messageKey\":\"messages.demons\"},{\"clicks\":189,\"messageKey\":\"messages.veil\"},{\"clicks\":215,\"messageKey\":\"messages.spirits\"},{\"clicks\":238,\"messageKey\":\"messages.council\"},{\"clicks\":275,\"messageKey\":\"messages.primordial\"},{\"clicks\":299,\"messageKey\":\"messages.void\"},{\"clicks\":315,\"messageKey\":\"messages.runes\"},{\"clicks\":333,\"messageKey\":\"messages.beast\"},{\"clicks\":350,\"messageKey\":\"messages.prophets\"},{\"clicks\":375,\"messageKey\":\"messages.dimensions\"},{\"clicks\":420,\"messageKey\":\"messages.portal\"},{\"clicks\":469,\"messageKey\":\"messages.burrow\"},{\"clicks\":512,\"messageKey\":\"messages.warren\"},{\"clicks\":567,\"messageKey\":\"messages.sacrifice\"},{\"clicks\":616,\"messageKey\":\"messages.thump\"},{\"clicks\":666,\"messageKey\":\"messages.darkWarren\"},{\"clicks\":717,\"messageKey\":\"messages.ears\"},{\"clicks\":777,\"messageKey\":\"messages.jackpot\"},{\"clicks\":888,\"messageKey\":\"messages.unmatched\"},{\"clicks\":950,\"messageKey\":\"messages.carrotThrone\"},{\"clicks\":999,\"messageKey\":\"messages.reality\"},{\"clicks\":1111,\"messageKey\":\"messages.onesAlignment\"},{\"clicks\":1337,\"messageKey\":\"messages.elite\"},{\"clicks\":1500,\"messageKey\":\"messages.power\"},{\"clicks\":1666,\"messageKey\":\"messages.devils\"},{\"clicks\":1777,\"messageKey\":\"messages.lucky\"},{\"clicks\":1888,\"messageKey\":\"messages.dynasty\"},{\"clicks\":2000,\"messageKey\":\"messages.twoThousand\"},{\"clicks\":2222,\"messageKey\":\"messages.quartet\"},{\"clicks\":2500,\"messageKey\":\"messages.transcend\"},{\"clicks\":2750,\"messageKey\":\"messages.constellation\"},{\"clicks\":3000,\"messageKey\":\"messages.destiny\"},{\"clicks\":3333,\"messageKey\":\"messages.triforce\"},{\"clicks\":3777,\"messageKey\":\"messages.fortune\"},{\"clicks\":4000,\"messageKey\":\"messages.newDimensions\"},{\"clicks\":4444,\"messageKey\":\"messages.quartet2\"},{\"clicks\":4999,\"messageKey\":\"messages.threshold\"},{\"clicks\":5000,\"messageKey\":\"messages.ultimate\"},{\"clicks\":5555,\"messageKey\":\"messages.force\"},{\"clicks\":6666,\"messageKey\":\"messages.underworld\"},{\"clicks\":7500,\"messageKey\":\"messages.moonSummon\"},{\"clicks\":7777,\"messageKey\":\"messages.maxJackpot\"},{\"clicks\":8888,\"messageKey\":\"messages.infinite\"},{\"clicks\":9999,\"messageKey\":\"messages.edgeOfForever\"},{\"clicks\":10000,\"messageKey\":\"messages.godhood\"},{\"clicks\":11111,\"messageKey\":\"messages.beyondTheVeil\"},{\"clicks\":12345,\"messageKey\":\"messages.sequence\"},{\"clicks\":13337,\"messageKey\":\"messages.hyperElite\"},{\"clicks\":14000,\"messageKey\":\"messages.eventHorizon\"},{\"clicks\":15000,\"messageKey\":\"messages.matrixAwakens\"},{\"clicks\":17777,\"messageKey\":\"messages.luckyForever\"},{\"clicks\":20000,\"messageKey\":\"messages.twentyK\"},{\"clicks\":25000,\"messageKey\":\"messages.singularity\"},{\"clicks\":33333,\"messageKey\":\"messages.tripleAscension\"},{\"clicks\":42000,\"messageKey\":\"messages.ultimateAnswer\"},{\"clicks\":50000,\"messageKey\":\"messages.eternity\"}]}");

});

parcelRegister("fAcbY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.languages = module.exports.i18nInstance = module.exports.default = void 0;

var $b583ace8906d2a59$var$_i18next = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("cC7WN")));

var $b583ace8906d2a59$var$_i18nextBrowserLanguagedetector = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("8izYb")));

var $b583ace8906d2a59$var$_translation = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("lXa4i")));

var $b583ace8906d2a59$var$_translation2 = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("5qXa8")));

var $b583ace8906d2a59$var$_translation3 = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("cPlR7")));

var $b583ace8906d2a59$var$_translation4 = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("TwGGT")));

var $b583ace8906d2a59$var$_translation5 = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("jGnFL")));

var $b583ace8906d2a59$var$_translation6 = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("ltNo2")));

var $b583ace8906d2a59$var$_translation7 = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("gZmg8")));

var $b583ace8906d2a59$var$_translation8 = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("lDS5j")));

var $b583ace8906d2a59$var$_translation9 = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("iIwbz")));

var $b583ace8906d2a59$var$_translation0 = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("g6Gro")));

var $b583ace8906d2a59$var$_translation1 = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("l7Wqg")));

var $b583ace8906d2a59$var$_translation10 = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("ekvVh")));

var $b583ace8906d2a59$var$_translation11 = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("h4Lbe")));

var $b583ace8906d2a59$var$_translation12 = $b583ace8906d2a59$var$_interopRequireDefault((parcelRequire("QnZ5l")));
function $b583ace8906d2a59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b583ace8906d2a59$var$languages = module.exports.languages = {
    en: {
        nativeName: "English"
    },
    ja: {
        nativeName: "\u65E5\u672C\u8A9E"
    },
    es: {
        nativeName: "Espa\xf1ol"
    },
    zh: {
        nativeName: "\u4E2D\u6587"
    },
    id: {
        nativeName: "Bahasa Indonesia"
    },
    ko: {
        nativeName: "\uD55C\uAD6D\uC5B4"
    },
    hi: {
        nativeName: "\u0939\u093F\u0928\u094D\u0926\u0940"
    },
    pt: {
        nativeName: "Portugu\xeas"
    },
    de: {
        nativeName: "Deutsch"
    },
    fr: {
        nativeName: "Fran\xe7ais"
    },
    pl: {
        nativeName: "Polski"
    },
    "zh-TW": {
        nativeName: "\u7E41\u9AD4\u4E2D\u6587"
    },
    it: {
        nativeName: "Italiano"
    },
    pirate: {
        nativeName: "Pirate"
    }
};
// You can override the language by adding ?lng=LANGUAGE_CODE to the URL
// For example: ?lng=ja for Japanese, ?lng=es for Spanish
const $b583ace8906d2a59$var$i18nInstance = module.exports.i18nInstance = $b583ace8906d2a59$var$_i18next.default.use($b583ace8906d2a59$var$_i18nextBrowserLanguagedetector.default).init({
    detection: {
        order: [
            "querystring",
            "navigator"
        ],
        lookupQuerystring: "lng"
    },
    debug: true,
    fallbackLng: {
        "zh-TW": [
            "zh"
        ],
        default: [
            "en"
        ]
    },
    resources: {
        en: {
            translation: $b583ace8906d2a59$var$_translation2.default
        },
        ja: {
            translation: $b583ace8906d2a59$var$_translation8.default
        },
        es: {
            translation: $b583ace8906d2a59$var$_translation3.default
        },
        zh: {
            translation: $b583ace8906d2a59$var$_translation12.default
        },
        id: {
            translation: $b583ace8906d2a59$var$_translation6.default
        },
        ko: {
            translation: $b583ace8906d2a59$var$_translation9.default
        },
        hi: {
            translation: $b583ace8906d2a59$var$_translation5.default
        },
        pt: {
            translation: $b583ace8906d2a59$var$_translation10.default
        },
        de: {
            translation: $b583ace8906d2a59$var$_translation.default
        },
        fr: {
            translation: $b583ace8906d2a59$var$_translation4.default
        },
        pl: {
            translation: $b583ace8906d2a59$var$_translation1.default
        },
        "zh-TW": {
            translation: $b583ace8906d2a59$var$_translation11.default
        },
        it: {
            translation: $b583ace8906d2a59$var$_translation7.default
        },
        pirate: {
            translation: $b583ace8906d2a59$var$_translation0.default
        }
    },
    interpolation: {
        escapeValue: false
    }
});
// Set the language dropdown to match the detected/selected language
$b583ace8906d2a59$var$i18nInstance.then(()=>{
    const languageSelect = document.getElementById("language-select");
    if (languageSelect) languageSelect.value = $b583ace8906d2a59$var$_i18next.default.language;
});
var $b583ace8906d2a59$var$_default = module.exports.default = $b583ace8906d2a59$var$_i18next.default;

});
parcelRegister("cC7WN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $92ef32d64b751874$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "createInstance", function () { return $92ef32d64b751874$export$99152e8d49ca4e7d; });
$parcel$export(module.exports, "dir", function () { return $92ef32d64b751874$export$147ec2801e896265; });
$parcel$export(module.exports, "init", function () { return $92ef32d64b751874$export$2cd8252107eb640b; });
$parcel$export(module.exports, "loadResources", function () { return $92ef32d64b751874$export$d3d08d944062d7e; });
$parcel$export(module.exports, "reloadResources", function () { return $92ef32d64b751874$export$a5d9bf5d83fcab09; });
$parcel$export(module.exports, "use", function () { return $92ef32d64b751874$export$1f96ae73734a86cc; });
$parcel$export(module.exports, "changeLanguage", function () { return $92ef32d64b751874$export$61465194746e7fd2; });
$parcel$export(module.exports, "getFixedT", function () { return $92ef32d64b751874$export$f90d180fc7da3b3b; });
$parcel$export(module.exports, "t", function () { return $92ef32d64b751874$export$625550452a3fa3ec; });
$parcel$export(module.exports, "exists", function () { return $92ef32d64b751874$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "setDefaultNamespace", function () { return $92ef32d64b751874$export$2b4b218e406d2d00; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return $92ef32d64b751874$export$93d9ee97c1ad3f31; });
$parcel$export(module.exports, "loadNamespaces", function () { return $92ef32d64b751874$export$83be934b53fff43b; });
$parcel$export(module.exports, "loadLanguages", function () { return $92ef32d64b751874$export$8cd7e7a54fa865bc; });
const $92ef32d64b751874$var$isString = (obj)=>typeof obj === 'string';
const $92ef32d64b751874$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $92ef32d64b751874$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $92ef32d64b751874$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $92ef32d64b751874$var$lastOfPathSeparatorRegExp = /###/g;
const $92ef32d64b751874$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($92ef32d64b751874$var$lastOfPathSeparatorRegExp, '.') : key;
const $92ef32d64b751874$var$canNotTraverseDeeper = (object)=>!object || $92ef32d64b751874$var$isString(object);
const $92ef32d64b751874$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$92ef32d64b751874$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($92ef32d64b751874$var$canNotTraverseDeeper(object)) return {};
        const key = $92ef32d64b751874$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($92ef32d64b751874$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $92ef32d64b751874$var$cleanKey(stack[stackIndex])
    };
};
const $92ef32d64b751874$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $92ef32d64b751874$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $92ef32d64b751874$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $92ef32d64b751874$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $92ef32d64b751874$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $92ef32d64b751874$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $92ef32d64b751874$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $92ef32d64b751874$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $92ef32d64b751874$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $92ef32d64b751874$var$getPath(data, key);
    if (value !== undefined) return value;
    return $92ef32d64b751874$var$getPath(defaultData, key);
};
const $92ef32d64b751874$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($92ef32d64b751874$var$isString(target[prop]) || target[prop] instanceof String || $92ef32d64b751874$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $92ef32d64b751874$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $92ef32d64b751874$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $92ef32d64b751874$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $92ef32d64b751874$var$escape = (data)=>{
    if ($92ef32d64b751874$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$92ef32d64b751874$var$_entityMap[s]);
    return data;
};
class $92ef32d64b751874$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $92ef32d64b751874$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $92ef32d64b751874$var$looksLikeObjectPathRegExpCache = new $92ef32d64b751874$var$RegExpCache(20);
const $92ef32d64b751874$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $92ef32d64b751874$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $92ef32d64b751874$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $92ef32d64b751874$var$deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $92ef32d64b751874$var$getCleanedCode = (code)=>code?.replace('_', '-');
const $92ef32d64b751874$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $92ef32d64b751874$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $92ef32d64b751874$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($92ef32d64b751874$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $92ef32d64b751874$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $92ef32d64b751874$var$Logger(this.logger, options);
    }
}
var $92ef32d64b751874$var$baseLogger = new $92ef32d64b751874$var$Logger();
class $92ef32d64b751874$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $92ef32d64b751874$var$ResourceStore extends $92ef32d64b751874$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($92ef32d64b751874$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $92ef32d64b751874$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$92ef32d64b751874$var$isString(key)) return result;
        return $92ef32d64b751874$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $92ef32d64b751874$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if ($92ef32d64b751874$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $92ef32d64b751874$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $92ef32d64b751874$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $92ef32d64b751874$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $92ef32d64b751874$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $92ef32d64b751874$var$checkedLoadedFor = {};
const $92ef32d64b751874$var$shouldHandleAsObject = (res)=>!$92ef32d64b751874$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $92ef32d64b751874$var$Translator extends $92ef32d64b751874$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $92ef32d64b751874$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $92ef32d64b751874$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key == null) return false;
        const resolved = this.resolve(key, options);
        return resolved?.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$92ef32d64b751874$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $92ef32d64b751874$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $92ef32d64b751874$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') options = {
            ...options
        };
        if (!options) options = {};
        if (keys == null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = options.count !== undefined && !$92ef32d64b751874$var$isString(options.count);
        const hasDefaultValue = $92ef32d64b751874$var$Translator.hasDefaultValue(options);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0;
        const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $92ef32d64b751874$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($92ef32d64b751874$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...options,
                        defaultValue: $92ef32d64b751874$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $92ef32d64b751874$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = $92ef32d64b751874$var$isString(res) && (options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && !$92ef32d64b751874$var$isString(options.replace) ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey?.[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = $92ef32d64b751874$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && options.applyPostProcessor !== false) res = $92ef32d64b751874$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($92ef32d64b751874$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && !$92ef32d64b751874$var$isString(options.count);
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0;
            const needsContextHandling = options.context !== undefined && ($92ef32d64b751874$var$isString(options.context) || typeof options.context === 'number') && options.context !== '';
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$92ef32d64b751874$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $92ef32d64b751874$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$92ef32d64b751874$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $92ef32d64b751874$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $92ef32d64b751874$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $92ef32d64b751874$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $92ef32d64b751874$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($92ef32d64b751874$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($92ef32d64b751874$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($92ef32d64b751874$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($92ef32d64b751874$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $92ef32d64b751874$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $92ef32d64b751874$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $92ef32d64b751874$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $92ef32d64b751874$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const cleanedCode = $92ef32d64b751874$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (!Intl) {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $92ef32d64b751874$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $92ef32d64b751874$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$92ef32d64b751874$var$suffixesOrder[pluralCategory1] - $92ef32d64b751874$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $92ef32d64b751874$var$deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $92ef32d64b751874$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $92ef32d64b751874$var$isString(key)) {
        path = $92ef32d64b751874$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $92ef32d64b751874$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $92ef32d64b751874$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $92ef32d64b751874$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $92ef32d64b751874$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $92ef32d64b751874$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $92ef32d64b751874$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $92ef32d64b751874$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $92ef32d64b751874$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $92ef32d64b751874$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $92ef32d64b751874$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $92ef32d64b751874$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $92ef32d64b751874$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($92ef32d64b751874$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$92ef32d64b751874$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $92ef32d64b751874$var$regexSafe(this.escape(val)) : $92ef32d64b751874$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $92ef32d64b751874$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$92ef32d64b751874$var$isString(value) && !this.useRawValueToEscape) value = $92ef32d64b751874$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$92ef32d64b751874$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$92ef32d64b751874$var$isString(value)) return value;
            if (!$92ef32d64b751874$var$isString(value)) value = $92ef32d64b751874$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $92ef32d64b751874$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $92ef32d64b751874$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (val, lng, options)=>{
        let optForCache = options;
        if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) optForCache = {
            ...optForCache,
            [options.interpolationkey]: undefined
        };
        const key = lng + JSON.stringify(optForCache);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($92ef32d64b751874$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
class $92ef32d64b751874$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $92ef32d64b751874$var$baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: $92ef32d64b751874$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $92ef32d64b751874$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $92ef32d64b751874$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $92ef32d64b751874$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: $92ef32d64b751874$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        this.formatSeparator = options.interpolation.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $92ef32d64b751874$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $92ef32d64b751874$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $92ef32d64b751874$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $92ef32d64b751874$var$Connector extends $92ef32d64b751874$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $92ef32d64b751874$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $92ef32d64b751874$var$pushPath(q.loaded, [
                lng
            ], ns);
            $92ef32d64b751874$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($92ef32d64b751874$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($92ef32d64b751874$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $92ef32d64b751874$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($92ef32d64b751874$var$isString(args[1])) ret.defaultValue = args[1];
            if ($92ef32d64b751874$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    });
const $92ef32d64b751874$var$transformOptions = (options)=>{
    if ($92ef32d64b751874$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($92ef32d64b751874$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($92ef32d64b751874$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs?.indexOf?.('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $92ef32d64b751874$var$noop = ()=>{};
const $92ef32d64b751874$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $92ef32d64b751874$var$I18n extends $92ef32d64b751874$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $92ef32d64b751874$var$transformOptions(options);
        this.services = {};
        this.logger = $92ef32d64b751874$var$baseLogger;
        this.modules = {
            external: []
        };
        $92ef32d64b751874$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($92ef32d64b751874$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $92ef32d64b751874$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$92ef32d64b751874$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $92ef32d64b751874$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $92ef32d64b751874$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $92ef32d64b751874$var$Formatter;
            const lu = new $92ef32d64b751874$var$LanguageUtil(this.options);
            this.store = new $92ef32d64b751874$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $92ef32d64b751874$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $92ef32d64b751874$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $92ef32d64b751874$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $92ef32d64b751874$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $92ef32d64b751874$var$Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $92ef32d64b751874$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $92ef32d64b751874$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $92ef32d64b751874$var$noop;
        let usedCallback = callback;
        const usedLng = $92ef32d64b751874$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $92ef32d64b751874$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $92ef32d64b751874$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $92ef32d64b751874$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $92ef32d64b751874$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit('languageChanged', l);
                this.logger.log('languageChanged', l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = $92ef32d64b751874$var$isString(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            if (options.keyPrefix !== '') options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if ($92ef32d64b751874$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.translator?.translate(...args);
    }
    exists() {
        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $92ef32d64b751874$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($92ef32d64b751874$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $92ef32d64b751874$var$defer();
        if ($92ef32d64b751874$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $92ef32d64b751874$var$LanguageUtil($92ef32d64b751874$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $92ef32d64b751874$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $92ef32d64b751874$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $92ef32d64b751874$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                return Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, {});
            }, {});
            clone.store = new $92ef32d64b751874$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $92ef32d64b751874$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $92ef32d64b751874$export$2e2bcd8739ae039 = $92ef32d64b751874$var$I18n.createInstance();
$92ef32d64b751874$export$2e2bcd8739ae039.createInstance = $92ef32d64b751874$var$I18n.createInstance;
const $92ef32d64b751874$export$99152e8d49ca4e7d = $92ef32d64b751874$export$2e2bcd8739ae039.createInstance;
const $92ef32d64b751874$export$147ec2801e896265 = $92ef32d64b751874$export$2e2bcd8739ae039.dir;
const $92ef32d64b751874$export$2cd8252107eb640b = $92ef32d64b751874$export$2e2bcd8739ae039.init;
const $92ef32d64b751874$export$d3d08d944062d7e = $92ef32d64b751874$export$2e2bcd8739ae039.loadResources;
const $92ef32d64b751874$export$a5d9bf5d83fcab09 = $92ef32d64b751874$export$2e2bcd8739ae039.reloadResources;
const $92ef32d64b751874$export$1f96ae73734a86cc = $92ef32d64b751874$export$2e2bcd8739ae039.use;
const $92ef32d64b751874$export$61465194746e7fd2 = $92ef32d64b751874$export$2e2bcd8739ae039.changeLanguage;
const $92ef32d64b751874$export$f90d180fc7da3b3b = $92ef32d64b751874$export$2e2bcd8739ae039.getFixedT;
const $92ef32d64b751874$export$625550452a3fa3ec = $92ef32d64b751874$export$2e2bcd8739ae039.t;
const $92ef32d64b751874$export$f7e9f41ea797a17 = $92ef32d64b751874$export$2e2bcd8739ae039.exists;
const $92ef32d64b751874$export$2b4b218e406d2d00 = $92ef32d64b751874$export$2e2bcd8739ae039.setDefaultNamespace;
const $92ef32d64b751874$export$93d9ee97c1ad3f31 = $92ef32d64b751874$export$2e2bcd8739ae039.hasLoadedNamespace;
const $92ef32d64b751874$export$83be934b53fff43b = $92ef32d64b751874$export$2e2bcd8739ae039.loadNamespaces;
const $92ef32d64b751874$export$8cd7e7a54fa865bc = $92ef32d64b751874$export$2e2bcd8739ae039.loadLanguages;

});

parcelRegister("8izYb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $60abe804a68ca337$export$2e2bcd8739ae039; });
const { slice: $60abe804a68ca337$var$slice, forEach: $60abe804a68ca337$var$forEach } = [];
function $60abe804a68ca337$var$defaults(obj) {
    $60abe804a68ca337$var$forEach.call($60abe804a68ca337$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $60abe804a68ca337$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $60abe804a68ca337$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $60abe804a68ca337$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$60abe804a68ca337$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$60abe804a68ca337$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $60abe804a68ca337$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $60abe804a68ca337$var$serializeCookie(name, value, cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name, domain) {
        this.create(name, '', -1, domain);
    }
};
var $60abe804a68ca337$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $60abe804a68ca337$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $60abe804a68ca337$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $60abe804a68ca337$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $60abe804a68ca337$var$hash = {
    name: 'hash',
    // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
    lookup (_ref) {
        let { lookupHash: lookupHash, lookupFromHashIndex: lookupFromHashIndex } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            const { hash: hash } = window.location;
            if (hash && hash.length > 2) {
                const query = hash.substring(1);
                if (lookupHash) {
                    const params = query.split('&');
                    for(let i = 0; i < params.length; i++){
                        const pos = params[i].indexOf('=');
                        if (pos > 0) {
                            const key = params[i].substring(0, pos);
                            if (key === lookupHash) found = params[i].substring(pos + 1);
                        }
                    }
                }
                if (found) return found;
                if (!found && lookupFromHashIndex > -1) {
                    const language = hash.match(/\/([a-zA-Z-]*)/g);
                    if (!Array.isArray(language)) return undefined;
                    const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
                    return language[index]?.replace('/', '');
                }
            }
        }
        return found;
    }
};
let $60abe804a68ca337$var$hasLocalStorageSupport = null;
const $60abe804a68ca337$var$localStorageAvailable = ()=>{
    if ($60abe804a68ca337$var$hasLocalStorageSupport !== null) return $60abe804a68ca337$var$hasLocalStorageSupport;
    try {
        $60abe804a68ca337$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$60abe804a68ca337$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $60abe804a68ca337$var$hasLocalStorageSupport = false;
    }
    return $60abe804a68ca337$var$hasLocalStorageSupport;
};
var $60abe804a68ca337$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $60abe804a68ca337$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $60abe804a68ca337$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $60abe804a68ca337$var$hasSessionStorageSupport = null;
const $60abe804a68ca337$var$sessionStorageAvailable = ()=>{
    if ($60abe804a68ca337$var$hasSessionStorageSupport !== null) return $60abe804a68ca337$var$hasSessionStorageSupport;
    try {
        $60abe804a68ca337$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$60abe804a68ca337$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $60abe804a68ca337$var$hasSessionStorageSupport = false;
    }
    return $60abe804a68ca337$var$hasSessionStorageSupport;
};
var $60abe804a68ca337$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $60abe804a68ca337$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $60abe804a68ca337$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $60abe804a68ca337$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $60abe804a68ca337$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $60abe804a68ca337$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $60abe804a68ca337$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $60abe804a68ca337$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $60abe804a68ca337$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $60abe804a68ca337$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$60abe804a68ca337$var$canCookies) $60abe804a68ca337$var$order.splice(1, 1);
const $60abe804a68ca337$var$getDefaults = ()=>({
        order: $60abe804a68ca337$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $60abe804a68ca337$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $60abe804a68ca337$var$defaults(options, this.options || {}, $60abe804a68ca337$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($60abe804a68ca337$var$cookie$1);
        this.addDetector($60abe804a68ca337$var$querystring);
        this.addDetector($60abe804a68ca337$var$localStorage);
        this.addDetector($60abe804a68ca337$var$sessionStorage);
        this.addDetector($60abe804a68ca337$var$navigator$1);
        this.addDetector($60abe804a68ca337$var$htmlTag);
        this.addDetector($60abe804a68ca337$var$path);
        this.addDetector($60abe804a68ca337$var$subdomain);
        this.addDetector($60abe804a68ca337$var$hash);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$60abe804a68ca337$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$60abe804a68ca337$export$2e2bcd8739ae039.type = 'languageDetector';

});

parcelRegister("lXa4i", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"title":"nakazawa \uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","description":"\uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","buttons":{"fullscreen":"Vollbild","achievements":"Erfolge","reset":"Zur\xfccksetzen","language":"Sprache"},"achievements":{"title":"Erfolge","noAchievements":"Noch keine Erfolge erzielt. Klicke weiter!","unlocked":"Erfolg freigeschaltet: {{message}}","progress":"{{progress}}%","beginner":"\uD83C\uDFAF Anf\xe4nger-H\xe4schen","carrotSnatcher":"\uD83E\uDD55 Gem\xfcsedieb","bunnyBerserker":"\uD83D\uDE21 Rasender Hase","hopPunk":"\uD83C\uDFB8 Anarchisten-Hase","bunnyNinja":"\uD83E\uDD77 Leise aber T\xf6dlich","expert":"\uD83C\uDF1F Experten-H\xfcpfer","master":"\uD83D\uDC51 Karotten-K\xf6nig","carrotpocalypse":"\uD83E\uDD55 Garten-Zerst\xf6rer","bunnyOverlord":"\uD83D\uDE08 Oberster Herrscher des Baus","chaosHare":"\uD83C\uDF2A\uFE0F Agent des Chaos","carrotCultist":"\u26EA Hohepriester des Karotten-Kults","bunnyberryPie":"\uD83E\uDD67 Halluzinogener Kuchenmeister","rabbitHole":"\uD83D\uDD73\uFE0F Quantentunnel-Gr\xe4ber","moonRabbit":"\uD83C\uDF19 Mondhase","bunnyDoom":"\uD83D\uDC80 Vorbote der Hasen-Apokalypse","carrotNuke":"\u2622\uFE0F Tr\xe4ger der Nuklear-Karotte","bunnyMatrix":"\uD83E\uDD16 St\xf6rung in der Hasen-Matrix","cosmicHare":"\uD83C\uDF0C Der Kosmische Hase Erwacht","warrenSingularity":"\uD83D\uDD73\uFE0F Bau-Singularit\xe4t Erreicht","eternalBunny":"\u267E\uFE0F Der Ewige Hase"},"messages":{"prophecy":"Die uralte Klick-Prophezeiung beginnt sich zu entfalten...","cosmic":"Die kosmischen Klicker w\xe4ren stolz auf deinen Fortschritt!","astral":"Das Klicken hallt durch die Astralebene...","speaking":"Warte... hast du das geh\xf6rt? Die Klicks sprechen zu mir...","ancient":"Dein Klicken resoniert mit uralter Macht!","sages":"Die Klick-Weisen fl\xfcstern von deinem Potential...","demons":"SEHT! Die Klick-D\xe4monen erwachen aus ihrem Schlummer!","veil":"Deine Klicks durchdringen den Schleier der Realit\xe4t!","spirits":"Die Klick-Geister tanzen zu deinem Rhythmus...","council":"Der Gro\xdfe Klick-Rat hat deine Hingabe bemerkt","primordial":"Dein Klicken erweckt urzeitliche Kr\xe4fte!","void":"Die klickende Leere starrt zur\xfcck...","runes":"Uralte Klick-Runen leuchten mit deiner Kraft!","beast":"DREI DREI DREI - DIE ZAHL DER KLICK-BESTIE","prophets":"Die Klick-Propheten besingen dein Kommen!","dimensions":"Deine Klicks hallen durch die Dimensionen...","portal":"Deine Klicks haben ein Portal zur Klick-Dimension ge\xf6ffnet!","sacrifice":"Die uralten Klick-G\xf6tter fordern MEHR OPFER","jackpot":"JACKPOT! Das Klick-Casino begr\xfc\xdft seinen neuesten Champion!","unmatched":"Deine Klick-Kraft ist un\xfcbertroffen!","reality":"Die Realit\xe4t selbst beugt sich deinem klickenden Willen!","elite":"DU BIST ZUM ELITE-KLICK-MEISTER GEWORDEN","power":"Dein Klick-Power-Level ist \xfcber 1500!","devils":"Die Klick-Teufel verneigen sich vor deiner Macht","lucky":"Gl\xfcckliche Klicks flie\xdfen durch deine Adern","dynasty":"Die Klick-Dynastie erkennt deine Vorherrschaft an","twoThousand":"Zweitausend Klicks purer Kraft!","quartet":"Die Prophezeiung des Klick-Quartetts ist erf\xfcllt","transcend":"Dein Klicken \xfcbersteigt sterbliches Verst\xe4ndnis","constellation":"Die Klick-Konstellation richtet sich zu deinen Ehren aus","destiny":"DREITAUSEND KLICKS DES SCHICKSALS","triforce":"Die Dreifache Klick-Triforce erwacht!","fortune":"Das Gl\xfcck beg\xfcnstigt den beharrlichen Klicker","newDimensions":"Deine Klick-Kraft erreicht neue Dimensionen","quartet2":"Das Vierfache Klick-Quartett harmoniert","threshold":"An der Schwelle zur Klick-G\xf6ttlichkeit","ultimate":"F\xdcNFTAUSEND KLICKS ULTIMATIVER MACHT!","force":"Die F\xfcnf-Finger-Klick-Kraft steht unter deinem Kommando","underworld":"Die Klick-Unterwelt kr\xf6nt dich zu ihrem Herrscher","maxJackpot":"MAXIMALER JACKPOT-KLICK ERREICHT","infinite":"UNENDLICHE KLICK-KRAFT!","godhood":"DU BIST ZUR KLICK-GOTTHEIT AUFGESTIEGEN","burrow":"Du hast tiefer gegraben als jeder Hase zuvor...","warren":"Der Gro\xdfe Bau erkennt deine Anwesenheit an...","thump":"Die Erde bebt bei jedem Stampfer deiner Pfote!","darkWarren":"Der Dunkle Bau \xf6ffnet seine Tore f\xfcr dich...","ears":"Deine Ohren werden l\xe4nger... du kannst jetzt alles h\xf6ren...","carrotThrone":"Der Karotten-Thron materialisiert sich vor dir...","onesAlignment":"Alle Einsen ordnen sich - die Bau-Frequenz resoniert!","moonSummon":"Der Mondhase h\xf6rt deinen Ruf durch die Leere...","edgeOfForever":"Du stehst am Rand der Ewigkeit... Ohren zucken...","beyondTheVeil":"Jenseits des Schleiers werden alle Baue eins...","sequence":"1-2-3-4-5... Die Heilige H\xfcpf-Sequenz ist vollendet!","hyperElite":"HYPER-ELITE-HASEN-STATUS FREIGESCHALTET \uD83D\uDC07\uD83D\uDC07\uD83D\uDC07","eventHorizon":"Jenseits des Ereignishorizonts des Kosmischen Kaninchenbaus...","matrixAwakens":"Die Bau-Matrix glitcht... du siehst die Karotten hinter der Realit\xe4t","luckyForever":"Jede Pfote, jeder H\xfcpfer, jedes Zucken... f\xfcr immer gesegnet","twentyK":"ZWANZIGTAUSEND. Du bist kein Hase mehr. Du bist DER Hase.","singularity":"Die Hasen-Singularit\xe4t. Alle Hasen sind du. Du bist alle Hasen.","tripleAscension":"Der Dreifache Aufstieg des Kosmischen Hasen!","ultimateAnswer":"42.000 - Die Ultimative Antwort waren die ganze Zeit Karotten","eternity":"\u267E\uFE0F DER EWIGE BAU HAT KEIN ENDE. DU AUCH NICHT. \u267E\uFE0F"},"powerups":{"bonusPoints":"\uD83E\uDD55 +{{count}} Bonuspunkte!","clickStreak":"\uD83D\uDD25 {{count}} Klick-Serie!","fire":"\uD83D\uDD25 Feuerkraft Aktiviert!"},"table":{"achievement":"Erfolg","progress":"Fortschritt"},"reset":{"confirm":"Bist du sicher, dass du den gesamten Fortschritt zur\xfccksetzen m\xf6chtest? Dies kann nicht r\xfcckg\xe4ngig gemacht werden."}}');

});

parcelRegister("5qXa8", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"title":"nakazawa \uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","description":"\uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","buttons":{"fullscreen":"Fullscreen","achievements":"Achievements","reset":"Reset"},"messages":{"prophecy":"A bunny twitches its nose... something ancient stirs...","cosmic":"The answer to life, the universe, and everything? Bunnies. Obviously.","astral":"Your clicking echoes through the astral warren...","speaking":"Wait... did you hear that? The thumping... it\'s speaking to you...","ancient":"The carrots resonate with ancient power!","sages":"The Elder Rabbits whisper of your potential...","demons":"BEHOLD! The Carrot Demons arise from the deepest burrow!","veil":"Your clicks pierce the veil between warrens!","spirits":"The Bunny Spirits dance to your rhythm...","council":"The Grand Warren Council has noticed your dedication","primordial":"Your thumping awakens primordial bunnies!","void":"The rabbit hole gazes back at you...","runes":"Ancient carrot runes glow beneath the earth!","beast":"THREE THREE THREE - THE NUMBER OF THE BUNNY BEAST","prophets":"The Warren Prophets sing of your coming!","dimensions":"Your thumps echo through every burrow in existence...","portal":"Your clicks have opened a portal to the Carrot Dimension!","burrow":"You\'ve dug deeper than any rabbit before...","warren":"The Great Warren recognizes your presence...","sacrifice":"The ancient Bunny Gods demand MORE CARROTS","thump":"The earth trembles with every thump of your foot!","darkWarren":"The Dark Warren opens its gates for you...","ears":"Your ears grow longer... you can hear everything now...","jackpot":"JACKPOT! The Carrot Casino crowns its champion! \uD83E\uDD55\uD83C\uDFB0","unmatched":"\u5154\u5B50\u7684\u529B\u91CF\u65E0\u4EBA\u80FD\u53CA! (Your bunny power is unmatched!)","carrotThrone":"The Carrot Throne materializes before you...","reality":"Reality bends around your twitching whiskers!","onesAlignment":"All ones align - the Warren Frequency resonates!","elite":"YOU HAVE BECOME THE ELITE BUNNY MASTER \uD83D\uDC07","power":"Your bunny power level is OVER FIFTEEN HUNDRED!","devils":"The Carrot Devils bow before your floofy might","lucky":"Lucky rabbit feet? You ARE the lucky rabbit","dynasty":"The Bunny Dynasty recognizes your supremacy \uD83D\uDC30","twoThousand":"Two thousand thumps of pure lagomorph power!","quartet":"The prophecy of the Four Rabbits is fulfilled","transcend":"Your hopping transcends mortal understanding","constellation":"The Bunny Constellation aligns in your honor \uD83C\uDF19","destiny":"THREE THOUSAND THUMPS OF DESTINY","triforce":"The Triple Carrot Triforce awakens!","fortune":"Fortune favors the persistent bunny","newDimensions":"Your bunny energy reaches dimensions unknown to mortals","quartet2":"The Quadruple Warren Quartet harmonizes","threshold":"Standing at the threshold of carrot divinity...","ultimate":"FIVE THOUSAND THUMPS OF ULTIMATE BUNNY POWER! \uD83D\uDC30\u26A1","force":"The Five Pawed Bunny Force is yours to command","underworld":"The Carrot Underworld crowns you their Fluffy Overlord","moonSummon":"The Moon Rabbit hears your call across the void...","maxJackpot":"MAXIMUM CARROT JACKPOT! THE WARREN OVERFLOWS! \uD83E\uDD55\uD83E\uDD55\uD83E\uDD55","infinite":"\u65E0\u9650\u5154\u5B50\u529B\u91CF! (INFINITE BUNNY POWER!)","edgeOfForever":"You stand at the edge of forever... ears twitching...","godhood":"YOU HAVE ASCENDED TO BUNNY GODHOOD \uD83D\uDC30\uD83D\uDC51","beyondTheVeil":"Beyond the veil, all warrens become one...","sequence":"1-2-3-4-5... The Sacred Hop Sequence is complete!","hyperElite":"HYPER ELITE BUNNY STATUS UNLOCKED \uD83D\uDC07\uD83D\uDC07\uD83D\uDC07","eventHorizon":"Past the event horizon of the Cosmic Rabbit Hole...","matrixAwakens":"The Warren Matrix glitches... you see the carrots behind reality","luckyForever":"Every paw, every hop, every twitch... blessed forever","twentyK":"TWENTY THOUSAND. You are no longer a bunny. You are THE bunny.","singularity":"The Bunny Singularity. All rabbits are you. You are all rabbits.","tripleAscension":"The Triple Ascension of the Cosmic Hare!","ultimateAnswer":"42,000 - The Ultimate Answer was carrots all along","eternity":"\u267E\uFE0F THE ETERNAL WARREN HAS NO END. NEITHER DO YOU. \u267E\uFE0F"},"achievements":{"title":"Achievements","noAchievements":"No achievements earned yet. Keep clicking!","unlocked":"Achievement Unlocked: {{message}}","progress":"{{progress}}%","beginner":"\uD83C\uDFAF Beginner Bunny","carrotSnatcher":"\uD83E\uDD55 Vegetable Bandit","bunnyBerserker":"\uD83D\uDE21 Rabid Rampage","hopPunk":"\uD83C\uDFB8 Anarchist Cottontail","bunnyNinja":"\uD83E\uDD77 Silent but Deadly Floof","expert":"\uD83C\uDF1F Expert Hopper","master":"\uD83D\uDC51 Carrot King","carrotpocalypse":"\uD83E\uDD55 Destroyer of Vegetable Gardens","bunnyOverlord":"\uD83D\uDE08 Supreme Leader of the Warren","chaosHare":"\uD83C\uDF2A\uFE0F Agent of Bunny Chaos","carrotCultist":"\u26EA High Priest of the Carrot Cult","bunnyberryPie":"\uD83E\uDD67 Hallucinogenic Pie Master","rabbitHole":"\uD83D\uDD73\uFE0F Quantum Tunnel Digger","moonRabbit":"\uD83C\uDF19 Lunar Jade Pounder","bunnyDoom":"\uD83D\uDC80 Harbinger of the Bunpocalypse","carrotNuke":"\u2622\uFE0F Thermonuclear Carrot Wielder","bunnyMatrix":"\uD83E\uDD16 Glitch in the Warren Matrix","cosmicHare":"\uD83C\uDF0C The Cosmic Hare Awakens","warrenSingularity":"\uD83D\uDD73\uFE0F Warren Singularity Achieved","eternalBunny":"\u267E\uFE0F The Eternal Bunny"},"powerups":{"bonusPoints":"\uD83E\uDD55 +{{count}} Bonus Carrots!","clickStreak":"\uD83D\uDD25 {{count}} Thump Streak!","fire":"\uD83D\uDD25 Fire Power Activated!"},"table":{"achievement":"Achievement","progress":"Progress"},"reset":{"confirm":"Are you sure you want to reset all progress? This cannot be undone."}}');

});

parcelRegister("cPlR7", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"title":"nakazawa \uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","description":"\uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","buttons":{"fullscreen":"Pantalla completa","achievements":"Logros","reset":"Reiniciar","language":"Idioma"},"achievements":{"title":"Logros","noAchievements":"A\xfan no hay logros conseguidos. \xa1Sigue haciendo clic!","unlocked":"\xa1Logro desbloqueado: {{message}}","progress":"{{progress}}%","beginner":"\uD83C\uDFAF Conejito Principiante","carrotSnatcher":"\uD83E\uDD55 Ladr\xf3n de Vegetales","bunnyBerserker":"\uD83D\uDE21 Furia Desatada","hopPunk":"\uD83C\uDFB8 Conejito Anarquista","bunnyNinja":"\uD83E\uDD77 Silencioso pero Mortal","expert":"\uD83C\uDF1F Saltar\xedn Experto","master":"\uD83D\uDC51 Rey Zanahoria","carrotpocalypse":"\uD83E\uDD55 Destructor de Huertos","bunnyOverlord":"\uD83D\uDE08 L\xedder Supremo de la Madriguera","chaosHare":"\uD83C\uDF2A\uFE0F Agente del Caos","carrotCultist":"\u26EA Sumo Sacerdote del Culto a la Zanahoria","bunnyberryPie":"\uD83E\uDD67 Maestro del Pastel Alucin\xf3geno","rabbitHole":"\uD83D\uDD73\uFE0F Excavador de T\xfaneles Cu\xe1nticos","moonRabbit":"\uD83C\uDF19 Conejo Lunar","bunnyDoom":"\uD83D\uDC80 Heraldo del Conejocalipsis","carrotNuke":"\u2622\uFE0F Portador de la Zanahoria Nuclear","bunnyMatrix":"\uD83E\uDD16 Fallo en la Matriz Conejil","cosmicHare":"\uD83C\uDF0C La Liebre C\xf3smica Despierta","warrenSingularity":"\uD83D\uDD73\uFE0F Singularidad de la Madriguera Alcanzada","eternalBunny":"\u267E\uFE0F El Conejo Eterno"},"messages":{"prophecy":"\xa1La antigua profec\xeda de clics comienza a revelarse...","cosmic":"\xa1Los clickers c\xf3smicos estar\xedan orgullosos de tu progreso!","astral":"Los clics resuenan a trav\xe9s del plano astral...","speaking":"Espera... \xbfescuchaste eso? \xa1Los clics me est\xe1n hablando!","ancient":"\xa1Tus clics resuenan con poder ancestral!","sages":"Los Sabios del Clic susurran sobre tu potencial...","demons":"\xa1CONTEMPLA! \xa1Los Demonios del Clic despiertan de su letargo!","veil":"\xa1Tus clics atraviesan el velo de la realidad!","spirits":"Los Esp\xedritus del Clic bailan a tu ritmo...","council":"El Gran Consejo del Clic ha notado tu dedicaci\xf3n","primordial":"\xa1Tus clics despiertan fuerzas primordiales!","void":"El vac\xedo de los clics te devuelve la mirada...","runes":"\xa1Las antiguas runas del clic brillan con tu poder!","beast":"TRES TRES TRES - EL N\xdaMERO DE LA BESTIA DEL CLIC","prophets":"\xa1Los Profetas del Clic cantan sobre tu llegada!","dimensions":"Tus clics resuenan a trav\xe9s de las dimensiones...","portal":"\xa1Tus clics han abierto un portal a la Dimensi\xf3n del Clic!","sacrifice":"Los antiguos Dioses del Clic exigen M\xc1S SACRIFICIO","jackpot":"\xa1PREMIO GORDO! \xa1El Casino del Clic da la bienvenida a su nuevo campe\xf3n!","unmatched":"\xa1Tu poder de clics no tiene igual!","reality":"\xa1La realidad misma se dobla ante tu voluntad de clics!","elite":"TE HAS CONVERTIDO EN EL MAESTRO \xc9LITE DEL CLIC","power":"\xa1Tu nivel de poder de clics supera los 1500!","devils":"Los Demonios del Clic se inclinan ante tu poder","lucky":"Los clics afortunados fluyen por tus venas","dynasty":"La Dinast\xeda del Clic reconoce tu supremac\xeda","twoThousand":"\xa1Dos mil clics de puro poder!","quartet":"\xa1La profec\xeda del Cuarteto del Clic se ha cumplido!","transcend":"Tus clics trascienden el entendimiento mortal","constellation":"La Constelaci\xf3n del Clic se alinea en tu honor","destiny":"TRES MIL CLICS DEL DESTINO","triforce":"\xa1La Triple Trifuerza del Clic despierta!","fortune":"La fortuna favorece al clicker persistente","newDimensions":"Tu poder de clics alcanza nuevas dimensiones","quartet2":"El Cu\xe1druple Cuarteto del Clic armoniza","threshold":"De pie en el umbral de la divinidad del clic","ultimate":"\xa1CINCO MIL CLICS DE PODER SUPREMO!","force":"La Fuerza de los Cinco Dedos del Clic est\xe1 bajo tu mando","underworld":"El Inframundo del Clic te corona como su gobernante","maxJackpot":"\xa1PREMIO GORDO M\xc1XIMO DE CLICS CONSEGUIDO!","infinite":"\xa1PODER DE CLICS INFINITO!","godhood":"HAS ASCENDIDO A LA DIVINIDAD DEL CLIC","burrow":"Has cavado m\xe1s profundo que cualquier conejo antes...","warren":"La Gran Madriguera reconoce tu presencia...","thump":"\xa1La tierra tiembla con cada golpe de tu pata!","darkWarren":"La Madriguera Oscura abre sus puertas para ti...","ears":"Tus orejas crecen m\xe1s largas... ahora puedes o\xedr todo...","carrotThrone":"El Trono de la Zanahoria se materializa ante ti...","onesAlignment":"\xa1Todos los unos se alinean - la Frecuencia de la Madriguera resuena!","moonSummon":"El Conejo Lunar oye tu llamada a trav\xe9s del vac\xedo...","edgeOfForever":"Est\xe1s al borde de la eternidad... orejas temblando...","beyondTheVeil":"M\xe1s all\xe1 del velo, todas las madrigueras se unen...","sequence":"1-2-3-4-5... \xa1La Secuencia Sagrada del Salto est\xe1 completa!","hyperElite":"ESTADO HIPER \xc9LITE DESBLOQUEADO \uD83D\uDC07\uD83D\uDC07\uD83D\uDC07","eventHorizon":"M\xe1s all\xe1 del horizonte de eventos de la Madriguera C\xf3smica...","matrixAwakens":"La Matriz de la Madriguera falla... ves las zanahorias detr\xe1s de la realidad","luckyForever":"Cada pata, cada salto, cada temblor... bendecido para siempre","twentyK":"VEINTE MIL. Ya no eres un conejo. Eres EL conejo.","singularity":"La Singularidad Conejil. Todos los conejos eres t\xfa. T\xfa eres todos los conejos.","tripleAscension":"\xa1La Triple Ascensi\xf3n de la Liebre C\xf3smica!","ultimateAnswer":"42.000 - La Respuesta Definitiva siempre fueron las zanahorias","eternity":"\u267E\uFE0F LA MADRIGUERA ETERNA NO TIENE FIN. T\xda TAMPOCO. \u267E\uFE0F"},"powerups":{"bonusPoints":"\uD83E\uDD55 \xa1+{{count}} Puntos Extra!","clickStreak":"\uD83D\uDD25 \xa1{{count}} Clics Seguidos!","fire":"\uD83D\uDD25 \xa1Poder de Fuego Activado!"},"table":{"achievement":"Logro","progress":"Progreso"},"reset":{"confirm":"\xbfEst\xe1s seguro de que quieres reiniciar todo el progreso? Esta acci\xf3n no se puede deshacer."}}');

});

parcelRegister("TwGGT", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"title":"nakazawa \uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","description":"\uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","buttons":{"fullscreen":"Plein \xe9cran","achievements":"Succ\xe8s","reset":"R\xe9initialiser","language":"Langue"},"achievements":{"title":"Succ\xe8s","noAchievements":"Aucun succ\xe8s d\xe9bloqu\xe9. Continuez \xe0 cliquer !","unlocked":"Succ\xe8s d\xe9bloqu\xe9 : {{message}}","progress":"{{progress}}%","beginner":"\uD83C\uDFAF Lapin D\xe9butant","carrotSnatcher":"\uD83E\uDD55 Voleur de L\xe9gumes","bunnyBerserker":"\uD83D\uDE21 Lapin Enrag\xe9","hopPunk":"\uD83C\uDFB8 Lapin Anarchiste","bunnyNinja":"\uD83E\uDD77 Silencieux mais Mortel","expert":"\uD83C\uDF1F Sauteur Expert","master":"\uD83D\uDC51 Roi des Carottes","carrotpocalypse":"\uD83E\uDD55 Destructeur de Potagers","bunnyOverlord":"\uD83D\uDE08 Seigneur Supr\xeame du Terrier","chaosHare":"\uD83C\uDF2A\uFE0F Agent du Chaos","carrotCultist":"\u26EA Grand Pr\xeatre du Culte de la Carotte","bunnyberryPie":"\uD83E\uDD67 Ma\xeetre de la Tarte Hallucinog\xe8ne","rabbitHole":"\uD83D\uDD73\uFE0F Creuseur de Tunnels Quantiques","moonRabbit":"\uD83C\uDF19 Lapin Lunaire","bunnyDoom":"\uD83D\uDC80 H\xe9raut du Lapocalypse","carrotNuke":"\u2622\uFE0F Porteur de la Carotte Nucl\xe9aire","bunnyMatrix":"\uD83E\uDD16 Bug dans la Matrice Lapine","cosmicHare":"\uD83C\uDF0C Le Li\xe8vre Cosmique S\'\xe9veille","warrenSingularity":"\uD83D\uDD73\uFE0F Singularit\xe9 du Terrier Atteinte","eternalBunny":"\u267E\uFE0F Le Lapin \xc9ternel"},"messages":{"prophecy":"L\'ancienne proph\xe9tie des clics commence \xe0 se d\xe9voiler...","cosmic":"Les cliqueurs cosmiques seraient fiers de vos progr\xe8s !","astral":"Les clics r\xe9sonnent \xe0 travers le plan astral...","speaking":"Attendez... vous avez entendu \xe7a ? Les clics me parlent...","ancient":"Vos clics r\xe9sonnent avec une puissance ancestrale !","sages":"Les Sages du Clic murmurent votre potentiel...","demons":"CONTEMPLEZ ! Les D\xe9mons du Clic s\'\xe9veillent de leur sommeil !","veil":"Vos clics percent le voile de la r\xe9alit\xe9 !","spirits":"Les Esprits du Clic dansent \xe0 votre rythme...","council":"Le Grand Conseil du Clic a remarqu\xe9 votre d\xe9vouement","primordial":"Vos clics r\xe9veillent des forces primordiales !","void":"Le vide des clics vous regarde en retour...","runes":"Les runes anciennes du clic brillent de votre puissance !","beast":"TROIS TROIS TROIS - LE NOMBRE DE LA B\xcaTE DU CLIC","prophets":"Les Proph\xe8tes du Clic chantent votre venue !","dimensions":"Vos clics r\xe9sonnent \xe0 travers les dimensions...","portal":"Vos clics ont ouvert un portail vers la Dimension du Clic !","sacrifice":"Les anciens Dieux du Clic exigent PLUS DE SACRIFICES","jackpot":"JACKPOT ! Le Casino du Clic accueille son nouveau champion !","unmatched":"\u4F60\u7684\u70B9\u51FB\u529B\u91CF\u65E0\u4EBA\u80FD\u53CA! (Votre puissance de clic est in\xe9gal\xe9e !)","reality":"La r\xe9alit\xe9 elle-m\xeame se plie \xe0 votre volont\xe9 de clic !","elite":"VOUS \xcaTES DEVENU LE MA\xceTRE DU CLIC D\'\xc9LITE","power":"Votre niveau de puissance de clic d\xe9passe 1500 !","devils":"Les D\xe9mons du Clic s\'inclinent devant votre puissance","lucky":"Les clics chanceux coulent dans vos veines","dynasty":"La Dynastie du Clic reconna\xeet votre supr\xe9matie","twoThousand":"Deux mille clics de pure puissance !","quartet":"La proph\xe9tie du Quatuor du Clic est accomplie","transcend":"Vos clics transcendent la compr\xe9hension mortelle","constellation":"La Constellation du Clic s\'aligne en votre honneur","destiny":"TROIS MILLE CLICS DU DESTIN","triforce":"La Triple Triforce du Clic s\'\xe9veille !","fortune":"La fortune favorise le cliqueur persistant","newDimensions":"Votre puissance de clic atteint de nouvelles dimensions","quartet2":"Le Quatuor Quadruple du Clic s\'harmonise","threshold":"Debout au seuil de la divinit\xe9 du clic","ultimate":"CINQ MILLE CLICS DE PUISSANCE ULTIME !","force":"La Force des Cinq Doigts du Clic est \xe0 vos ordres","underworld":"Les Enfers du Clic vous couronnent leur souverain","maxJackpot":"JACKPOT MAXIMUM DE CLIC ATTEINT","infinite":"\u65E0\u9650\u70B9\u51FB\u529B\u91CF! (PUISSANCE DE CLIC INFINIE !)","godhood":"VOUS AVEZ ATTEINT LA DIVINIT\xc9 DU CLIC","burrow":"Vous avez creus\xe9 plus profond qu\'aucun lapin avant vous...","warren":"Le Grand Terrier reconna\xeet votre pr\xe9sence...","thump":"La terre tremble \xe0 chaque coup de votre patte !","darkWarren":"Le Terrier Sombre ouvre ses portes pour vous...","ears":"Vos oreilles s\'allongent... vous pouvez tout entendre maintenant...","carrotThrone":"Le Tr\xf4ne de Carotte se mat\xe9rialise devant vous...","onesAlignment":"Tous les uns s\'alignent - la Fr\xe9quence du Terrier r\xe9sonne !","moonSummon":"Le Lapin Lunaire entend votre appel \xe0 travers le vide...","edgeOfForever":"Vous \xeates au bord de l\'\xe9ternit\xe9... oreilles fr\xe9missantes...","beyondTheVeil":"Au-del\xe0 du voile, tous les terriers ne font qu\'un...","sequence":"1-2-3-4-5... La S\xe9quence Sacr\xe9e du Bond est compl\xe8te !","hyperElite":"STATUT HYPER \xc9LITE D\xc9BLOQU\xc9 \uD83D\uDC07\uD83D\uDC07\uD83D\uDC07","eventHorizon":"Au-del\xe0 de l\'horizon des \xe9v\xe9nements du Terrier Cosmique...","matrixAwakens":"La Matrice du Terrier glitche... vous voyez les carottes derri\xe8re la r\xe9alit\xe9","luckyForever":"Chaque patte, chaque bond, chaque fr\xe9missement... b\xe9ni pour toujours","twentyK":"VINGT MILLE. Vous n\'\xeates plus un lapin. Vous \xeates LE lapin.","singularity":"La Singularit\xe9 Lapine. Tous les lapins sont vous. Vous \xeates tous les lapins.","tripleAscension":"La Triple Ascension du Li\xe8vre Cosmique !","ultimateAnswer":"42 000 - La R\xe9ponse Ultime, c\'\xe9tait les carottes depuis le d\xe9but","eternity":"\u267E\uFE0F LE TERRIER \xc9TERNEL N\'A PAS DE FIN. VOUS NON PLUS. \u267E\uFE0F"},"powerups":{"bonusPoints":"\uD83E\uDD55 +{{count}} Points Bonus !","clickStreak":"\uD83D\uDD25 {{count}} Clics d\'Affil\xe9e !","fire":"\uD83D\uDD25 Puissance de Feu Activ\xe9e !"},"table":{"achievement":"Succ\xe8s","progress":"Progr\xe8s"},"reset":{"confirm":"\xcates-vous s\xfbr de vouloir r\xe9initialiser toute la progression ? Cette action est irr\xe9versible."}}');

});

parcelRegister("jGnFL", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"title":"\u0928\u093E\u0915\u093E\u091C\u093C\u093E\u0935\u093E \uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","description":"\uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","buttons":{"fullscreen":"\u092A\u0942\u0930\u094D\u0923 \u0938\u094D\u0915\u094D\u0930\u0940\u0928","achievements":"\u0909\u092A\u0932\u092C\u094D\u0927\u093F\u092F\u093E\u0902","reset":"\u0930\u0940\u0938\u0947\u091F","language":"\u092D\u093E\u0937\u093E"},"achievements":{"title":"\u0909\u092A\u0932\u092C\u094D\u0927\u093F\u092F\u093E\u0902","noAchievements":"\u0905\u092D\u0940 \u0924\u0915 \u0915\u094B\u0908 \u0909\u092A\u0932\u092C\u094D\u0927\u093F \u0928\u0939\u0940\u0902 \u092E\u093F\u0932\u0940\u0964 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0924\u0947 \u0930\u0939\u0947\u0902!","unlocked":"\u0909\u092A\u0932\u092C\u094D\u0927\u093F \u0905\u0928\u0932\u0949\u0915: {{message}}","progress":"{{progress}}%","beginner":"\uD83C\uDFAF \u0928\u094C\u0938\u093F\u0916\u093F\u092F\u093E \u0916\u0930\u0917\u094B\u0936","carrotSnatcher":"\uD83E\uDD55 \u0938\u092C\u094D\u091C\u0940 \u091A\u094B\u0930","bunnyBerserker":"\uD83D\uDE21 \u0915\u094D\u0930\u094B\u0927\u093F\u0924 \u0916\u0930\u0917\u094B\u0936","hopPunk":"\uD83C\uDFB8 \u0935\u093F\u0926\u094D\u0930\u094B\u0939\u0940 \u0916\u0930\u0917\u094B\u0936","bunnyNinja":"\uD83E\uDD77 \u0936\u093E\u0902\u0924 \u092A\u0930 \u0918\u093E\u0924\u0915","expert":"\uD83C\uDF1F \u0935\u093F\u0936\u0947\u0937\u091C\u094D\u091E \u0915\u0942\u0926\u0928\u0947 \u0935\u093E\u0932\u093E","master":"\uD83D\uDC51 \u0917\u093E\u091C\u0930 \u0915\u093E \u0930\u093E\u091C\u093E","carrotpocalypse":"\uD83E\uDD55 \u092C\u0917\u0940\u091A\u0947 \u0915\u093E \u0935\u093F\u0928\u093E\u0936\u0915","bunnyOverlord":"\uD83D\uDE08 \u0916\u0930\u0917\u094B\u0936 \u092C\u093F\u0932 \u0915\u093E \u0938\u0930\u094D\u0935\u094B\u091A\u094D\u091A \u0936\u093E\u0938\u0915","chaosHare":"\uD83C\uDF2A\uFE0F \u0905\u0930\u093E\u091C\u0915\u0924\u093E \u0915\u093E \u0926\u0942\u0924","carrotCultist":"\u26EA \u0917\u093E\u091C\u0930 \u092A\u0902\u0925 \u0915\u093E \u092E\u0939\u093E\u092A\u0941\u091C\u093E\u0930\u0940","bunnyberryPie":"\uD83E\uDD67 \u092D\u094D\u0930\u093E\u092E\u0915 \u092A\u093E\u0908 \u092E\u093E\u0938\u094D\u091F\u0930","rabbitHole":"\uD83D\uDD73\uFE0F \u0915\u094D\u0935\u093E\u0902\u091F\u092E \u0938\u0941\u0930\u0902\u0917 \u0916\u094B\u0926\u0928\u0947 \u0935\u093E\u0932\u093E","moonRabbit":"\uD83C\uDF19 \u091A\u0902\u0926\u094D\u0930 \u0916\u0930\u0917\u094B\u0936","bunnyDoom":"\uD83D\uDC80 \u0916\u0930\u0917\u094B\u0936 \u092A\u094D\u0930\u0932\u092F \u0915\u093E \u0905\u0917\u094D\u0930\u0926\u0942\u0924","carrotNuke":"\u2622\uFE0F \u092A\u0930\u092E\u093E\u0923\u0941 \u0917\u093E\u091C\u0930 \u0927\u093E\u0930\u0915","bunnyMatrix":"\uD83E\uDD16 \u0916\u0930\u0917\u094B\u0936 \u092E\u0948\u091F\u094D\u0930\u093F\u0915\u094D\u0938 \u092E\u0947\u0902 \u0917\u0921\u093C\u092C\u0921\u093C\u0940","cosmicHare":"\uD83C\uDF0C \u092C\u094D\u0930\u0939\u094D\u092E\u093E\u0902\u0921\u0940\u092F \u0916\u0930\u0917\u094B\u0936 \u0915\u093E \u091C\u093E\u0917\u0930\u0923","warrenSingularity":"\uD83D\uDD73\uFE0F \u0916\u0930\u0917\u094B\u0936 \u092C\u093F\u0932 \u0935\u093F\u0932\u0915\u094D\u0937\u0923\u0924\u093E \u092A\u094D\u0930\u093E\u092A\u094D\u0924","eternalBunny":"\u267E\uFE0F \u0936\u093E\u0936\u094D\u0935\u0924 \u0916\u0930\u0917\u094B\u0936"},"messages":{"prophecy":"\u092A\u094D\u0930\u093E\u091A\u0940\u0928 \u0915\u094D\u0932\u093F\u0915\u093F\u0902\u0917 \u092D\u0935\u093F\u0937\u094D\u092F\u0935\u093E\u0923\u0940 \u0916\u0941\u0932\u0928\u0947 \u0932\u0917\u0940 \u0939\u0948...","cosmic":"\u092C\u094D\u0930\u0939\u094D\u092E\u093E\u0902\u0921\u0940\u092F \u0915\u094D\u0932\u093F\u0915\u0930\u094D\u0938 \u0906\u092A\u0915\u0940 \u092A\u094D\u0930\u0917\u0924\u093F \u092A\u0930 \u0917\u0930\u094D\u0935 \u0915\u0930\u0947\u0902\u0917\u0947!","astral":"\u0915\u094D\u0932\u093F\u0915 \u0915\u0940 \u0917\u0942\u0902\u091C \u0905\u0938\u094D\u091F\u094D\u0930\u0932 \u092A\u094D\u0932\u0947\u0928 \u092E\u0947\u0902 \u092B\u0948\u0932\u0924\u0940 \u0939\u0948...","speaking":"\u0930\u0941\u0915\u094B... \u0915\u094D\u092F\u093E \u0924\u0941\u092E\u0928\u0947 \u0938\u0941\u0928\u093E? \u0915\u094D\u0932\u093F\u0915\u094D\u0938 \u092E\u0941\u091D\u0938\u0947 \u092C\u093E\u0924 \u0915\u0930 \u0930\u0939\u0947 \u0939\u0948\u0902...","ancient":"\u0906\u092A\u0915\u093E \u0915\u094D\u0932\u093F\u0915\u093F\u0902\u0917 \u092A\u094D\u0930\u093E\u091A\u0940\u0928 \u0936\u0915\u094D\u0924\u093F \u0938\u0947 \u0917\u0942\u0902\u091C\u0924\u093E \u0939\u0948!","sages":"\u0915\u094D\u0932\u093F\u0915 \u090B\u0937\u093F \u0906\u092A\u0915\u0940 \u0915\u094D\u0937\u092E\u0924\u093E \u0915\u0947 \u092C\u093E\u0930\u0947 \u092E\u0947\u0902 \u092B\u0941\u0938\u092B\u0941\u0938\u093E\u0924\u0947 \u0939\u0948\u0902...","demons":"\u0926\u0947\u0916\u094B! \u0915\u094D\u0932\u093F\u0915 \u0930\u093E\u0915\u094D\u0937\u0938 \u0905\u092A\u0928\u0940 \u0928\u0940\u0902\u0926 \u0938\u0947 \u091C\u093E\u0917 \u0930\u0939\u0947 \u0939\u0948\u0902!","veil":"\u0906\u092A\u0915\u0947 \u0915\u094D\u0932\u093F\u0915\u094D\u0938 \u0935\u093E\u0938\u094D\u0924\u0935\u093F\u0915\u0924\u093E \u0915\u0947 \u092A\u0930\u094D\u0926\u0947 \u0915\u094B \u092D\u0947\u0926\u0924\u0947 \u0939\u0948\u0902!","spirits":"\u0915\u094D\u0932\u093F\u0915 \u0906\u0924\u094D\u092E\u093E\u090F\u0902 \u0906\u092A\u0915\u0940 \u0932\u092F \u092A\u0930 \u0928\u0943\u0924\u094D\u092F \u0915\u0930\u0924\u0940 \u0939\u0948\u0902...","council":"\u092E\u0939\u093E\u0928 \u0915\u094D\u0932\u093F\u0915 \u092A\u0930\u093F\u0937\u0926 \u0928\u0947 \u0906\u092A\u0915\u0940 \u0938\u092E\u0930\u094D\u092A\u0923 \u092A\u0930 \u0927\u094D\u092F\u093E\u0928 \u0926\u093F\u092F\u093E \u0939\u0948","primordial":"\u0906\u092A\u0915\u093E \u0915\u094D\u0932\u093F\u0915\u093F\u0902\u0917 \u0906\u0926\u093F\u092E \u0936\u0915\u094D\u0924\u093F\u092F\u094B\u0902 \u0915\u094B \u091C\u0917\u093E\u0924\u093E \u0939\u0948!","void":"\u0915\u094D\u0932\u093F\u0915\u093F\u0902\u0917 \u0936\u0942\u0928\u094D\u092F \u0906\u092A \u092A\u0930 \u0935\u093E\u092A\u0938 \u0928\u091C\u093C\u0930 \u0921\u093E\u0932\u0924\u093E \u0939\u0948...","runes":"\u092A\u094D\u0930\u093E\u091A\u0940\u0928 \u0915\u094D\u0932\u093F\u0915 \u0930\u0942\u0928\u094D\u0938 \u0906\u092A\u0915\u0940 \u0936\u0915\u094D\u0924\u093F \u0938\u0947 \u091A\u092E\u0915\u0924\u0947 \u0939\u0948\u0902!","beast":"\u0924\u0940\u0928 \u0924\u0940\u0928 \u0924\u0940\u0928 - \u0915\u094D\u0932\u093F\u0915 \u0930\u093E\u0915\u094D\u0937\u0938 \u0915\u093E \u0905\u0902\u0915","prophets":"\u0915\u094D\u0932\u093F\u0915 \u092D\u0935\u093F\u0937\u094D\u092F\u0935\u0915\u094D\u0924\u093E \u0906\u092A\u0915\u0947 \u0906\u0917\u092E\u0928 \u0915\u093E \u0917\u093E\u0928 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902!","dimensions":"\u0906\u092A\u0915\u0947 \u0915\u094D\u0932\u093F\u0915\u094D\u0938 \u0906\u092F\u093E\u092E\u094B\u0902 \u092E\u0947\u0902 \u0917\u0942\u0902\u091C\u0924\u0947 \u0939\u0948\u0902...","portal":"\u0906\u092A\u0915\u0947 \u0915\u094D\u0932\u093F\u0915\u094D\u0938 \u0928\u0947 \u0915\u094D\u0932\u093F\u0915 \u0906\u092F\u093E\u092E \u0915\u093E \u0926\u094D\u0935\u093E\u0930 \u0916\u094B\u0932 \u0926\u093F\u092F\u093E \u0939\u0948!","sacrifice":"\u092A\u094D\u0930\u093E\u091A\u0940\u0928 \u0915\u094D\u0932\u093F\u0915 \u0926\u0947\u0935\u0924\u093E \u0914\u0930 \u092C\u0932\u093F\u0926\u093E\u0928 \u092E\u093E\u0902\u0917\u0924\u0947 \u0939\u0948\u0902","jackpot":"\u091C\u0948\u0915\u092A\u0949\u091F! \u0915\u094D\u0932\u093F\u0915 \u0915\u0948\u0938\u0940\u0928\u094B \u0905\u092A\u0928\u0947 \u0928\u090F \u091A\u0948\u0902\u092A\u093F\u092F\u0928 \u0915\u093E \u0938\u094D\u0935\u093E\u0917\u0924 \u0915\u0930\u0924\u093E \u0939\u0948!","unmatched":"\u0906\u092A\u0915\u0940 \u0915\u094D\u0932\u093F\u0915 \u0936\u0915\u094D\u0924\u093F \u0905\u0926\u094D\u0935\u093F\u0924\u0940\u092F \u0939\u0948!","reality":"\u0935\u093E\u0938\u094D\u0924\u0935\u093F\u0915\u0924\u093E \u0938\u094D\u0935\u092F\u0902 \u0906\u092A\u0915\u0940 \u0915\u094D\u0932\u093F\u0915\u093F\u0902\u0917 \u0907\u091A\u094D\u091B\u093E \u0915\u0947 \u0906\u0917\u0947 \u091D\u0941\u0915\u0924\u0940 \u0939\u0948!","elite":"\u0906\u092A \u090F\u0932\u0940\u091F \u0915\u094D\u0932\u093F\u0915 \u092E\u093E\u0938\u094D\u091F\u0930 \u092C\u0928 \u0917\u090F \u0939\u0948\u0902","power":"\u0906\u092A\u0915\u093E \u0915\u094D\u0932\u093F\u0915\u093F\u0902\u0917 \u092A\u093E\u0935\u0930 \u0932\u0947\u0935\u0932 1500 \u0938\u0947 \u090A\u092A\u0930 \u0939\u0948!","devils":"\u0915\u094D\u0932\u093F\u0915 \u0936\u0948\u0924\u093E\u0928 \u0906\u092A\u0915\u0940 \u0936\u0915\u094D\u0924\u093F \u0915\u0947 \u0938\u093E\u092E\u0928\u0947 \u091D\u0941\u0915\u0924\u0947 \u0939\u0948\u0902","lucky":"\u092D\u093E\u0917\u094D\u092F\u0936\u093E\u0932\u0940 \u0915\u094D\u0932\u093F\u0915\u094D\u0938 \u0906\u092A\u0915\u0940 \u0928\u0938\u094B\u0902 \u092E\u0947\u0902 \u092C\u0939\u0924\u0947 \u0939\u0948\u0902","dynasty":"\u0915\u094D\u0932\u093F\u0915 \u0930\u093E\u091C\u0935\u0902\u0936 \u0906\u092A\u0915\u0940 \u0936\u094D\u0930\u0947\u0937\u094D\u0920\u0924\u093E \u0915\u094B \u092A\u0939\u091A\u093E\u0928\u0924\u093E \u0939\u0948","twoThousand":"\u0936\u0941\u0926\u094D\u0927 \u0936\u0915\u094D\u0924\u093F \u0915\u0947 \u0926\u094B \u0939\u091C\u093E\u0930 \u0915\u094D\u0932\u093F\u0915\u094D\u0938!","quartet":"\u0915\u094D\u0932\u093F\u0915 \u091A\u0924\u0941\u0937\u094D\u0915 \u0915\u0940 \u092D\u0935\u093F\u0937\u094D\u092F\u0935\u093E\u0923\u0940 \u092A\u0942\u0930\u0940 \u0939\u0941\u0908","transcend":"\u0906\u092A\u0915\u093E \u0915\u094D\u0932\u093F\u0915\u093F\u0902\u0917 \u0928\u0936\u094D\u0935\u0930 \u0938\u092E\u091D \u0938\u0947 \u092A\u0930\u0947 \u0939\u0948","constellation":"\u0915\u094D\u0932\u093F\u0915 \u0928\u0915\u094D\u0937\u0924\u094D\u0930 \u0906\u092A\u0915\u0947 \u0938\u092E\u094D\u092E\u093E\u0928 \u092E\u0947\u0902 \u0938\u0902\u0930\u0947\u0916\u093F\u0924 \u0939\u094B\u0924\u0947 \u0939\u0948\u0902","destiny":"\u0928\u093F\u092F\u0924\u093F \u0915\u0947 \u0924\u0940\u0928 \u0939\u091C\u093E\u0930 \u0915\u094D\u0932\u093F\u0915\u094D\u0938","triforce":"\u091F\u094D\u0930\u093F\u092A\u0932 \u0915\u094D\u0932\u093F\u0915 \u0924\u094D\u0930\u093F\u0936\u0915\u094D\u0924\u093F \u091C\u093E\u0917\u0943\u0924 \u0939\u094B\u0924\u0940 \u0939\u0948!","fortune":"\u092D\u093E\u0917\u094D\u092F \u0926\u0943\u0922\u093C \u0915\u094D\u0932\u093F\u0915\u0930 \u0915\u093E \u0938\u093E\u0925 \u0926\u0947\u0924\u093E \u0939\u0948","newDimensions":"\u0906\u092A\u0915\u0940 \u0915\u094D\u0932\u093F\u0915\u093F\u0902\u0917 \u0936\u0915\u094D\u0924\u093F \u0928\u090F \u0906\u092F\u093E\u092E\u094B\u0902 \u0924\u0915 \u092A\u0939\u0941\u0902\u091A\u0924\u0940 \u0939\u0948","quartet2":"\u091A\u094C\u0917\u0941\u0928\u093E \u0915\u094D\u0932\u093F\u0915 \u091A\u0924\u0941\u0937\u094D\u0915 \u0938\u093E\u092E\u0902\u091C\u0938\u094D\u092F \u092C\u0928\u093E\u0924\u093E \u0939\u0948","threshold":"\u0915\u094D\u0932\u093F\u0915 \u0926\u093F\u0935\u094D\u092F\u0924\u093E \u0915\u0940 \u0926\u0939\u0932\u0940\u091C \u092A\u0930 \u0916\u0921\u093C\u0947 \u0939\u0948\u0902","ultimate":"\u092A\u0930\u092E \u0936\u0915\u094D\u0924\u093F \u0915\u0947 \u092A\u093E\u0902\u091A \u0939\u091C\u093E\u0930 \u0915\u094D\u0932\u093F\u0915\u094D\u0938!","force":"\u092A\u093E\u0902\u091A \u0909\u0902\u0917\u0932\u0940 \u0915\u094D\u0932\u093F\u0915 \u092B\u094B\u0930\u094D\u0938 \u0906\u092A\u0915\u0947 \u0928\u093F\u092F\u0902\u0924\u094D\u0930\u0923 \u092E\u0947\u0902 \u0939\u0948","underworld":"\u0915\u094D\u0932\u093F\u0915 \u092A\u093E\u0924\u093E\u0932 \u0906\u092A\u0915\u094B \u0905\u092A\u0928\u093E \u0936\u093E\u0938\u0915 \u092C\u0928\u093E\u0924\u093E \u0939\u0948","maxJackpot":"\u0905\u0927\u093F\u0915\u0924\u092E \u091C\u0948\u0915\u092A\u0949\u091F \u0915\u094D\u0932\u093F\u0915\u093F\u0902\u0917 \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0940","infinite":"\u0905\u0928\u0902\u0924 \u0915\u094D\u0932\u093F\u0915\u093F\u0902\u0917 \u0936\u0915\u094D\u0924\u093F!","godhood":"\u0906\u092A \u0915\u094D\u0932\u093F\u0915 \u0926\u0947\u0935\u0924\u094D\u0935 \u0924\u0915 \u092A\u0939\u0941\u0902\u091A \u0917\u090F \u0939\u0948\u0902","burrow":"\u0906\u092A\u0928\u0947 \u0915\u093F\u0938\u0940 \u092D\u0940 \u0916\u0930\u0917\u094B\u0936 \u0938\u0947 \u091C\u093C\u094D\u092F\u093E\u0926\u093E \u0917\u0939\u0930\u093E \u0916\u094B\u0926\u093E \u0939\u0948...","warren":"\u092E\u0939\u093E\u0928 \u0916\u0930\u0917\u094B\u0936 \u092C\u093F\u0932 \u0906\u092A\u0915\u0940 \u0909\u092A\u0938\u094D\u0925\u093F\u0924\u093F \u0915\u094B \u092A\u0939\u091A\u093E\u0928\u0924\u093E \u0939\u0948...","thump":"\u0906\u092A\u0915\u0947 \u0939\u0930 \u092A\u0948\u0930 \u0915\u0947 \u0925\u0902\u092A \u0938\u0947 \u0927\u0930\u0924\u0940 \u0915\u093E\u0902\u092A\u0924\u0940 \u0939\u0948!","darkWarren":"\u0905\u0902\u0927\u0947\u0930\u093E \u0916\u0930\u0917\u094B\u0936 \u092C\u093F\u0932 \u0906\u092A\u0915\u0947 \u0932\u093F\u090F \u0905\u092A\u0928\u0947 \u0926\u094D\u0935\u093E\u0930 \u0916\u094B\u0932\u0924\u093E \u0939\u0948...","ears":"\u0906\u092A\u0915\u0947 \u0915\u093E\u0928 \u0932\u0902\u092C\u0947 \u0939\u094B\u0924\u0947 \u091C\u093E \u0930\u0939\u0947 \u0939\u0948\u0902... \u0905\u092C \u0906\u092A \u0938\u092C \u0915\u0941\u091B \u0938\u0941\u0928 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902...","carrotThrone":"\u0917\u093E\u091C\u0930 \u0915\u093E \u0938\u093F\u0902\u0939\u093E\u0938\u0928 \u0906\u092A\u0915\u0947 \u0938\u093E\u092E\u0928\u0947 \u092A\u094D\u0930\u0915\u091F \u0939\u094B\u0924\u093E \u0939\u0948...","onesAlignment":"\u0938\u092D\u0940 \u090F\u0915 \u0938\u0902\u0930\u0947\u0916\u093F\u0924 \u0939\u094B\u0924\u0947 \u0939\u0948\u0902 - \u0916\u0930\u0917\u094B\u0936 \u092C\u093F\u0932 \u0915\u0940 \u0906\u0935\u0943\u0924\u094D\u0924\u093F \u0917\u0942\u0902\u091C\u0924\u0940 \u0939\u0948!","moonSummon":"\u091A\u0902\u0926\u094D\u0930 \u0916\u0930\u0917\u094B\u0936 \u0936\u0942\u0928\u094D\u092F \u0915\u0947 \u092A\u093E\u0930 \u0906\u092A\u0915\u0940 \u092A\u0941\u0915\u093E\u0930 \u0938\u0941\u0928\u0924\u093E \u0939\u0948...","edgeOfForever":"\u0906\u092A \u0905\u0928\u0902\u0924 \u0915\u0947 \u0915\u093F\u0928\u093E\u0930\u0947 \u092A\u0930 \u0916\u0921\u093C\u0947 \u0939\u0948\u0902... \u0915\u093E\u0928 \u092B\u0921\u093C\u092B\u0921\u093C\u093E \u0930\u0939\u0947 \u0939\u0948\u0902...","beyondTheVeil":"\u092A\u0930\u094D\u0926\u0947 \u0915\u0947 \u092A\u093E\u0930, \u0938\u092D\u0940 \u092C\u093F\u0932 \u090F\u0915 \u0939\u094B \u091C\u093E\u0924\u0947 \u0939\u0948\u0902...","sequence":"1-2-3-4-5... \u092A\u0935\u093F\u0924\u094D\u0930 \u0939\u0949\u092A \u0905\u0928\u0941\u0915\u094D\u0930\u092E \u092A\u0942\u0930\u093E \u0939\u0941\u0906!","hyperElite":"\u0939\u093E\u0907\u092A\u0930 \u090F\u0932\u0940\u091F \u0916\u0930\u0917\u094B\u0936 \u0938\u094D\u0925\u093F\u0924\u093F \u0905\u0928\u0932\u0949\u0915 \uD83D\uDC07\uD83D\uDC07\uD83D\uDC07","eventHorizon":"\u092C\u094D\u0930\u0939\u094D\u092E\u093E\u0902\u0921\u0940\u092F \u0916\u0930\u0917\u094B\u0936 \u092C\u093F\u0932 \u0915\u0947 \u0918\u091F\u0928\u093E \u0915\u094D\u0937\u093F\u0924\u093F\u091C \u0938\u0947 \u092A\u0930\u0947...","matrixAwakens":"\u0916\u0930\u0917\u094B\u0936 \u092C\u093F\u0932 \u092E\u0948\u091F\u094D\u0930\u093F\u0915\u094D\u0938 \u092E\u0947\u0902 \u0917\u0921\u093C\u092C\u0921\u093C\u0940... \u0906\u092A \u0935\u093E\u0938\u094D\u0924\u0935\u093F\u0915\u0924\u093E \u0915\u0947 \u092A\u0940\u091B\u0947 \u0917\u093E\u091C\u0930 \u0926\u0947\u0916\u0924\u0947 \u0939\u0948\u0902","luckyForever":"\u0939\u0930 \u092A\u0902\u091C\u093E, \u0939\u0930 \u091B\u0932\u093E\u0902\u0917, \u0939\u0930 \u092B\u0921\u093C\u0915\u0928... \u0939\u092E\u0947\u0936\u093E \u0915\u0947 \u0932\u093F\u090F \u0906\u0936\u0940\u0930\u094D\u0935\u093E\u0926\u093F\u0924","twentyK":"\u092C\u0940\u0938 \u0939\u091C\u093C\u093E\u0930\u0964 \u0906\u092A \u0905\u092C \u090F\u0915 \u0916\u0930\u0917\u094B\u0936 \u0928\u0939\u0940\u0902 \u0939\u0948\u0902\u0964 \u0906\u092A \u0935\u094B \u0916\u0930\u0917\u094B\u0936 \u0939\u0948\u0902\u0964","singularity":"\u0916\u0930\u0917\u094B\u0936 \u0935\u093F\u0932\u0915\u094D\u0937\u0923\u0924\u093E\u0964 \u0938\u092D\u0940 \u0916\u0930\u0917\u094B\u0936 \u0906\u092A \u0939\u0948\u0902\u0964 \u0906\u092A \u0938\u092D\u0940 \u0916\u0930\u0917\u094B\u0936 \u0939\u0948\u0902\u0964","tripleAscension":"\u092C\u094D\u0930\u0939\u094D\u092E\u093E\u0902\u0921\u0940\u092F \u0916\u0930\u0917\u094B\u0936 \u0915\u0940 \u0924\u0940\u0928 \u0917\u0941\u0928\u093E \u0909\u0924\u094D\u0925\u093E\u0928!","ultimateAnswer":"42,000 - \u092A\u0930\u092E \u0909\u0924\u094D\u0924\u0930 \u0936\u0941\u0930\u0942 \u0938\u0947 \u0939\u0940 \u0917\u093E\u091C\u0930 \u0925\u093E","eternity":"\u267E\uFE0F \u0936\u093E\u0936\u094D\u0935\u0924 \u0916\u0930\u0917\u094B\u0936 \u092C\u093F\u0932 \u0915\u093E \u0915\u094B\u0908 \u0905\u0902\u0924 \u0928\u0939\u0940\u0902 \u0939\u0948\u0964 \u0906\u092A\u0915\u093E \u092D\u0940 \u0928\u0939\u0940\u0902\u0964 \u267E\uFE0F"},"powerups":{"bonusPoints":"\uD83E\uDD55 +{{count}} \u092C\u094B\u0928\u0938 \u0905\u0902\u0915!","clickStreak":"\uD83D\uDD25 {{count}} \u0915\u094D\u0932\u093F\u0915 \u0938\u094D\u091F\u094D\u0930\u0940\u0915!","fire":"\uD83D\uDD25 \u092B\u093E\u092F\u0930 \u092A\u093E\u0935\u0930 \u0938\u0915\u094D\u0930\u093F\u092F!"},"table":{"achievement":"\u0909\u092A\u0932\u092C\u094D\u0927\u093F","progress":"\u092A\u094D\u0930\u0917\u0924\u093F"},"reset":{"confirm":"\u0915\u094D\u092F\u093E \u0906\u092A \u0935\u093E\u0915\u0908 \u0938\u093E\u0930\u0940 \u092A\u094D\u0930\u0917\u0924\u093F \u0930\u0940\u0938\u0947\u091F \u0915\u0930\u0928\u093E \u091A\u093E\u0939\u0924\u0947 \u0939\u0948\u0902? \u0907\u0938\u0947 \u0935\u093E\u092A\u0938 \u0928\u0939\u0940\u0902 \u0915\u093F\u092F\u093E \u091C\u093E \u0938\u0915\u0924\u093E\u0964"}}');

});

parcelRegister("ltNo2", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"title":"nakazawa \uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","description":"\uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","buttons":{"fullscreen":"Layar Penuh","achievements":"Prestasi","reset":"Atur Ulang","language":"Bahasa"},"achievements":{"title":"Prestasi","noAchievements":"Belum ada prestasi yang diraih. Terus klik!","unlocked":"Prestasi Terbuka: {{message}}","progress":"{{progress}}%","beginner":"\uD83C\uDFAF Kelinci Pemula","carrotSnatcher":"\uD83E\uDD55 Pencuri Sayuran","bunnyBerserker":"\uD83D\uDE21 Amukan Kelinci","hopPunk":"\uD83C\uDFB8 Kelinci Anarkis","bunnyNinja":"\uD83E\uDD77 Kelinci Ninja Mematikan","expert":"\uD83C\uDF1F Pelompat Ahli","master":"\uD83D\uDC51 Raja Wortel","carrotpocalypse":"\uD83E\uDD55 Penghancur Kebun","bunnyOverlord":"\uD83D\uDE08 Penguasa Tertinggi Kelinci","chaosHare":"\uD83C\uDF2A\uFE0F Agen Kekacauan","carrotCultist":"\u26EA Pendeta Tinggi Kultus Wortel","bunnyberryPie":"\uD83E\uDD67 Ahli Pai Halusinasi","rabbitHole":"\uD83D\uDD73\uFE0F Penggali Terowongan Kuantum","moonRabbit":"\uD83C\uDF19 Kelinci Bulan","bunnyDoom":"\uD83D\uDC80 Pembawa Kiamat Kelinci","carrotNuke":"\u2622\uFE0F Pemegang Wortel Nuklir","bunnyMatrix":"\uD83E\uDD16 Glitch dalam Matrix Kelinci","cosmicHare":"\uD83C\uDF0C Kelinci Kosmik Bangkit","warrenSingularity":"\uD83D\uDD73\uFE0F Singularitas Liang Tercapai","eternalBunny":"\u267E\uFE0F Kelinci Abadi"},"messages":{"prophecy":"Ramalan klik kuno mulai terungkap...","cosmic":"Para pengklik kosmik akan bangga dengan kemajuanmu!","astral":"Klik-klik bergema melalui alam astral...","speaking":"Tunggu... apa kamu mendengarnya? Klik-klik itu berbicara padaku...","ancient":"Klikmu beresonansi dengan kekuatan kuno!","sages":"Para Bijak Klik berbisik tentang potensimu...","demons":"LIHATLAH! Para Iblis Klik bangkit dari tidur mereka!","veil":"Klik-klikmu menembus tirai realitas!","spirits":"Roh-Roh Klik menari mengikuti iramamu...","council":"Dewan Agung Klik telah memperhatikan dedikasimu","primordial":"Klikmu membangunkan kekuatan primordial!","void":"Kekosongan klik menatap balik padamu...","runes":"Rune-rune klik kuno bersinar dengan kekuatanmu!","beast":"TIGA TIGA TIGA - ANGKA DARI MAKHLUK KLIK","prophets":"Para Nabi Klik bernyanyi tentang kedatanganmu!","dimensions":"Klik-klikmu bergema melalui dimensi...","portal":"Klik-klikmu telah membuka portal ke Dimensi Klik!","sacrifice":"Para Dewa Klik Kuno menuntut LEBIH BANYAK PENGORBANAN","jackpot":"JACKPOT! Kasino Klik menyambut juara barunya!","unmatched":"Kekuatan klikmu tak tertandingi!","reality":"Realitas sendiri tunduk pada kehendak klikmu!","elite":"KAMU TELAH MENJADI PENGUASA KLIK ELIT","power":"Level kekuatan klikmu di atas 1500!","devils":"Para Iblis Klik membungkuk di hadapan kekuatanmu","lucky":"Klik keberuntungan mengalir dalam pembuluh darahmu","dynasty":"Dinasti Klik mengakui supremasimu","twoThousand":"Dua ribu klik kekuatan murni!","quartet":"Ramalan Kuartet Klik telah terpenuhi","transcend":"Klikmu melampaui pemahaman fana","constellation":"Konstelasi Klik selaras untuk menghormatimu","destiny":"TIGA RIBU KLIK TAKDIR","triforce":"Triforce Klik Tiga terbangun!","fortune":"Keberuntungan berpihak pada pengklik yang gigih","newDimensions":"Kekuatan klikmu mencapai dimensi baru","quartet2":"Kuartet Klik Empat mengharmonisasi","threshold":"Berdiri di ambang keillahian klik","ultimate":"LIMA RIBU KLIK KEKUATAN ULTIMAT!","force":"Kekuatan Klik Lima Jari siap kau perintah","underworld":"Dunia Bawah Klik memahkotaimu sebagai penguasa mereka","maxJackpot":"JACKPOT KLIK MAKSIMUM TERCAPAI","infinite":"KEKUATAN KLIK TAK TERBATAS!","godhood":"KAMU TELAH NAIK MENJADI DEWA KLIK","burrow":"Kamu telah menggali lebih dalam dari kelinci manapun...","warren":"Liang Agung mengakui kehadiranmu...","thump":"Bumi berguncang setiap kali kakimu menghentakkan tanah!","darkWarren":"Liang Gelap membuka gerbangnya untukmu...","ears":"Telingamu semakin panjang... kamu bisa mendengar segalanya sekarang...","carrotThrone":"Tahta Wortel terwujud di hadapanmu...","onesAlignment":"Semua angka satu selaras - Frekuensi Liang beresonansi!","moonSummon":"Kelinci Bulan mendengar panggilanmu menembus kekosongan...","edgeOfForever":"Kamu berdiri di tepi keabadian... telinga bergetar...","beyondTheVeil":"Di balik tabir, semua liang menjadi satu...","sequence":"1-2-3-4-5... Urutan Lompatan Suci telah selesai!","hyperElite":"STATUS HIPER ELIT KELINCI TERBUKA \uD83D\uDC07\uD83D\uDC07\uD83D\uDC07","eventHorizon":"Melewati cakrawala peristiwa Lubang Kelinci Kosmik...","matrixAwakens":"Matrix Liang berkedip... kamu melihat wortel di balik realitas","luckyForever":"Setiap cakar, setiap lompatan, setiap kedutan... diberkati selamanya","twentyK":"DUA PULUH RIBU. Kamu bukan lagi seekor kelinci. Kamu adalah SANG kelinci.","singularity":"Singularitas Kelinci. Semua kelinci adalah kamu. Kamu adalah semua kelinci.","tripleAscension":"Kenaikan Tiga Kali Lipat dari Kelinci Kosmik!","ultimateAnswer":"42.000 - Jawaban Utama selalu wortel sejak awal","eternity":"\u267E\uFE0F LIANG ABADI TIDAK MEMILIKI AKHIR. KAU JUGA TIDAK. \u267E\uFE0F"},"powerups":{"bonusPoints":"\uD83E\uDD55 +{{count}} Poin Bonus!","clickStreak":"\uD83D\uDD25 {{count}} Klik Beruntun!","fire":"\uD83D\uDD25 Kekuatan Api Diaktifkan!"},"table":{"achievement":"Prestasi","progress":"Kemajuan"},"reset":{"confirm":"Apakah Anda yakin ingin mengatur ulang semua kemajuan? Ini tidak dapat dibatalkan."}}');

});

parcelRegister("gZmg8", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"title":"nakazawa \uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","description":"\uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","buttons":{"fullscreen":"Schermo intero","achievements":"Obiettivi","reset":"Azzera","language":"Lingua"},"achievements":{"title":"Obiettivi","noAchievements":"Nessun obiettivo sbloccato. Continua a cliccare!","unlocked":"Obiettivo Sbloccato: {{message}}","progress":"{{progress}}%","beginner":"\uD83C\uDFAF Coniglio Principiante","carrotSnatcher":"\uD83E\uDD55 Ladro di Verdure","bunnyBerserker":"\uD83D\uDE21 Coniglio Furioso","hopPunk":"\uD83C\uDFB8 Coniglio Anarchico","bunnyNinja":"\uD83E\uDD77 Silenzioso ma Letale","expert":"\uD83C\uDF1F Saltatore Esperto","master":"\uD83D\uDC51 Re delle Carote","carrotpocalypse":"\uD83E\uDD55 Distruttore di Orti","bunnyOverlord":"\uD83D\uDE08 Signore Supremo della Tana","chaosHare":"\uD83C\uDF2A\uFE0F Agente del Caos","carrotCultist":"\u26EA Sommo Sacerdote del Culto della Carota","bunnyberryPie":"\uD83E\uDD67 Maestro della Torta Allucinogena","rabbitHole":"\uD83D\uDD73\uFE0F Scavatore di Tunnel Quantici","moonRabbit":"\uD83C\uDF19 Coniglio Lunare","bunnyDoom":"\uD83D\uDC80 Araldo del Coniglipocalisse","carrotNuke":"\u2622\uFE0F Portatore della Carota Nucleare","bunnyMatrix":"\uD83E\uDD16 Glitch nella Matrice dei Conigli","cosmicHare":"\uD83C\uDF0C La Lepre Cosmica Si Risveglia","warrenSingularity":"\uD83D\uDD73\uFE0F Singolarit\xe0 della Tana Raggiunta","eternalBunny":"\u267E\uFE0F Il Coniglio Eterno"},"messages":{"prophecy":"L\'antica profezia del click inizia a svelarsi...","cosmic":"I cliccatori cosmici sarebbero fieri del tuo progresso!","astral":"I click echeggiano attraverso il piano astrale...","speaking":"Aspetta... hai sentito? I click mi stanno parlando...","ancient":"Il tuo clicking risuona con potere antico!","sages":"I Saggi del Click sussurrano del tuo potenziale...","demons":"CONTEMPLA! I Demoni del Click si risvegliano dal loro sonno!","veil":"I tuoi click trafiggono il velo della realt\xe0!","spirits":"Gli Spiriti del Click danzano al tuo ritmo...","council":"Il Gran Consiglio del Click ha notato la tua dedizione","primordial":"Il tuo clicking risveglia forze primordiali!","void":"Il vuoto del clicking ti fissa negli occhi...","runes":"Le antiche rune del click brillano col tuo potere!","beast":"TRE TRE TRE - IL NUMERO DELLA BESTIA DEL CLICK","prophets":"I Profeti del Click cantano del tuo arrivo!","dimensions":"I tuoi click echeggiano attraverso le dimensioni...","portal":"I tuoi click hanno aperto un portale verso la Dimensione del Click!","sacrifice":"Gli antichi Dei del Click esigono PI\xd9 SACRIFICI","jackpot":"JACKPOT! Il Casin\xf2 del Click d\xe0 il benvenuto al suo nuovo campione!","unmatched":"Il tuo potere di click \xe8 imbattibile!","reality":"La realt\xe0 stessa si piega alla tua volont\xe0 di clicking!","elite":"SEI DIVENTATO IL MAESTRO CLICK D\'ELITE","power":"Il tuo livello di potere click supera 1500!","devils":"I Diavoli del Click si inchinano al tuo potere","lucky":"I click fortunati scorrono nelle tue vene","dynasty":"La Dinastia del Click riconosce la tua supremazia","twoThousand":"Duemila click di puro potere!","quartet":"La profezia del Quartetto del Click si \xe8 avverata","transcend":"Il tuo clicking trascende la comprensione mortale","constellation":"La Costellazione del Click si allinea in tuo onore","destiny":"TREMILA CLICK DEL DESTINO","triforce":"La Triforza Tripla del Click si risveglia!","fortune":"La fortuna favorisce il cliccatore persistente","newDimensions":"Il tuo potere di click raggiunge nuove dimensioni","quartet2":"Il Quartetto Quadruplo del Click armonizza","threshold":"In piedi sulla soglia della divinit\xe0 del click","ultimate":"CINQUEMILA CLICK DI POTERE SUPREMO!","force":"La Forza Click delle Cinque Dita \xe8 ai tuoi comandi","underworld":"Il Sottomondo del Click ti incorona loro sovrano","maxJackpot":"RAGGIUNTO IL JACKPOT MASSIMO DEI CLICK","infinite":"POTERE DI CLICK INFINITO!","godhood":"SEI ASCESO ALLA DIVINIT\xc0 DEL CLICK","burrow":"Hai scavato pi\xf9 in profondit\xe0 di qualsiasi coniglio prima di te...","warren":"La Grande Tana riconosce la tua presenza...","thump":"La terra trema ad ogni colpo della tua zampa!","darkWarren":"La Tana Oscura apre i suoi cancelli per te...","ears":"Le tue orecchie si allungano... ora puoi sentire tutto...","carrotThrone":"Il Trono di Carota si materializza davanti a te...","onesAlignment":"Tutti gli uni si allineano - la Frequenza della Tana risuona!","moonSummon":"Il Coniglio Lunare sente la tua chiamata attraverso il vuoto...","edgeOfForever":"Sei al bordo dell\'eternit\xe0... orecchie tremanti...","beyondTheVeil":"Oltre il velo, tutte le tane diventano una...","sequence":"1-2-3-4-5... La Sacra Sequenza del Salto \xe8 completa!","hyperElite":"STATO IPER ELITE SBLOCCATO \uD83D\uDC07\uD83D\uDC07\uD83D\uDC07","eventHorizon":"Oltre l\'orizzonte degli eventi della Tana Cosmica...","matrixAwakens":"La Matrice della Tana ha un glitch... vedi le carote dietro la realt\xe0","luckyForever":"Ogni zampa, ogni salto, ogni fremito... benedetto per sempre","twentyK":"VENTIMILA. Non sei pi\xf9 un coniglio. Sei IL coniglio.","singularity":"La Singolarit\xe0 dei Conigli. Tutti i conigli sei tu. Tu sei tutti i conigli.","tripleAscension":"La Tripla Ascensione della Lepre Cosmica!","ultimateAnswer":"42.000 - La Risposta Definitiva sono sempre state le carote","eternity":"\u267E\uFE0F LA TANA ETERNA NON HA FINE. NEANCHE TU. \u267E\uFE0F"},"powerups":{"bonusPoints":"\uD83E\uDD55 +{{count}} Punti Bonus!","clickStreak":"\uD83D\uDD25 {{count}} Click Consecutivi!","fire":"\uD83D\uDD25 Potere di Fuoco Attivato!"},"table":{"achievement":"Obiettivo","progress":"Progresso"},"reset":{"confirm":"Sei sicuro di voler azzerare tutti i progressi? Questa azione non pu\xf2 essere annullata."}}');

});

parcelRegister("lDS5j", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"title":"\u4E2D\u6CA2 \uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","description":"\uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","buttons":{"fullscreen":"\u5168\u753B\u9762","achievements":"\u5B9F\u7E3E","reset":"\u30EA\u30BB\u30C3\u30C8","language":"\u8A00\u8A9E"},"achievements":{"title":"\u5B9F\u7E3E","noAchievements":"\u307E\u3060\u5B9F\u7E3E\u3092\u7372\u5F97\u3057\u3066\u3044\u307E\u305B\u3093\u3002\u30AF\u30EA\u30C3\u30AF\u3092\u7D9A\u3051\u307E\u3057\u3087\u3046\uFF01","unlocked":"\u5B9F\u7E3E\u89E3\u9664\uFF1A{{message}}","progress":"{{progress}}%","beginner":"\uD83C\uDFAF \u521D\u5FC3\u8005\u30D0\u30CB\u30FC","carrotSnatcher":"\uD83E\uDD55 \u91CE\u83DC\u6CE5\u68D2","bunnyBerserker":"\uD83D\uDE21 \u72C2\u4E71\u306E\u30A6\u30B5\u30AE","hopPunk":"\uD83C\uDFB8 \u30A2\u30CA\u30FC\u30AD\u30FC\u306A\u7DBF\u5C3E","bunnyNinja":"\uD83E\uDD77 \u9759\u304B\u306A\u308B\u6B7B\u306E\u30D5\u30EF\u30D5\u30EF","expert":"\uD83C\uDF1F \u30A8\u30AD\u30B9\u30D1\u30FC\u30C8\u30DB\u30C3\u30D1\u30FC","master":"\uD83D\uDC51 \u30CB\u30F3\u30B8\u30F3\u30AD\u30F3\u30B0","carrotpocalypse":"\uD83E\uDD55 \u83DC\u5712\u306E\u7834\u58CA\u8005","bunnyOverlord":"\uD83D\uDE08 \u30A6\u30B5\u30AE\u306E\u7FA4\u308C\u306E\u652F\u914D\u8005","chaosHare":"\uD83C\uDF2A\uFE0F \u6DF7\u6C8C\u306E\u30A6\u30B5\u30AE\u4F7F\u3044","carrotCultist":"\u26EA \u30CB\u30F3\u30B8\u30F3\u6559\u56E3\u306E\u5927\u53F8\u796D","bunnyberryPie":"\uD83E\uDD67 \u5E7B\u899A\u30D1\u30A4\u306E\u9054\u4EBA","rabbitHole":"\uD83D\uDD73\uFE0F \u91CF\u5B50\u30C8\u30F3\u30CD\u30EB\u6398\u308A","moonRabbit":"\uD83C\uDF19 \u6708\u306E\u7389\u514E","bunnyDoom":"\uD83D\uDC80 \u30A6\u30B5\u30DD\u30AB\u30EA\u30D7\u30B9\u306E\u4F7F\u8005","carrotNuke":"\u2622\uFE0F \u71B1\u6838\u30CB\u30F3\u30B8\u30F3\u4F7F\u3044","bunnyMatrix":"\uD83E\uDD16 \u30A6\u30B5\u30AE\u30DE\u30C8\u30EA\u30C3\u30AF\u30B9\u306E\u7570\u5E38","cosmicHare":"\uD83C\uDF0C \u5B87\u5B99\u306E\u30A6\u30B5\u30AE\u306E\u899A\u9192","warrenSingularity":"\uD83D\uDD73\uFE0F \u5DE3\u7A74\u30B7\u30F3\u30AE\u30E5\u30E9\u30EA\u30C6\u30A3\u9054\u6210","eternalBunny":"\u267E\uFE0F \u6C38\u9060\u306E\u30A6\u30B5\u30AE"},"messages":{"prophecy":"\u53E4\u4EE3\u306E\u30AF\u30EA\u30C3\u30AF\u4E88\u8A00\u304C\u5C55\u958B\u3057\u59CB\u3081\u308B...","cosmic":"\u5B87\u5B99\u306E\u30AF\u30EA\u30C3\u30AB\u30FC\u305F\u3061\u306F\u3042\u306A\u305F\u306E\u9032\u6B69\u3092\u8A87\u308A\u306B\u601D\u3046\u3067\u3057\u3087\u3046\uFF01","astral":"\u30AF\u30EA\u30C3\u30AF\u304C\u661F\u754C\u3092\u97FF\u304D\u6E21\u308B...","speaking":"\u5F85\u3063\u3066...\u805E\u3053\u3048\u305F\uFF1F\u30AF\u30EA\u30C3\u30AF\u304C\u79C1\u306B\u8A71\u3057\u304B\u3051\u3066\u3044\u308B...","ancient":"\u3042\u306A\u305F\u306E\u30AF\u30EA\u30C3\u30AF\u304C\u53E4\u4EE3\u306E\u529B\u3068\u5171\u9CF4\u3059\u308B\uFF01","sages":"\u30AF\u30EA\u30C3\u30AF\u306E\u8CE2\u8005\u305F\u3061\u304C\u3042\u306A\u305F\u306E\u53EF\u80FD\u6027\u3092\u56C1\u3044\u3066\u3044\u308B...","demons":"\u898B\u3088\uFF01\u30AF\u30EA\u30C3\u30AF\u306E\u60AA\u9B54\u305F\u3061\u304C\u76EE\u899A\u3081\u305F\uFF01","veil":"\u3042\u306A\u305F\u306E\u30AF\u30EA\u30C3\u30AF\u304C\u73FE\u5B9F\u306E\u58C1\u3092\u7A81\u304D\u7834\u308B\uFF01","spirits":"\u30AF\u30EA\u30C3\u30AF\u306E\u7CBE\u970A\u305F\u3061\u304C\u3042\u306A\u305F\u306E\u30EA\u30BA\u30E0\u306B\u5408\u308F\u305B\u3066\u8E0A\u308B...","council":"\u30B0\u30E9\u30F3\u30C9\u30AF\u30EA\u30C3\u30AF\u8A55\u8B70\u4F1A\u304C\u3042\u306A\u305F\u306E\u732E\u8EAB\u306B\u6C17\u4ED8\u3044\u305F","primordial":"\u3042\u306A\u305F\u306E\u30AF\u30EA\u30C3\u30AF\u304C\u539F\u521D\u306E\u529B\u3092\u547C\u3073\u899A\u307E\u3059\uFF01","void":"\u30AF\u30EA\u30C3\u30AF\u306E\u865A\u7A7A\u304C\u3042\u306A\u305F\u3092\u898B\u8FD4\u3057\u3066\u3044\u308B...","runes":"\u53E4\u4EE3\u306E\u30AF\u30EA\u30C3\u30AF\u30EB\u30FC\u30F3\u304C\u3042\u306A\u305F\u306E\u529B\u3067\u8F1D\u304F\uFF01","beast":"\u4E09\u4E09\u4E09 - \u30AF\u30EA\u30C3\u30AF\u7363\u306E\u6570\u5B57","prophets":"\u30AF\u30EA\u30C3\u30AF\u306E\u9810\u8A00\u8005\u305F\u3061\u304C\u3042\u306A\u305F\u306E\u5230\u6765\u3092\u6B4C\u3046\uFF01","dimensions":"\u3042\u306A\u305F\u306E\u30AF\u30EA\u30C3\u30AF\u304C\u6B21\u5143\u3092\u8D85\u3048\u3066\u97FF\u304D\u6E21\u308B...","portal":"\u3042\u306A\u305F\u306E\u30AF\u30EA\u30C3\u30AF\u304C\u30AF\u30EA\u30C3\u30AF\u6B21\u5143\u3078\u306E\u30DD\u30FC\u30BF\u30EB\u3092\u958B\u3044\u305F\uFF01","sacrifice":"\u53E4\u4EE3\u306E\u30AF\u30EA\u30C3\u30AF\u306E\u795E\u3005\u304C\u3055\u3089\u306A\u308B\u751F\u8D04\u3092\u6C42\u3081\u308B","jackpot":"\u30B8\u30E3\u30C3\u30AF\u30DD\u30C3\u30C8\uFF01\u30AF\u30EA\u30C3\u30AF\u30AB\u30B8\u30CE\u304C\u65B0\u30C1\u30E3\u30F3\u30D4\u30AA\u30F3\u3092\u6B53\u8FCE\u3059\u308B\uFF01","unmatched":"\u3042\u306A\u305F\u306E\u30AF\u30EA\u30C3\u30AF\u529B\u306F\u7121\u6575\u3067\u3059\uFF01","reality":"\u73FE\u5B9F\u305D\u306E\u3082\u306E\u304C\u3042\u306A\u305F\u306E\u30AF\u30EA\u30C3\u30AF\u306E\u610F\u5FD7\u306B\u5F93\u3046\uFF01","elite":"\u3042\u306A\u305F\u306F\u30A8\u30EA\u30FC\u30C8\u30AF\u30EA\u30C3\u30AF\u30DE\u30B9\u30BF\u30FC\u3068\u306A\u3063\u305F","power":"\u3042\u306A\u305F\u306E\u30AF\u30EA\u30C3\u30AF\u30D1\u30EF\u30FC\u30EC\u30D9\u30EB\u306F1500\u3092\u8D85\u3048\u305F\uFF01","devils":"\u30AF\u30EA\u30C3\u30AF\u306E\u60AA\u9B54\u305F\u3061\u304C\u3042\u306A\u305F\u306E\u529B\u306E\u524D\u306B\u982D\u3092\u5782\u308C\u308B","lucky":"\u5E78\u904B\u306E\u30AF\u30EA\u30C3\u30AF\u304C\u3042\u306A\u305F\u306E\u8840\u7BA1\u3092\u6D41\u308C\u308B","dynasty":"\u30AF\u30EA\u30C3\u30AF\u738B\u671D\u304C\u3042\u306A\u305F\u306E\u8987\u6A29\u3092\u8A8D\u3081\u308B","twoThousand":"\u7D14\u7C8B\u306A\u529B\u306E2000\u30AF\u30EA\u30C3\u30AF\uFF01","quartet":"\u30AF\u30EA\u30C3\u30AF\u56DB\u91CD\u594F\u306E\u4E88\u8A00\u304C\u6210\u5C31\u3057\u305F","transcend":"\u3042\u306A\u305F\u306E\u30AF\u30EA\u30C3\u30AF\u306F\u4EBA\u77E5\u3092\u8D85\u8D8A\u3059\u308B","constellation":"\u30AF\u30EA\u30C3\u30AF\u661F\u5EA7\u304C\u3042\u306A\u305F\u306E\u6804\u8A89\u306E\u305F\u3081\u306B\u6574\u5217\u3059\u308B","destiny":"\u904B\u547D\u306E3000\u30AF\u30EA\u30C3\u30AF","triforce":"\u30C8\u30EA\u30D7\u30EB\u30AF\u30EA\u30C3\u30AF\u30C8\u30E9\u30A4\u30D5\u30A9\u30FC\u30B9\u304C\u76EE\u899A\u3081\u308B\uFF01","fortune":"\u5E78\u904B\u306F\u57F7\u5FF5\u6DF1\u3044\u30AF\u30EA\u30C3\u30AB\u30FC\u306E\u5473\u65B9","newDimensions":"\u3042\u306A\u305F\u306E\u30AF\u30EA\u30C3\u30AF\u529B\u304C\u65B0\u6B21\u5143\u306B\u5230\u9054\u3059\u308B","quartet2":"\u56DB\u91CD\u30AF\u30EA\u30C3\u30AF\u30AB\u30EB\u30C6\u30C3\u30C8\u304C\u8ABF\u548C\u3059\u308B","threshold":"\u30AF\u30EA\u30C3\u30AF\u795E\u6027\u306E\u95BE\u5024\u306B\u7ACB\u3064","ultimate":"\u7A76\u6975\u306E\u529B\u306E5000\u30AF\u30EA\u30C3\u30AF\uFF01","force":"\u4E94\u672C\u6307\u30AF\u30EA\u30C3\u30AF\u30D5\u30A9\u30FC\u30B9\u304C\u3042\u306A\u305F\u306E\u6307\u63EE\u4E0B\u306B","underworld":"\u30AF\u30EA\u30C3\u30AF\u51A5\u754C\u304C\u3042\u306A\u305F\u3092\u652F\u914D\u8005\u3068\u3057\u3066\u6234\u51A0\u3059\u308B","maxJackpot":"\u6700\u5927\u30B8\u30E3\u30C3\u30AF\u30DD\u30C3\u30C8\u30AF\u30EA\u30C3\u30AF\u9054\u6210","infinite":"\u7121\u9650\u306E\u30AF\u30EA\u30C3\u30AF\u30D1\u30EF\u30FC\uFF01","godhood":"\u3042\u306A\u305F\u306F\u30AF\u30EA\u30C3\u30AF\u795E\u6027\u3078\u3068\u6607\u83EF\u3057\u305F","burrow":"\u4ED6\u306E\u3069\u306E\u30A6\u30B5\u30AE\u3088\u308A\u3082\u6DF1\u304F\u6398\u308A\u9032\u3093\u3060...","warren":"\u5927\u3044\u306A\u308B\u30A6\u30B5\u30AE\u306E\u5DE3\u7A74\u304C\u3042\u306A\u305F\u306E\u5B58\u5728\u3092\u8A8D\u3081\u308B...","thump":"\u3042\u306A\u305F\u306E\u8DB3\u306E\u30B9\u30BF\u30F3\u30D7\u3067\u5927\u5730\u304C\u9707\u3048\u308B\uFF01","darkWarren":"\u95C7\u306E\u5DE3\u7A74\u304C\u3042\u306A\u305F\u306E\u305F\u3081\u306B\u9580\u3092\u958B\u304F...","ears":"\u8033\u304C\u3069\u3093\u3069\u3093\u9577\u304F\u306A\u308B...\u5168\u3066\u304C\u805E\u3053\u3048\u308B\u3088\u3046\u306B\u306A\u3063\u305F...","carrotThrone":"\u30CB\u30F3\u30B8\u30F3\u306E\u7389\u5EA7\u304C\u3042\u306A\u305F\u306E\u524D\u306B\u73FE\u308C\u308B...","onesAlignment":"\u5168\u3066\u306E\u4E00\u304C\u63C3\u3046 - \u5DE3\u7A74\u306E\u5468\u6CE2\u6570\u304C\u5171\u9CF4\u3059\u308B\uFF01","moonSummon":"\u6708\u306E\u514E\u304C\u865A\u7A7A\u3092\u8D8A\u3048\u3066\u3042\u306A\u305F\u306E\u547C\u3073\u58F0\u3092\u805E\u304F...","edgeOfForever":"\u6C38\u9060\u306E\u6DF5\u306B\u7ACB\u3064...\u8033\u304C\u30D2\u30AF\u30D2\u30AF\u3068...","beyondTheVeil":"\u30F4\u30A7\u30FC\u30EB\u306E\u5411\u3053\u3046\u5074\u3067\u3001\u5168\u3066\u306E\u5DE3\u7A74\u304C\u3072\u3068\u3064\u306B\u306A\u308B...","sequence":"1-2-3-4-5...\u8056\u306A\u308B\u30DB\u30C3\u30D7\u306E\u914D\u5217\u304C\u5B8C\u6210\u3057\u305F\uFF01","hyperElite":"\u30CF\u30A4\u30D1\u30FC\u30A8\u30EA\u30FC\u30C8\u30D0\u30CB\u30FC\u30B9\u30C6\u30FC\u30BF\u30B9\u89E3\u9664 \uD83D\uDC07\uD83D\uDC07\uD83D\uDC07","eventHorizon":"\u5B87\u5B99\u306E\u30A6\u30B5\u30AE\u306E\u7A74\u306E\u30A4\u30D9\u30F3\u30C8\u30DB\u30E9\u30A4\u30BA\u30F3\u3092\u8D8A\u3048\u3066...","matrixAwakens":"\u5DE3\u7A74\u30DE\u30C8\u30EA\u30C3\u30AF\u30B9\u304C\u30B0\u30EA\u30C3\u30C1...\u73FE\u5B9F\u306E\u88CF\u5074\u306B\u30CB\u30F3\u30B8\u30F3\u304C\u898B\u3048\u308B","luckyForever":"\u5168\u3066\u306E\u8089\u7403\u3001\u5168\u3066\u306E\u30B8\u30E3\u30F3\u30D7\u3001\u5168\u3066\u306E\u30D2\u30AF\u30D2\u30AF...\u6C38\u9060\u306B\u795D\u798F\u3055\u308C\u305F","twentyK":"\u4E8C\u4E07\u3002\u3042\u306A\u305F\u306F\u3082\u306F\u3084\u30A6\u30B5\u30AE\u3067\u306F\u306A\u3044\u3002\u3042\u306A\u305F\u304C\u30A6\u30B5\u30AE\u305D\u306E\u3082\u306E\u3060\u3002","singularity":"\u30D0\u30CB\u30FC\u30FB\u30B7\u30F3\u30AE\u30E5\u30E9\u30EA\u30C6\u30A3\u3002\u5168\u3066\u306E\u30A6\u30B5\u30AE\u306F\u3042\u306A\u305F\u3002\u3042\u306A\u305F\u306F\u5168\u3066\u306E\u30A6\u30B5\u30AE\u3002","tripleAscension":"\u5B87\u5B99\u306E\u30A6\u30B5\u30AE\u306E\u4E09\u91CD\u6607\u5929\uFF01","ultimateAnswer":"42,000 - \u7A76\u6975\u306E\u7B54\u3048\u306F\u6700\u521D\u304B\u3089\u30CB\u30F3\u30B8\u30F3\u3060\u3063\u305F","eternity":"\u267E\uFE0F \u6C38\u9060\u306E\u5DE3\u7A74\u306B\u7D42\u308F\u308A\u306F\u306A\u3044\u3002\u3042\u306A\u305F\u306B\u3082\u3002\u267E\uFE0F"},"powerups":{"bonusPoints":"\uD83E\uDD55 +{{count}} \u30DC\u30FC\u30CA\u30B9\u30DD\u30A4\u30F3\u30C8\uFF01","clickStreak":"\uD83D\uDD25 {{count}}\u9023\u7D9A\u30AF\u30EA\u30C3\u30AF\uFF01","fire":"\uD83D\uDD25 \u30D5\u30A1\u30A4\u30E4\u30FC\u30D1\u30EF\u30FC\u767A\u52D5\uFF01"},"table":{"achievement":"\u5B9F\u7E3E","progress":"\u9032\u6357"},"reset":{"confirm":"\u672C\u5F53\u306B\u5168\u3066\u306E\u9032\u884C\u72B6\u6CC1\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3059\u304B\uFF1F\u3053\u306E\u64CD\u4F5C\u306F\u53D6\u308A\u6D88\u305B\u307E\u305B\u3093\u3002"}}');

});

parcelRegister("iIwbz", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"title":"\uB098\uCE74\uC790\uC640 \uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","description":"\uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","buttons":{"fullscreen":"\uC804\uCCB4 \uD654\uBA74","achievements":"\uC5C5\uC801","reset":"\uCD08\uAE30\uD654","language":"\uC5B8\uC5B4"},"achievements":{"title":"\uC5C5\uC801","noAchievements":"\uC544\uC9C1 \uD68D\uB4DD\uD55C \uC5C5\uC801\uC774 \uC5C6\uC2B5\uB2C8\uB2E4. \uACC4\uC18D \uD074\uB9AD\uD558\uC138\uC694!","unlocked":"\uC5C5\uC801 \uB2EC\uC131: {{message}}","progress":"{{progress}}%","beginner":"\uD83C\uDFAF \uCD08\uBCF4\uC790 \uD1A0\uB07C","carrotSnatcher":"\uD83E\uDD55 \uCC44\uC18C \uB3C4\uB451","bunnyBerserker":"\uD83D\uDE21 \uAD11\uBD84\uD55C \uD1A0\uB07C","hopPunk":"\uD83C\uDFB8 \uC544\uB098\uD0A4\uC2A4\uD2B8 \uD1A0\uB07C","bunnyNinja":"\uD83E\uDD77 \uC870\uC6A9\uD558\uC9C0\uB9CC \uCE58\uBA85\uC801\uC778 \uD1A0\uB07C","expert":"\uD83C\uDF1F \uC804\uBB38 \uC810\uD37C","master":"\uD83D\uDC51 \uB2F9\uADFC\uC655","carrotpocalypse":"\uD83E\uDD55 \uCC44\uC18C\uBC2D \uD30C\uAD34\uC790","bunnyOverlord":"\uD83D\uDE08 \uD1A0\uB07C\uAD74\uC758 \uCD5C\uACE0 \uC9C0\uBC30\uC790","chaosHare":"\uD83C\uDF2A\uFE0F \uD63C\uB3C8\uC758 \uC694\uC6D0","carrotCultist":"\u26EA \uB2F9\uADFC \uAD50\uB2E8\uC758 \uB300\uC81C\uC0AC\uC7A5","bunnyberryPie":"\uD83E\uDD67 \uD658\uAC01 \uD30C\uC774\uC758 \uB2EC\uC778","rabbitHole":"\uD83D\uDD73\uFE0F \uC591\uC790 \uD130\uB110 \uAD74\uCC29\uAE30","moonRabbit":"\uD83C\uDF19 \uB2EC\uD1A0\uB07C","bunnyDoom":"\uD83D\uDC80 \uD1A0\uB07C \uC885\uB9D0\uC758 \uC804\uB839","carrotNuke":"\u2622\uFE0F \uD575\uB2F9\uADFC \uC18C\uC720\uC790","bunnyMatrix":"\uD83E\uDD16 \uD1A0\uB07C \uB9E4\uD2B8\uB9AD\uC2A4\uC758 \uC624\uB958","cosmicHare":"\uD83C\uDF0C \uC6B0\uC8FC \uD1A0\uB07C\uC758 \uAC01\uC131","warrenSingularity":"\uD83D\uDD73\uFE0F \uD1A0\uB07C\uAD74 \uD2B9\uC774\uC810 \uB2EC\uC131","eternalBunny":"\u267E\uFE0F \uC601\uC6D0\uD55C \uD1A0\uB07C"},"messages":{"prophecy":"\uACE0\uB300\uC758 \uD074\uB9AD \uC608\uC5B8\uC774 \uD3BC\uCCD0\uC9C0\uAE30 \uC2DC\uC791\uD569\uB2C8\uB2E4...","cosmic":"\uC6B0\uC8FC\uC758 \uD074\uB9AD\uC2A4\uD130\uB4E4\uC774 \uB2F9\uC2E0\uC758 \uC9C4\uC804\uC744 \uC790\uB791\uC2A4\uB7EC\uC6CC\uD560 \uAC83\uC785\uB2C8\uB2E4!","astral":"\uD074\uB9AD\uC774 \uC544\uC2A4\uD2B8\uB784 \uCC28\uC6D0\uC744 \uC6B8\uB9BD\uB2C8\uB2E4...","speaking":"\uC7A0\uAE50... \uB4E4\uB9AC\uC2DC\uB098\uC694? \uD074\uB9AD\uC774 \uC800\uC5D0\uAC8C \uB9D0\uC744 \uAC78\uACE0 \uC788\uC5B4\uC694...","ancient":"\uB2F9\uC2E0\uC758 \uD074\uB9AD\uC774 \uACE0\uB300\uC758 \uD798\uACFC \uACF5\uBA85\uD569\uB2C8\uB2E4!","sages":"\uD074\uB9AD \uD604\uC790\uB4E4\uC774 \uB2F9\uC2E0\uC758 \uC7A0\uC7AC\uB825\uC744 \uC18D\uC0AD\uC785\uB2C8\uB2E4...","demons":"\uBCF4\uB77C! \uD074\uB9AD \uC545\uB9C8\uB4E4\uC774 \uC7A0\uC5D0\uC11C \uAE68\uC5B4\uB09C\uB2E4!","veil":"\uB2F9\uC2E0\uC758 \uD074\uB9AD\uC774 \uD604\uC2E4\uC758 \uC7A5\uB9C9\uC744 \uAD00\uD1B5\uD569\uB2C8\uB2E4!","spirits":"\uD074\uB9AD\uC758 \uC601\uD63C\uB4E4\uC774 \uB2F9\uC2E0\uC758 \uB9AC\uB4EC\uC5D0 \uB9DE\uCDB0 \uCDA4\uCDA5\uB2C8\uB2E4...","council":"\uC704\uB300\uD55C \uD074\uB9AD \uC758\uD68C\uAC00 \uB2F9\uC2E0\uC758 \uD5CC\uC2E0\uC744 \uC54C\uC544\uCC28\uB838\uC2B5\uB2C8\uB2E4","primordial":"\uB2F9\uC2E0\uC758 \uD074\uB9AD\uC774 \uD0DC\uCD08\uC758 \uD798\uC744 \uAE68\uC6C1\uB2C8\uB2E4!","void":"\uD074\uB9AD\uC758 \uACF5\uD5C8\uAC00 \uB2F9\uC2E0\uC744 \uC751\uC2DC\uD569\uB2C8\uB2E4...","runes":"\uACE0\uB300\uC758 \uD074\uB9AD \uB8EC\uC774 \uB2F9\uC2E0\uC758 \uD798\uC73C\uB85C \uBE5B\uB0A9\uB2C8\uB2E4!","beast":"\uC14B \uC14B \uC14B - \uD074\uB9AD \uAD34\uC218\uC758 \uC22B\uC790","prophets":"\uD074\uB9AD \uC608\uC5B8\uC790\uB4E4\uC774 \uB2F9\uC2E0\uC758 \uB3C4\uB798\uB97C \uB178\uB798\uD569\uB2C8\uB2E4!","dimensions":"\uB2F9\uC2E0\uC758 \uD074\uB9AD\uC774 \uCC28\uC6D0\uC744 \uAD00\uD1B5\uD558\uC5EC \uC6B8\uB9BD\uB2C8\uB2E4...","portal":"\uB2F9\uC2E0\uC758 \uD074\uB9AD\uC774 \uD074\uB9AD \uCC28\uC6D0\uC73C\uB85C \uAC00\uB294 \uD3EC\uD138\uC744 \uC5F4\uC5C8\uC2B5\uB2C8\uB2E4!","sacrifice":"\uACE0\uB300\uC758 \uD074\uB9AD \uC2E0\uB4E4\uC774 \uB354 \uB9CE\uC740 \uD76C\uC0DD\uC744 \uC694\uAD6C\uD569\uB2C8\uB2E4","jackpot":"\uC7AD\uD31F! \uD074\uB9AD \uCE74\uC9C0\uB178\uAC00 \uC0C8\uB85C\uC6B4 \uCC54\uD53C\uC5B8\uC744 \uD658\uC601\uD569\uB2C8\uB2E4!","unmatched":"\uB2F9\uC2E0\uC758 \uD074\uB9AD \uD30C\uC6CC\uB294 \uBE44\uD560 \uB370\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4!","reality":"\uD604\uC2E4 \uC790\uCCB4\uAC00 \uB2F9\uC2E0\uC758 \uD074\uB9AD \uC758\uC9C0\uC5D0 \uAD74\uBCF5\uD569\uB2C8\uB2E4!","elite":"\uB2F9\uC2E0\uC740 \uC5D8\uB9AC\uD2B8 \uD074\uB9AD \uB9C8\uC2A4\uD130\uAC00 \uB418\uC5C8\uC2B5\uB2C8\uB2E4","power":"\uB2F9\uC2E0\uC758 \uD074\uB9AD \uD30C\uC6CC \uB808\uBCA8\uC774 1500\uC744 \uB118\uC5C8\uC2B5\uB2C8\uB2E4!","devils":"\uD074\uB9AD \uC545\uB9C8\uB4E4\uC774 \uB2F9\uC2E0\uC758 \uD798 \uC55E\uC5D0 \uBB34\uB98E \uAFC7\uC2B5\uB2C8\uB2E4","lucky":"\uD589\uC6B4\uC758 \uD074\uB9AD\uC774 \uB2F9\uC2E0\uC758 \uD54F\uC904\uC744 \uD0C0\uACE0 \uD750\uB985\uB2C8\uB2E4","dynasty":"\uD074\uB9AD \uC655\uC870\uAC00 \uB2F9\uC2E0\uC758 \uD328\uAD8C\uC744 \uC778\uC815\uD569\uB2C8\uB2E4","twoThousand":"\uC21C\uC218\uD55C \uD798\uC758 \uC774\uCC9C \uBC88\uC9F8 \uD074\uB9AD!","quartet":"\uD074\uB9AD 4\uC911\uC8FC\uC758 \uC608\uC5B8\uC774 \uC2E4\uD604\uB418\uC5C8\uC2B5\uB2C8\uB2E4","transcend":"\uB2F9\uC2E0\uC758 \uD074\uB9AD\uC774 \uD544\uBA78\uC790\uC758 \uC774\uD574\uB97C \uCD08\uC6D4\uD569\uB2C8\uB2E4","constellation":"\uD074\uB9AD \uBCC4\uC790\uB9AC\uAC00 \uB2F9\uC2E0\uC744 \uAE30\uB9AC\uBA70 \uC815\uB82C\uD569\uB2C8\uB2E4","destiny":"\uC6B4\uBA85\uC758 \uC0BC\uCC9C \uBC88\uC9F8 \uD074\uB9AD","triforce":"\uC0BC\uC911 \uD074\uB9AD\uC758 \uD2B8\uB77C\uC774\uD3EC\uC2A4\uAC00 \uAE68\uC5B4\uB0A9\uB2C8\uB2E4!","fortune":"\uD589\uC6B4\uC740 \uB048\uAE30 \uC788\uB294 \uD074\uB9AC\uCEE4\uC758 \uD3B8","newDimensions":"\uB2F9\uC2E0\uC758 \uD074\uB9AD \uD30C\uC6CC\uAC00 \uC0C8\uB85C\uC6B4 \uCC28\uC6D0\uC5D0 \uB3C4\uB2EC\uD569\uB2C8\uB2E4","quartet2":"4\uC911 \uD074\uB9AD \uCF70\uB974\uD15F\uC774 \uC870\uD654\uB97C \uC774\uB8F9\uB2C8\uB2E4","threshold":"\uD074\uB9AD \uC2E0\uC131\uC758 \uBB38\uD131\uC5D0 \uC11C \uC788\uC2B5\uB2C8\uB2E4","ultimate":"\uAD81\uADF9\uC758 \uD798, \uC624\uCC9C \uBC88\uC9F8 \uD074\uB9AD!","force":"\uC624\uC218 \uD074\uB9AD \uD3EC\uC2A4\uAC00 \uB2F9\uC2E0\uC758 \uBA85\uB839\uC744 \uB530\uB985\uB2C8\uB2E4","underworld":"\uD074\uB9AD \uC9C0\uD558\uC138\uACC4\uAC00 \uB2F9\uC2E0\uC744 \uADF8\uB4E4\uC758 \uD1B5\uCE58\uC790\uB85C \uCD94\uB300\uD569\uB2C8\uB2E4","maxJackpot":"\uCD5C\uB300 \uC7AD\uD31F \uD074\uB9AD \uB2EC\uC131","infinite":"\uBB34\uD55C\uD55C \uD074\uB9AD\uC758 \uD798!","godhood":"\uB2F9\uC2E0\uC740 \uD074\uB9AD\uC758 \uC2E0\uACA9\uC5D0 \uC62C\uB790\uC2B5\uB2C8\uB2E4","burrow":"\uADF8 \uC5B4\uB5A4 \uD1A0\uB07C\uBCF4\uB2E4 \uB354 \uAE4A\uC774 \uD30C\uACE0\uB4E4\uC5C8\uB2E4...","warren":"\uC704\uB300\uD55C \uD1A0\uB07C\uAD74\uC774 \uB2F9\uC2E0\uC758 \uC874\uC7AC\uB97C \uC778\uC815\uD569\uB2C8\uB2E4...","thump":"\uB2F9\uC2E0\uC758 \uBC1C\uC744 \uAD6C\uB97C \uB54C\uB9C8\uB2E4 \uB300\uC9C0\uAC00 \uC9C4\uB3D9\uD569\uB2C8\uB2E4!","darkWarren":"\uC5B4\uB460\uC758 \uD1A0\uB07C\uAD74\uC774 \uB2F9\uC2E0\uC744 \uC704\uD574 \uBB38\uC744 \uC5FD\uB2C8\uB2E4...","ears":"\uADC0\uAC00 \uC810\uC810 \uAE38\uC5B4\uC9C4\uB2E4... \uC774\uC81C \uBAA8\uB4E0 \uAC83\uC774 \uB4E4\uB9B0\uB2E4...","carrotThrone":"\uB2F9\uADFC \uC655\uC88C\uAC00 \uB2F9\uC2E0 \uC55E\uC5D0 \uB098\uD0C0\uB0A9\uB2C8\uB2E4...","onesAlignment":"\uBAA8\uB4E0 \uC77C\uC774 \uC815\uB82C\uB429\uB2C8\uB2E4 - \uD1A0\uB07C\uAD74 \uC8FC\uD30C\uC218\uAC00 \uACF5\uBA85\uD569\uB2C8\uB2E4!","moonSummon":"\uB2EC\uD1A0\uB07C\uAC00 \uD5C8\uACF5\uC744 \uB118\uC5B4 \uB2F9\uC2E0\uC758 \uBD80\uB984\uC744 \uB4E3\uC2B5\uB2C8\uB2E4...","edgeOfForever":"\uC601\uC6D0\uC758 \uAC00\uC7A5\uC790\uB9AC\uC5D0 \uC11C \uC788\uC2B5\uB2C8\uB2E4... \uADC0\uAC00 \uB5A8\uB9AC\uBA70...","beyondTheVeil":"\uC7A5\uB9C9 \uB108\uBA38, \uBAA8\uB4E0 \uD1A0\uB07C\uAD74\uC774 \uD558\uB098\uAC00 \uB429\uB2C8\uB2E4...","sequence":"1-2-3-4-5... \uC2E0\uC131\uD55C \uD638\uD551 \uC2DC\uD000\uC2A4\uAC00 \uC644\uC131\uB418\uC5C8\uC2B5\uB2C8\uB2E4!","hyperElite":"\uD558\uC774\uD37C \uC5D8\uB9AC\uD2B8 \uD1A0\uB07C \uC0C1\uD0DC \uD574\uC81C \uD83D\uDC07\uD83D\uDC07\uD83D\uDC07","eventHorizon":"\uC6B0\uC8FC \uD1A0\uB07C\uAD74\uC758 \uC0AC\uAC74\uC758 \uC9C0\uD3C9\uC120\uC744 \uB118\uC5B4\uC11C...","matrixAwakens":"\uD1A0\uB07C\uAD74 \uB9E4\uD2B8\uB9AD\uC2A4\uC5D0 \uAE00\uB9AC\uCE58... \uD604\uC2E4 \uB4A4\uC758 \uB2F9\uADFC\uC774 \uBCF4\uC778\uB2E4","luckyForever":"\uBAA8\uB4E0 \uBC1C, \uBAA8\uB4E0 \uB3C4\uC57D, \uBAA8\uB4E0 \uB5A8\uB9BC... \uC601\uC6D0\uD788 \uCD95\uBCF5\uBC1B\uB2E4","twentyK":"\uC774\uB9CC. \uB2F9\uC2E0\uC740 \uB354 \uC774\uC0C1 \uD1A0\uB07C\uAC00 \uC544\uB2D9\uB2C8\uB2E4. \uB2F9\uC2E0\uC774 \uBC14\uB85C \uADF8 \uD1A0\uB07C\uC785\uB2C8\uB2E4.","singularity":"\uD1A0\uB07C \uD2B9\uC774\uC810. \uBAA8\uB4E0 \uD1A0\uB07C\uB294 \uB2F9\uC2E0\uC774\uB2E4. \uB2F9\uC2E0\uC740 \uBAA8\uB4E0 \uD1A0\uB07C\uB2E4.","tripleAscension":"\uC6B0\uC8FC \uD1A0\uB07C\uC758 \uC0BC\uC911 \uC2B9\uCC9C!","ultimateAnswer":"42,000 - \uAD81\uADF9\uC758 \uB2F5\uC740 \uCC98\uC74C\uBD80\uD130 \uB2F9\uADFC\uC774\uC5C8\uB2E4","eternity":"\u267E\uFE0F \uC601\uC6D0\uD55C \uD1A0\uB07C\uAD74\uC5D0\uB294 \uB05D\uC774 \uC5C6\uB2E4. \uB2F9\uC2E0\uB3C4 \uB9C8\uCC2C\uAC00\uC9C0. \u267E\uFE0F"},"powerups":{"bonusPoints":"\uD83E\uDD55 +{{count}} \uBCF4\uB108\uC2A4 \uD3EC\uC778\uD2B8!","clickStreak":"\uD83D\uDD25 {{count}}\uBC88 \uC5F0\uC18D \uD074\uB9AD!","fire":"\uD83D\uDD25 \uD30C\uC774\uC5B4 \uD30C\uC6CC \uBC1C\uB3D9!"},"table":{"achievement":"\uC5C5\uC801","progress":"\uC9C4\uD589\uB3C4"},"reset":{"confirm":"\uBAA8\uB4E0 \uC9C4\uD589 \uC0C1\uD669\uC744 \uCD08\uAE30\uD654\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C? \uC774 \uC791\uC5C5\uC740 \uCDE8\uC18C\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."}}');

});

parcelRegister("g6Gro", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"title":"PIRATE \uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","description":"\uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","buttons":{"fullscreen":"Full Sails","achievements":"Treasures","reset":"Abandon Ship"},"messages":{"prophecy":"Arr, the ancient clickin\' prophecy starts to unfold, ye scurvy dog!","cosmic":"Shiver me timbers, the cosmic clickin\' crew be proud of yer progress!","astral":"The clickin\' echoes through the seven seas of the astral plane...","speaking":"Blimey! Did ye hear that? The clicks be speakin\' to me...","ancient":"Yer clickin\' resonates with the power of Davy Jones himself!","sages":"The Click Sages whisper tales of yer potential, ye swab...","demons":"BEHOLD! The Click Demons rise from the briny deep!","veil":"Yer clicks pierce the veil like a cutlass through sail!","spirits":"The Click Spirits dance a jolly sailor\'s jig to yer rhythm...","council":"The Grand Click Council of Pirates has noticed yer dedication","primordial":"Yer clickin\' awakens forces from the bottom of the sea!","void":"The clickin\' void stares back at ye like a hungry kraken...","runes":"Ancient pirate click runes glow with yer power!","beast":"THREE THREE THREE - THE NUMBER OF THE CLICK BEAST, YE SCALLYWAG","prophets":"The Click Prophets sing shanties of yer coming!","dimensions":"Yer clicks echo through the seven dimensional seas...","portal":"Yer clicks have opened a portal to Tortuga!","sacrifice":"The ancient Click Gods demand MORE PLUNDER","jackpot":"TREASURE FOUND! The Click Casino welcomes its newest buccaneer!","unmatched":"\u4F60\u7684\u70B9\u51FB\u529B\u91CF\u65E0\u4EBA\u80FD\u53CA! (Yer clickin\' power be unmatched, ye sea dog!)","reality":"Reality itself bends to yer clickin\' like a ship in a storm!","elite":"YE BE THE ELITE CLICK CAPTAIN NOW","power":"Yer clickin\' power level be over 1500 doubloons!","devils":"The Click Devils bow before yer mighty cutlass","lucky":"Lucky clicks flow through yer veins like rum","dynasty":"The Click Dynasty recognizes ye as the Pirate King","twoThousand":"Two thousand clicks of pure pirate power!","quartet":"The prophecy of the Click Shanty Quartet be fulfilled","transcend":"Yer clickin\' transcends mortal understanding, by thunder!","constellation":"The Click Stars align to guide yer ship","destiny":"THREE THOUSAND CLICKS OF PIRATE DESTINY","triforce":"The Triple Click Trident awakens!","fortune":"Fortune favors the bold clicker of the seas","newDimensions":"Yer clickin\' power reaches new oceans","quartet2":"The Quadruple Click Shanty crew harmonizes","threshold":"Standing at the helm of click divinity","ultimate":"FIVE THOUSAND CLICKS OF ULTIMATE PIRATE POWER!","force":"The Five Fingered Click Force be yours to command","underworld":"The Click Underworld crowns ye their Pirate King","maxJackpot":"MAXIMUM TREASURE CLICKING ACHIEVED","infinite":"\u65E0\u9650\u70B9\u51FB\u529B\u91CF! (INFINITE PIRATE CLICKING POWER!)","godhood":"YE HAVE ASCENDED TO CLICK PIRATE GODHOOD","burrow":"Ye\'ve dug deeper than any rabbit what ever sailed the seven seas...","warren":"The Grand Warren recognizes ye as a proper captain...","thump":"The deck shakes with every stomp of yer peg leg!","darkWarren":"The Dark Warren opens its skull-and-crossbones gates fer ye...","ears":"Yer ears grow longer... ye can hear every whisper on the wind...","carrotThrone":"The Carrot Throne rises from the briny deep before ye...","onesAlignment":"All ones align - the Warren\'s Signal Flags wave in harmony!","moonSummon":"The Moon Rabbit hears yer shanty across the void...","edgeOfForever":"Ye stand at the edge of forever... ears twitchin\' like a compass needle...","beyondTheVeil":"Beyond the fog, all warrens become one mighty fleet...","sequence":"1-2-3-4-5... The Sacred Hop Shanty be complete!","hyperElite":"HYPER ELITE PIRATE BUNNY STATUS UNLOCKED \uD83D\uDC07\uD83D\uDC07\uD83D\uDC07","eventHorizon":"Past the edge of the map where sea monsters dwell...","matrixAwakens":"The Warren Matrix glitches... ye see the carrots behind the sea chart","luckyForever":"Every paw, every hop, every twitch of yer whiskers... blessed by the sea forever","twentyK":"TWENTY THOUSAND LEAGUES. Ye be no longer a bunny. Ye be THE bunny captain.","singularity":"The Pirate Bunny Singularity. All rabbits sail under yer flag. Ye be every rabbit.","tripleAscension":"The Triple Ascension of the Cosmic Hare! All hands on deck!","ultimateAnswer":"42,000 doubloons - The Ultimate Answer was carrots all along, ye scallywag","eternity":"\u267E\uFE0F THE ETERNAL WARREN HAS NO PORT OF CALL. NEITHER DO YE. \u267E\uFE0F"},"achievements":{"title":"Treasures","noAchievements":"No booty plundered yet. Keep clickin\', ye scurvy dog!","unlocked":"Treasure Found: {{message}}","progress":"{{progress}}%","beginner":"\uD83C\uDFAF Landlubber Bunny","carrotSnatcher":"\uD83E\uDD55 Vegetable Pillager","bunnyBerserker":"\uD83D\uDE21 Mad Sea Dog\'s Rampage","hopPunk":"\uD83C\uDFB8 Mutinous Cottontail","bunnyNinja":"\uD83E\uDD77 Silent but Deadly Buccaneer","expert":"\uD83C\uDF1F Seasoned Sailor","master":"\uD83D\uDC51 Captain of the Carrots","carrotpocalypse":"\uD83E\uDD55 Scourge of the Garden Seas","bunnyOverlord":"\uD83D\uDE08 Admiral of the Warren","chaosHare":"\uD83C\uDF2A\uFE0F Storm Bringer of the Seven Seas","carrotCultist":"\u26EA High Priest of Davy Jones\' Locker","bunnyberryPie":"\uD83E\uDD67 Ship\'s Cook of Madness","rabbitHole":"\uD83D\uDD73\uFE0F Black Hole Digger","moonRabbit":"\uD83C\uDF19 Navigator of the Starlit Seas","bunnyDoom":"\uD83D\uDC80 Herald of the Rabbit\'s Revenge","carrotNuke":"\u2622\uFE0F Master of the Carrot Cannon","bunnyMatrix":"\uD83E\uDD16 Ghost in the Ship\'s Matrix","cosmicHare":"\uD83C\uDF0C The Cosmic Sea Hare Awakens","warrenSingularity":"\uD83D\uDD73\uFE0F Warren Singularity Achieved, Captain","eternalBunny":"\u267E\uFE0F The Eternal Buccaneer Bunny"},"powerups":{"bonusPoints":"\uD83E\uDD55 +{{count}} Extra Doubloons!","clickStreak":"\uD83D\uDD25 {{count}} Click Streak, Ye Scurvy Dog!","fire":"\uD83D\uDD25 Cannon Fire Power Ready!"},"table":{"achievement":"Plunder","progress":"Distance Sailed"},"reset":{"confirm":"Arr ye sure ye want to scuttle all yer progress? There be no gettin\' it back once it\'s gone to Davy Jones\' locker!"}}');

});

parcelRegister("l7Wqg", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"title":"nakazawa \uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","description":"\uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","buttons":{"fullscreen":"Pe\u0142ny ekran","achievements":"Osi\u0105gni\u0119cia","reset":"Reset","language":"J\u0119zyk"},"achievements":{"title":"Osi\u0105gni\u0119cia","noAchievements":"Brak osi\u0105gni\u0119\u0107. Klikaj dalej!","unlocked":"Odblokowano osi\u0105gni\u0119cie: {{message}}","progress":"{{progress}}%","beginner":"\uD83C\uDFAF Kr\xf3lik Pocz\u0105tkuj\u0105cy","carrotSnatcher":"\uD83E\uDD55 Z\u0142odziej Warzyw","bunnyBerserker":"\uD83D\uDE21 W\u015Bciek\u0142y Kr\xf3lik","hopPunk":"\uD83C\uDFB8 Kr\xf3lik Anarchista","bunnyNinja":"\uD83E\uDD77 Cichy ale \u015Amiertelny","expert":"\uD83C\uDF1F Ekspert Skok\xf3w","master":"\uD83D\uDC51 Kr\xf3l Marchewek","carrotpocalypse":"\uD83E\uDD55 Niszczyciel Ogrod\xf3w","bunnyOverlord":"\uD83D\uDE08 Najwy\u017Cszy W\u0142adca Kr\xf3liczej Nory","chaosHare":"\uD83C\uDF2A\uFE0F Agent Chaosu","carrotCultist":"\u26EA Najwy\u017Cszy Kap\u0142an Kultu Marchewki","bunnyberryPie":"\uD83E\uDD67 Mistrz Halucynogennych Ciast","rabbitHole":"\uD83D\uDD73\uFE0F Kopacz Kwantowych Tuneli","moonRabbit":"\uD83C\uDF19 Ksi\u0119\u017Cycowy Kr\xf3lik","bunnyDoom":"\uD83D\uDC80 Zwiastun Kr\xf3liczej Apokalipsy","carrotNuke":"\u2622\uFE0F Posiadacz Nuklearnej Marchewki","bunnyMatrix":"\uD83E\uDD16 B\u0142\u0105d w Kr\xf3liczym Matriksie","cosmicHare":"\uD83C\uDF0C Kosmiczny Zaj\u0105c si\u0119 Budzi","warrenSingularity":"\uD83D\uDD73\uFE0F Osobliwo\u015B\u0107 Nory Osi\u0105gni\u0119ta","eternalBunny":"\u267E\uFE0F Wieczny Kr\xf3lik"},"messages":{"prophecy":"Staro\u017Cytna przepowiednia klikania zaczyna si\u0119 spe\u0142nia\u0107...","cosmic":"Kosmiczni klikacze byliby dumni z twojego post\u0119pu!","astral":"Klikanie odbija si\u0119 echem w astralnej p\u0142aszczy\u017Anie...","speaking":"Czekaj... s\u0142ysza\u0142e\u015B to? Klikni\u0119cia m\xf3wi\u0105 do mnie...","ancient":"Twoje klikanie rezonuje ze staro\u017Cytn\u0105 moc\u0105!","sages":"M\u0119drcy Klikania szepcz\u0105 o twoim potencjale...","demons":"SP\xd3JRZ! Demony Klikania budz\u0105 si\u0119 ze snu!","veil":"Twoje klikni\u0119cia przebijaj\u0105 zas\u0142on\u0119 rzeczywisto\u015Bci!","spirits":"Duchy Klikania ta\u0144cz\u0105 w twoim rytmie...","council":"Wielka Rada Klikania zauwa\u017Cy\u0142a twoje oddanie","primordial":"Twoje klikanie budzi pierwotne si\u0142y!","void":"Pustka klikania spogl\u0105da na ciebie...","runes":"Staro\u017Cytne runy klikania \u015Bwiec\u0105 twoj\u0105 moc\u0105!","beast":"TRZY TRZY TRZY - LICZBA BESTII KLIKANIA","prophets":"Prorocy Klikania \u015Bpiewaj\u0105 o twoim nadej\u015Bciu!","dimensions":"Twoje klikni\u0119cia odbijaj\u0105 si\u0119 echem przez wymiary...","portal":"Twoje klikni\u0119cia otworzy\u0142y portal do Wymiaru Klikania!","sacrifice":"Staro\u017Cytni Bogowie Klikania \u017C\u0105daj\u0105 WI\u0118CEJ OFIAR","jackpot":"JACKPOT! Kasyno Klikania wita swojego nowego mistrza!","unmatched":"\u4F60\u7684\u70B9\u51FB\u529B\u91CF\u65E0\u4EBA\u80FD\u53CA! (Twoja moc klikania jest niezr\xf3wnana!)","reality":"Sama rzeczywisto\u015B\u0107 ugina si\u0119 pod twoj\u0105 wol\u0105 klikania!","elite":"STA\u0141E\u015A SI\u0118 ELITARNYM MISTRZEM KLIKANIA","power":"Tw\xf3j poziom mocy klikania przekracza 1500!","devils":"Diab\u0142y Klikania k\u0142aniaj\u0105 si\u0119 twojej pot\u0119dze","lucky":"Szcz\u0119\u015Bliwe klikni\u0119cia p\u0142yn\u0105 w twoich \u017Cy\u0142ach","dynasty":"Dynastia Klikania uznaje twoj\u0105 supremacj\u0119","twoThousand":"Dwa tysi\u0105ce klikni\u0119\u0107 czystej mocy!","transcend":"Twoje klikanie przekracza \u015Bmiertelne pojmowanie","constellation":"Konstelacja Klikania uk\u0142ada si\u0119 na twoj\u0105 cze\u015B\u0107","destiny":"TRZY TYSI\u0104CE KLIKNI\u0118\u0106 PRZEZNACZENIA","triforce":"Potr\xf3jna Moc Klikania budzi si\u0119!","fortune":"Fortuna sprzyja wytrwa\u0142ym klikaczom","newDimensions":"Twoja moc klikania si\u0119ga nowych wymiar\xf3w","quartet":"Kwartet Poczw\xf3rnego Klikania harmonizuje","threshold":"Stoisz na progu bosko\u015Bci klikania","ultimate":"PI\u0118\u0106 TYSI\u0118CY KLIKNI\u0118\u0106 OSTATECZNEJ MOCY!","force":"Pi\u0119ciopalczasta Si\u0142a Klikania jest na twoje rozkazy","underworld":"Podziemny \u015Awiat Klikania koronuje ci\u0119 na w\u0142adc\u0119","maxJackpot":"OSI\u0104GNI\u0118TO MAKSYMALNY JACKPOT KLIKANIA","infinite":"\u65E0\u9650\u70B9\u51FB\u529B\u91CF! (NIESKO\u0143CZONA MOC KLIKANIA!)","godhood":"WZNIOS\u0141E\u015A SI\u0118 DO RANGI BOGA KLIKANIA","burrow":"Kopa\u0142e\u015B g\u0142\u0119biej ni\u017C jakikolwiek kr\xf3lik przed tob\u0105...","warren":"Wielka Nora rozpoznaje twoj\u0105 obecno\u015B\u0107...","thump":"Ziemia dr\u017Cy przy ka\u017Cdym tupni\u0119ciu twojej \u0142apki!","darkWarren":"Mroczna Nora otwiera dla ciebie swoje bramy...","ears":"Twoje uszy rosn\u0105... teraz s\u0142yszysz wszystko...","carrotThrone":"Tron Marchewkowy materializuje si\u0119 przed tob\u0105...","onesAlignment":"Wszystkie jedynki si\u0119 wyr\xf3wnuj\u0105 - Cz\u0119stotliwo\u015B\u0107 Nory rezonuje!","moonSummon":"Ksi\u0119\u017Cycowy Kr\xf3lik s\u0142yszy twoje wo\u0142anie przez pustk\u0119...","edgeOfForever":"Stoisz na kraw\u0119dzi wieczno\u015Bci... uszy drgaj\u0105...","beyondTheVeil":"Za zas\u0142on\u0105, wszystkie nory staj\u0105 si\u0119 jedn\u0105...","sequence":"1-2-3-4-5... \u015Awi\u0119ta Sekwencja Skok\xf3w jest kompletna!","hyperElite":"HIPER ELITARNY STATUS KR\xd3LIKA ODBLOKOWANY \uD83D\uDC07\uD83D\uDC07\uD83D\uDC07","eventHorizon":"Za horyzontem zdarze\u0144 Kosmicznej Kr\xf3liczej Nory...","matrixAwakens":"Matrix Nory glitchuje... widzisz marchewki za rzeczywisto\u015Bci\u0105","luckyForever":"Ka\u017Cda \u0142apka, ka\u017Cdy skok, ka\u017Cde drgni\u0119cie... pob\u0142ogos\u0142awione na wieki","twentyK":"DWADZIE\u015ACIA TYSI\u0118CY. Nie jeste\u015B ju\u017C kr\xf3likiem. Jeste\u015B TYM kr\xf3likiem.","singularity":"Kr\xf3licza Osobliwo\u015B\u0107. Wszystkie kr\xf3liki to ty. Ty jeste\u015B wszystkimi kr\xf3likami.","tripleAscension":"Potr\xf3jne Wniebowst\u0105pienie Kosmicznego Zaj\u0105ca!","ultimateAnswer":"42 000 - Ostateczna Odpowied\u017A to od zawsze by\u0142y marchewki","eternity":"\u267E\uFE0F WIECZNA NORA NIE MA KO\u0143CA. TY R\xd3WNIE\u017B NIE. \u267E\uFE0F"},"powerups":{"bonusPoints":"\uD83E\uDD55 +{{count}} Punkt\xf3w Bonusowych!","clickStreak":"\uD83D\uDD25 {{count}} Klikni\u0119\u0107 pod Rz\u0105d!","fire":"\uD83D\uDD25 Moc Ognia Aktywowana!"},"table":{"achievement":"Osi\u0105gni\u0119cie","progress":"Post\u0119p"},"reset":{"confirm":"Czy na pewno chcesz zresetowa\u0107 ca\u0142y post\u0119p? Tej operacji nie mo\u017Cna cofn\u0105\u0107."}}');

});

parcelRegister("ekvVh", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"title":"nakazawa \uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","description":"\uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","buttons":{"fullscreen":"Tela Cheia","achievements":"Conquistas","reset":"Reiniciar","language":"Idioma"},"achievements":{"title":"Conquistas","noAchievements":"Nenhuma conquista ainda. Continue clicando!","unlocked":"Conquista Desbloqueada: {{message}}","progress":"{{progress}}%","beginner":"\uD83C\uDFAF Coelho Iniciante","carrotSnatcher":"\uD83E\uDD55 Ladr\xe3o de Vegetais","bunnyBerserker":"\uD83D\uDE21 Coelho Furioso","hopPunk":"\uD83C\uDFB8 Coelho Anarquista","bunnyNinja":"\uD83E\uDD77 Silencioso mas Mortal","expert":"\uD83C\uDF1F Saltador Especialista","master":"\uD83D\uDC51 Rei da Cenoura","carrotpocalypse":"\uD83E\uDD55 Destruidor de Hortas","bunnyOverlord":"\uD83D\uDE08 L\xedder Supremo da Toca","chaosHare":"\uD83C\uDF2A\uFE0F Agente do Caos","carrotCultist":"\u26EA Sumo Sacerdote do Culto da Cenoura","bunnyberryPie":"\uD83E\uDD67 Mestre da Torta Alucin\xf3gena","rabbitHole":"\uD83D\uDD73\uFE0F Escavador de T\xfaneis Qu\xe2nticos","moonRabbit":"\uD83C\uDF19 Coelho Lunar","bunnyDoom":"\uD83D\uDC80 Arauto do Coelhocalipse","carrotNuke":"\u2622\uFE0F Portador da Cenoura Nuclear","bunnyMatrix":"\uD83E\uDD16 Falha na Matriz dos Coelhos","cosmicHare":"\uD83C\uDF0C A Lebre C\xf3smica Desperta","warrenSingularity":"\uD83D\uDD73\uFE0F Singularidade da Toca Alcan\xe7ada","eternalBunny":"\u267E\uFE0F O Coelho Eterno"},"messages":{"prophecy":"A antiga profecia dos cliques come\xe7a a se revelar...","cosmic":"Os clicadores c\xf3smicos ficariam orgulhosos do seu progresso!","astral":"Os cliques ecoam pelo plano astral...","speaking":"Espera... voc\xea ouviu isso? Os cliques est\xe3o falando comigo...","ancient":"Seus cliques ressoam com poder ancestral!","sages":"Os S\xe1bios do Clique sussurram sobre seu potencial...","demons":"CONTEMPLEM! Os Dem\xf4nios do Clique despertam de seu sono!","veil":"Seus cliques atravessam o v\xe9u da realidade!","spirits":"Os Esp\xedritos do Clique dan\xe7am ao seu ritmo...","council":"O Grande Conselho do Clique notou sua dedica\xe7\xe3o","primordial":"Seus cliques despertam for\xe7as primordiais!","void":"O vazio dos cliques olha de volta para voc\xea...","runes":"Antigas runas de clique brilham com seu poder!","beast":"TR\xcaS TR\xcaS TR\xcaS - O N\xdaMERO DA BESTA DO CLIQUE","prophets":"Os Profetas do Clique cantam sobre sua vinda!","dimensions":"Seus cliques ecoam atrav\xe9s das dimens\xf5es...","portal":"Seus cliques abriram um portal para a Dimens\xe3o do Clique!","sacrifice":"Os antigos Deuses do Clique exigem MAIS SACRIF\xcdCIO","jackpot":"JACKPOT! O Cassino do Clique recebe seu mais novo campe\xe3o!","unmatched":"Seu poder de clique \xe9 incompar\xe1vel!","reality":"A pr\xf3pria realidade se curva \xe0 sua vontade de clicar!","elite":"VOC\xca SE TORNOU O MESTRE ELITE DO CLIQUE","power":"Seu n\xedvel de poder de clique est\xe1 acima de 1500!","devils":"Os Dem\xf4nios do Clique se curvam diante de seu poder","lucky":"Cliques sortudos fluem por suas veias","dynasty":"A Dinastia do Clique reconhece sua supremacia","twoThousand":"Dois mil cliques de puro poder!","quartet":"A profecia do Quarteto do Clique foi cumprida","transcend":"Seus cliques transcendem o entendimento mortal","constellation":"A Constela\xe7\xe3o do Clique se alinha em sua honra","destiny":"TR\xcaS MIL CLIQUES DO DESTINO","triforce":"A Triforce Tripla do Clique desperta!","fortune":"A fortuna favorece o clicador persistente","newDimensions":"Seu poder de clique alcan\xe7a novas dimens\xf5es","quartet2":"O Quarteto Qu\xe1druplo do Clique harmoniza","threshold":"De p\xe9 no limiar da divindade do clique","ultimate":"CINCO MIL CLIQUES DE PODER SUPREMO!","force":"A For\xe7a dos Cinco Dedos do Clique est\xe1 sob seu comando","underworld":"O Submundo do Clique o coroa como seu governante","maxJackpot":"JACKPOT M\xc1XIMO DE CLIQUES ALCAN\xc7ADO","infinite":"PODER DE CLIQUE INFINITO!","godhood":"VOC\xca ASCENDEU \xc0 DIVINDADE DO CLIQUE","burrow":"Voc\xea cavou mais fundo do que qualquer coelho antes...","warren":"A Grande Toca reconhece sua presen\xe7a...","thump":"A terra treme a cada batida do seu p\xe9!","darkWarren":"A Toca Sombria abre seus port\xf5es para voc\xea...","ears":"Suas orelhas ficam mais longas... agora voc\xea pode ouvir tudo...","carrotThrone":"O Trono de Cenoura se materializa diante de voc\xea...","onesAlignment":"Todos os uns se alinham - a Frequ\xeancia da Toca ressoa!","moonSummon":"O Coelho Lunar ouve seu chamado atrav\xe9s do vazio...","edgeOfForever":"Voc\xea est\xe1 \xe0 beira da eternidade... orelhas tremendo...","beyondTheVeil":"Al\xe9m do v\xe9u, todas as tocas se tornam uma...","sequence":"1-2-3-4-5... A Sequ\xeancia Sagrada do Salto est\xe1 completa!","hyperElite":"STATUS HIPER ELITE DESBLOQUEADO \uD83D\uDC07\uD83D\uDC07\uD83D\uDC07","eventHorizon":"Al\xe9m do horizonte de eventos da Toca C\xf3smica...","matrixAwakens":"A Matrix da Toca falha... voc\xea v\xea as cenouras por tr\xe1s da realidade","luckyForever":"Cada pata, cada salto, cada tremor... aben\xe7oado para sempre","twentyK":"VINTE MIL. Voc\xea n\xe3o \xe9 mais um coelho. Voc\xea \xe9 O coelho.","singularity":"A Singularidade Coelhesca. Todos os coelhos s\xe3o voc\xea. Voc\xea \xe9 todos os coelhos.","tripleAscension":"A Tripla Ascens\xe3o da Lebre C\xf3smica!","ultimateAnswer":"42.000 - A Resposta Definitiva sempre foram cenouras","eternity":"\u267E\uFE0F A TOCA ETERNA N\xc3O TEM FIM. NEM VOC\xca. \u267E\uFE0F"},"powerups":{"bonusPoints":"\uD83E\uDD55 +{{count}} Pontos B\xf4nus!","clickStreak":"\uD83D\uDD25 {{count}} Cliques Seguidos!","fire":"\uD83D\uDD25 Poder de Fogo Ativado!"},"table":{"achievement":"Conquista","progress":"Progresso"},"reset":{"confirm":"Tem certeza que deseja reiniciar todo o progresso? Isso n\xe3o pode ser desfeito."}}');

});

parcelRegister("h4Lbe", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"title":"\u4E2D\u6FA4 \uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","description":"\uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","buttons":{"fullscreen":"\u5168\u87A2\u5E55","achievements":"\u6210\u5C31","reset":"\u91CD\u7F6E","language":"\u8A9E\u8A00"},"achievements":{"title":"\u6210\u5C31","noAchievements":"\u9084\u6C92\u6709\u7372\u5F97\u4EFB\u4F55\u6210\u5C31\u3002\u7E7C\u7E8C\u9EDE\u64CA\uFF01","unlocked":"\u89E3\u9396\u6210\u5C31\uFF1A{{message}}","progress":"{{progress}}%","beginner":"\uD83C\uDFAF \u65B0\u624B\u5154\u5B50","carrotSnatcher":"\uD83E\uDD55 \u852C\u83DC\u5927\u76DC","bunnyBerserker":"\uD83D\uDE21 \u72C2\u66B4\u5154\u5B50","hopPunk":"\uD83C\uDFB8 \u9F90\u514B\u5154\u5B50","bunnyNinja":"\uD83E\uDD77 \u7121\u8072\u81F4\u547D\u6BDB\u7403","expert":"\uD83C\uDF1F \u8DF3\u8E8D\u5C08\u5BB6","master":"\uD83D\uDC51 \u80E1\u863F\u8514\u4E4B\u738B","carrotpocalypse":"\uD83E\uDD55 \u83DC\u5712\u6BC0\u6EC5\u8005","bunnyOverlord":"\uD83D\uDE08 \u5154\u5B50\u6D1E\u9738\u4E3B","chaosHare":"\uD83C\uDF2A\uFE0F \u6DF7\u6C8C\u7279\u5DE5","carrotCultist":"\u26EA \u80E1\u863F\u8514\u6559\u5927\u796D\u53F8","bunnyberryPie":"\uD83E\uDD67 \u5E7B\u89BA\u6D3E\u5927\u5E2B","rabbitHole":"\uD83D\uDD73\uFE0F \u91CF\u5B50\u96A7\u9053\u6316\u6398\u6A5F","moonRabbit":"\uD83C\uDF19 \u6708\u5154\u6417\u85E5","bunnyDoom":"\uD83D\uDC80 \u5154\u5B50\u672B\u65E5\u4F7F\u8005","carrotNuke":"\u2622\uFE0F \u6838\u80E1\u863F\u8514\u6301\u6709\u8005","bunnyMatrix":"\uD83E\uDD16 \u5154\u5B50\u77E9\u9663\u6545\u969C","cosmicHare":"\uD83C\uDF0C \u5B87\u5B99\u4E4B\u5154\u89BA\u9192","warrenSingularity":"\uD83D\uDD73\uFE0F \u5154\u5B50\u6D1E\u5947\u9EDE\u9054\u6210","eternalBunny":"\u267E\uFE0F \u6C38\u6046\u4E4B\u5154"},"messages":{"prophecy":"\u53E4\u8001\u7684\u9EDE\u64CA\u9810\u8A00\u958B\u59CB\u5C55\u958B...","cosmic":"\u5B87\u5B99\u9EDE\u64CA\u8005\u5C0D\u4F60\u7684\u9032\u5C55\u611F\u5230\u9A55\u50B2\uFF01","astral":"\u9EDE\u64CA\u8072\u8FF4\u76EA\u5728\u661F\u754C\u4E2D...","speaking":"\u7B49\u7B49...\u4F60\u807D\u5230\u4E86\u55CE\uFF1F\u9EDE\u64CA\u5728\u8DDF\u6211\u8AAA\u8A71...","ancient":"\u4F60\u7684\u9EDE\u64CA\u8207\u53E4\u8001\u529B\u91CF\u5171\u9CF4\uFF01","sages":"\u9EDE\u64CA\u8CE2\u8005\u4F4E\u8A9E\u8457\u4F60\u7684\u6F5B\u529B...","demons":"\u770B\u54EA\uFF01\u9EDE\u64CA\u60E1\u9B54\u5F9E\u6C89\u7761\u4E2D\u7526\u9192\uFF01","veil":"\u4F60\u7684\u9EDE\u64CA\u7A7F\u900F\u4E86\u73FE\u5BE6\u7684\u9762\u7D17\uFF01","spirits":"\u9EDE\u64CA\u7CBE\u9748\u96A8\u8457\u4F60\u7684\u7BC0\u594F\u8D77\u821E...","council":"\u5049\u5927\u7684\u9EDE\u64CA\u8B70\u6703\u6CE8\u610F\u5230\u4E86\u4F60\u7684\u5949\u737B","primordial":"\u4F60\u7684\u9EDE\u64CA\u559A\u9192\u4E86\u539F\u59CB\u529B\u91CF\uFF01","void":"\u9EDE\u64CA\u865B\u7A7A\u56DE\u671B\u8457\u4F60...","runes":"\u53E4\u8001\u7684\u9EDE\u64CA\u7B26\u6587\u96A8\u8457\u4F60\u7684\u529B\u91CF\u767C\u5149\uFF01","beast":"\u4E09\u4E09\u4E09 - \u9EDE\u64CA\u7378\u7684\u6578\u5B57","prophets":"\u9EDE\u64CA\u5148\u77E5\u6B4C\u980C\u4F60\u7684\u5230\u4F86\uFF01","dimensions":"\u4F60\u7684\u9EDE\u64CA\u8FF4\u76EA\u5728\u7DAD\u5EA6\u4E4B\u9593...","portal":"\u4F60\u7684\u9EDE\u64CA\u6253\u958B\u4E86\u901A\u5F80\u9EDE\u64CA\u7DAD\u5EA6\u7684\u50B3\u9001\u9580\uFF01","sacrifice":"\u53E4\u8001\u7684\u9EDE\u64CA\u4E4B\u795E\u8981\u6C42\u66F4\u591A\u796D\u54C1","jackpot":"\u982D\u734E\uFF01\u9EDE\u64CA\u8CED\u5834\u6B61\u8FCE\u5B83\u7684\u6700\u65B0\u51A0\u8ECD\uFF01","unmatched":"\u4F60\u7684\u9EDE\u64CA\u529B\u91CF\u7121\u4EBA\u80FD\u53CA\uFF01","reality":"\u73FE\u5BE6\u672C\u8EAB\u81E3\u670D\u65BC\u4F60\u7684\u9EDE\u64CA\u610F\u5FD7\uFF01","quartet":"\u9EDE\u64CA\u56DB\u91CD\u594F\u7684\u9810\u8A00\u5BE6\u73FE\u4E86","elite":"\u4F60\u5DF2\u6210\u70BA\u7CBE\u82F1\u9EDE\u64CA\u5927\u5E2B","power":"\u4F60\u7684\u9EDE\u64CA\u529B\u91CF\u8D85\u904E1500\uFF01","devils":"\u9EDE\u64CA\u60E1\u9B54\u5411\u4F60\u7684\u529B\u91CF\u97A0\u8EAC","lucky":"\u5E78\u904B\u9EDE\u64CA\u6D41\u6DCC\u5728\u4F60\u7684\u8840\u6DB2\u4E2D","dynasty":"\u9EDE\u64CA\u738B\u671D\u627F\u8A8D\u4F60\u7684\u81F3\u9AD8\u7121\u4E0A","twoThousand":"\u5169\u5343\u6B21\u7D14\u7CB9\u529B\u91CF\u7684\u9EDE\u64CA\uFF01","quartet2":"\u9EDE\u64CA\u56DB\u91CD\u594F\u7684\u9810\u8A00\u5BE6\u73FE\u4E86","transcend":"\u4F60\u7684\u9EDE\u64CA\u8D85\u8D8A\u51E1\u4EBA\u7406\u89E3","constellation":"\u9EDE\u64CA\u661F\u5EA7\u70BA\u4F60\u7684\u69AE\u8000\u800C\u6392\u5217","destiny":"\u4E09\u5343\u6B21\u547D\u904B\u7684\u9EDE\u64CA","triforce":"\u4E09\u91CD\u9EDE\u64CA\u529B\u91CF\u89BA\u9192\uFF01","fortune":"\u547D\u904B\u7737\u9867\u5805\u6301\u4E0D\u61C8\u7684\u9EDE\u64CA\u8005","newDimensions":"\u4F60\u7684\u9EDE\u64CA\u529B\u91CF\u9054\u5230\u65B0\u7684\u7DAD\u5EA6","threshold":"\u7AD9\u5728\u9EDE\u64CA\u795E\u6027\u7684\u9580\u6ABB\u4E0A","ultimate":"\u4E94\u5343\u6B21\u7D42\u6975\u529B\u91CF\u7684\u9EDE\u64CA\uFF01","force":"\u4E94\u6307\u9EDE\u64CA\u529B\u91CF\u4EFB\u4F60\u6307\u63EE","underworld":"\u9EDE\u64CA\u51A5\u754C\u52A0\u5195\u4F60\u70BA\u7D71\u6CBB\u8005","maxJackpot":"\u9054\u5230\u6700\u5927\u9EDE\u64CA\u982D\u734E","infinite":"\u7121\u9650\u9EDE\u64CA\u529B\u91CF\uFF01","godhood":"\u4F60\u5DF2\u6649\u5347\u70BA\u9EDE\u64CA\u4E4B\u795E","burrow":"\u4F60\u6BD4\u4EFB\u4F55\u5154\u5B50\u90FD\u6316\u5F97\u66F4\u6DF1...","warren":"\u5049\u5927\u7684\u5154\u5B50\u6D1E\u8A8D\u53EF\u4F60\u7684\u5B58\u5728...","thump":"\u4F60\u6BCF\u6B21\u8DFA\u8173\u90FD\u8B93\u5927\u5730\u9707\u52D5\uFF01","darkWarren":"\u9ED1\u6697\u5154\u5B50\u6D1E\u70BA\u4F60\u655E\u958B\u5927\u9580...","ears":"\u4F60\u7684\u8033\u6735\u8D8A\u4F86\u8D8A\u9577...\u73FE\u5728\u4F60\u80FD\u807D\u5230\u4E00\u5207...","carrotThrone":"\u80E1\u863F\u8514\u738B\u5EA7\u5728\u4F60\u9762\u524D\u986F\u73FE...","onesAlignment":"\u6240\u6709\u7684\u4E00\u90FD\u5C0D\u9F4A\u4E86 - \u5154\u5B50\u6D1E\u983B\u7387\u5171\u632F\uFF01","moonSummon":"\u6708\u5154\u9694\u8457\u865B\u7A7A\u807D\u5230\u4E86\u4F60\u7684\u547C\u559A...","edgeOfForever":"\u4F60\u7AD9\u5728\u6C38\u6046\u7684\u908A\u7DE3...\u8033\u6735\u5FAE\u5FAE\u986B\u52D5...","beyondTheVeil":"\u9762\u7D17\u4E4B\u5916\uFF0C\u6240\u6709\u5154\u5B50\u6D1E\u5408\u70BA\u4E00\u9AD4...","sequence":"1-2-3-4-5...\u795E\u8056\u7684\u8DF3\u8E8D\u5E8F\u5217\u5B8C\u6210\u4E86\uFF01","hyperElite":"\u8D85\u7D1A\u7CBE\u82F1\u5154\u5B50\u72C0\u614B\u89E3\u9396 \uD83D\uDC07\uD83D\uDC07\uD83D\uDC07","eventHorizon":"\u8D8A\u904E\u5B87\u5B99\u5154\u5B50\u6D1E\u7684\u4E8B\u4EF6\u8996\u754C...","matrixAwakens":"\u5154\u5B50\u6D1E\u77E9\u9663\u51FA\u73FE\u6545\u969C...\u4F60\u770B\u5230\u4E86\u73FE\u5BE6\u80CC\u5F8C\u7684\u80E1\u863F\u8514","luckyForever":"\u6BCF\u4E00\u96BB\u722A\u5B50\uFF0C\u6BCF\u4E00\u6B21\u8DF3\u8E8D\uFF0C\u6BCF\u4E00\u6B21\u986B\u52D5...\u6C38\u9060\u88AB\u795D\u798F","twentyK":"\u5169\u842C\u3002\u4F60\u4E0D\u518D\u662F\u4E00\u96BB\u5154\u5B50\u3002\u4F60\u5C31\u662F\u90A3\u96BB\u5154\u5B50\u3002","singularity":"\u5154\u5B50\u5947\u9EDE\u3002\u6240\u6709\u5154\u5B50\u90FD\u662F\u4F60\u3002\u4F60\u5C31\u662F\u6240\u6709\u5154\u5B50\u3002","tripleAscension":"\u5B87\u5B99\u4E4B\u5154\u7684\u4E09\u91CD\u5347\u5929\uFF01","ultimateAnswer":"42,000 - \u7D42\u6975\u7B54\u6848\u5F9E\u4E00\u958B\u59CB\u5C31\u662F\u80E1\u863F\u8514","eternity":"\u267E\uFE0F \u6C38\u6046\u7684\u5154\u5B50\u6D1E\u6C92\u6709\u76E1\u982D\u3002\u4F60\u4E5F\u662F\u3002\u267E\uFE0F"},"powerups":{"bonusPoints":"\uD83E\uDD55 +{{count}} \u734E\u52F5\u5206\u6578\uFF01","clickStreak":"\uD83D\uDD25 {{count}}\u9023\u64CA\uFF01","fire":"\uD83D\uDD25 \u706B\u7130\u529B\u91CF\u555F\u52D5\uFF01"},"table":{"achievement":"\u6210\u5C31","progress":"\u9032\u5EA6"},"reset":{"confirm":"\u78BA\u5B9A\u8981\u91CD\u7F6E\u6240\u6709\u9032\u5EA6\u55CE\uFF1F\u6B64\u64CD\u4F5C\u7121\u6CD5\u64A4\u6D88\u3002"}}');

});

parcelRegister("QnZ5l", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"title":"\u4E2D\u6CFD \uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","description":"\uD83D\uDC07\uD83E\uDD55\uD83D\uDC30","buttons":{"fullscreen":"\u5168\u5C4F","achievements":"\u6210\u5C31","reset":"\u91CD\u7F6E","language":"\u8BED\u8A00"},"achievements":{"title":"\u6210\u5C31","noAchievements":"\u8FD8\u6CA1\u6709\u83B7\u5F97\u4EFB\u4F55\u6210\u5C31\u3002\u7EE7\u7EED\u70B9\u51FB\uFF01","unlocked":"\u89E3\u9501\u6210\u5C31\uFF1A{{message}}","progress":"{{progress}}%","beginner":"\uD83C\uDFAF \u65B0\u624B\u5154\u5B50","carrotSnatcher":"\uD83E\uDD55 \u852C\u83DC\u5927\u76D7","bunnyBerserker":"\uD83D\uDE21 \u72C2\u66B4\u5154\u5B50","hopPunk":"\uD83C\uDFB8 \u670B\u514B\u5154\u5B50","bunnyNinja":"\uD83E\uDD77 \u65E0\u58F0\u81F4\u547D\u6BDB\u7403","expert":"\uD83C\uDF1F \u8DF3\u8DC3\u4E13\u5BB6","master":"\uD83D\uDC51 \u80E1\u841D\u535C\u4E4B\u738B","carrotpocalypse":"\uD83E\uDD55 \u83DC\u56ED\u6BC1\u706D\u8005","bunnyOverlord":"\uD83D\uDE08 \u5154\u5B50\u6D1E\u9738\u4E3B","chaosHare":"\uD83C\uDF2A\uFE0F \u6DF7\u6C8C\u7279\u5DE5","carrotCultist":"\u26EA \u80E1\u841D\u535C\u6559\u5927\u796D\u53F8","bunnyberryPie":"\uD83E\uDD67 \u5E7B\u89C9\u6D3E\u5927\u5E08","rabbitHole":"\uD83D\uDD73\uFE0F \u91CF\u5B50\u96A7\u9053\u6316\u6398\u673A","moonRabbit":"\uD83C\uDF19 \u6708\u5154\u6363\u836F","bunnyDoom":"\uD83D\uDC80 \u5154\u5B50\u672B\u65E5\u4F7F\u8005","carrotNuke":"\u2622\uFE0F \u6838\u80E1\u841D\u535C\u6301\u6709\u8005","bunnyMatrix":"\uD83E\uDD16 \u5154\u5B50\u77E9\u9635\u6545\u969C","cosmicHare":"\uD83C\uDF0C \u5B87\u5B99\u4E4B\u5154\u89C9\u9192","warrenSingularity":"\uD83D\uDD73\uFE0F \u5154\u5B50\u6D1E\u5947\u70B9\u8FBE\u6210","eternalBunny":"\u267E\uFE0F \u6C38\u6052\u4E4B\u5154"},"messages":{"prophecy":"\u53E4\u8001\u7684\u70B9\u51FB\u9884\u8A00\u5F00\u59CB\u5C55\u5F00...","cosmic":"\u5B87\u5B99\u70B9\u51FB\u8005\u4F1A\u4E3A\u4F60\u7684\u8FDB\u6B65\u611F\u5230\u9A84\u50B2\uFF01","astral":"\u70B9\u51FB\u58F0\u5728\u661F\u754C\u4E2D\u56DE\u8361...","speaking":"\u7B49\u7B49...\u4F60\u542C\u5230\u4E86\u5417\uFF1F\u70B9\u51FB\u5728\u548C\u6211\u8BF4\u8BDD...","ancient":"\u4F60\u7684\u70B9\u51FB\u4E0E\u8FDC\u53E4\u529B\u91CF\u5171\u9E23\uFF01","sages":"\u70B9\u51FB\u8D24\u8005\u4F4E\u8BED\u7740\u4F60\u7684\u6F5C\u529B...","demons":"\u770B\u554A\uFF01\u70B9\u51FB\u6076\u9B54\u4ECE\u6C89\u7761\u4E2D\u9192\u6765\uFF01","veil":"\u4F60\u7684\u70B9\u51FB\u523A\u7A7F\u4E86\u73B0\u5B9E\u7684\u9762\u7EB1\uFF01","spirits":"\u70B9\u51FB\u4E4B\u7075\u968F\u7740\u4F60\u7684\u8282\u594F\u8D77\u821E...","council":"\u70B9\u51FB\u5927\u8BAE\u4F1A\u6CE8\u610F\u5230\u4E86\u4F60\u7684\u5949\u732E","primordial":"\u4F60\u7684\u70B9\u51FB\u5524\u9192\u4E86\u539F\u59CB\u529B\u91CF\uFF01","void":"\u70B9\u51FB\u865A\u7A7A\u56DE\u671B\u7740\u4F60...","runes":"\u53E4\u8001\u7684\u70B9\u51FB\u7B26\u6587\u56E0\u4F60\u7684\u529B\u91CF\u800C\u53D1\u5149\uFF01","beast":"\u4E09\u4E09\u4E09 - \u70B9\u51FB\u91CE\u517D\u7684\u6570\u5B57","prophets":"\u70B9\u51FB\u5148\u77E5\u6B4C\u9882\u7740\u4F60\u7684\u5230\u6765\uFF01","dimensions":"\u4F60\u7684\u70B9\u51FB\u5728\u7EF4\u5EA6\u95F4\u56DE\u54CD...","portal":"\u4F60\u7684\u70B9\u51FB\u6253\u5F00\u4E86\u901A\u5F80\u70B9\u51FB\u7EF4\u5EA6\u7684\u4F20\u9001\u95E8\uFF01","sacrifice":"\u53E4\u8001\u7684\u70B9\u51FB\u4E4B\u795E\u8981\u6C42\u66F4\u591A\u796D\u54C1","jackpot":"\u5927\u5956\uFF01\u70B9\u51FB\u8D4C\u573A\u6B22\u8FCE\u5B83\u7684\u6700\u65B0\u51A0\u519B\uFF01","unmatched":"\u4F60\u7684\u70B9\u51FB\u529B\u91CF\u65E0\u4EBA\u80FD\u53CA!","reality":"\u73B0\u5B9E\u672C\u8EAB\u5728\u4F60\u7684\u70B9\u51FB\u610F\u5FD7\u4E0B\u5F2F\u66F2\uFF01","elite":"\u4F60\u5DF2\u6210\u4E3A\u7CBE\u82F1\u70B9\u51FB\u5927\u5E08","power":"\u4F60\u7684\u70B9\u51FB\u529B\u91CF\u7B49\u7EA7\u8D85\u8FC71500\uFF01","devils":"\u70B9\u51FB\u6076\u9B54\u5728\u4F60\u7684\u529B\u91CF\u524D\u4FEF\u9996","lucky":"\u5E78\u8FD0\u70B9\u51FB\u6D41\u6DCC\u5728\u4F60\u7684\u8840\u6DB2\u4E2D","dynasty":"\u70B9\u51FB\u738B\u671D\u8BA4\u53EF\u4F60\u7684\u81F3\u9AD8\u65E0\u4E0A","twoThousand":"\u4E24\u5343\u6B21\u7EAF\u7CB9\u529B\u91CF\u7684\u70B9\u51FB\uFF01","quartet":"\u70B9\u51FB\u56DB\u91CD\u594F\u7684\u9884\u8A00\u5DF2\u5B9E\u73B0","transcend":"\u4F60\u7684\u70B9\u51FB\u8D85\u8D8A\u4E86\u51E1\u4EBA\u7684\u7406\u89E3","constellation":"\u70B9\u51FB\u661F\u5EA7\u4E3A\u4F60\u7684\u8363\u8000\u800C\u6392\u5217","destiny":"\u547D\u8FD0\u7684\u4E09\u5343\u6B21\u70B9\u51FB","triforce":"\u4E09\u91CD\u70B9\u51FB\u529B\u91CF\u89C9\u9192\uFF01","fortune":"\u547D\u8FD0\u9752\u7750\u6267\u7740\u7684\u70B9\u51FB\u8005","newDimensions":"\u4F60\u7684\u70B9\u51FB\u529B\u91CF\u8FBE\u5230\u65B0\u7684\u7EF4\u5EA6","quartet2":"\u56DB\u91CD\u70B9\u51FB\u56DB\u91CD\u594F\u548C\u8C10\u5171\u9E23","threshold":"\u7AD9\u5728\u70B9\u51FB\u795E\u6027\u7684\u95E8\u69DB","ultimate":"\u4E94\u5343\u6B21\u7EC8\u6781\u529B\u91CF\u7684\u70B9\u51FB\uFF01","force":"\u4E94\u6307\u70B9\u51FB\u529B\u91CF\u4EFB\u4F60\u9A71\u4F7F","underworld":"\u70B9\u51FB\u51A5\u754C\u52A0\u5195\u4F60\u4E3A\u738B","maxJackpot":"\u8FBE\u5230\u6700\u5927\u70B9\u51FB\u5927\u5956","infinite":"\u65E0\u9650\u70B9\u51FB\u529B\u91CF\uFF01","godhood":"\u4F60\u5DF2\u63D0\u5347\u4E3A\u70B9\u51FB\u4E4B\u795E","burrow":"\u4F60\u6316\u5F97\u6BD4\u4EFB\u4F55\u5154\u5B50\u90FD\u6DF1...","warren":"\u4F1F\u5927\u7684\u5154\u5B50\u6D1E\u627F\u8BA4\u4F60\u7684\u5B58\u5728...","thump":"\u4F60\u6BCF\u4E00\u6B21\u8DFA\u811A\u90FD\u8BA9\u5927\u5730\u98A4\u6296\uFF01","darkWarren":"\u9ED1\u6697\u5154\u5B50\u6D1E\u4E3A\u4F60\u6253\u5F00\u4E86\u5927\u95E8...","ears":"\u4F60\u7684\u8033\u6735\u8D8A\u6765\u8D8A\u957F...\u73B0\u5728\u4F60\u80FD\u542C\u5230\u4E00\u5207...","carrotThrone":"\u80E1\u841D\u535C\u738B\u5EA7\u5728\u4F60\u9762\u524D\u663E\u73B0...","onesAlignment":"\u6240\u6709\u7684\u4E00\u90FD\u5BF9\u9F50\u4E86 - \u5154\u5B50\u6D1E\u9891\u7387\u5171\u632F\uFF01","moonSummon":"\u6708\u5154\u9694\u7740\u865A\u7A7A\u542C\u5230\u4E86\u4F60\u7684\u547C\u5524...","edgeOfForever":"\u4F60\u7AD9\u5728\u6C38\u6052\u7684\u8FB9\u7F18...\u8033\u6735\u5FAE\u5FAE\u98A4\u52A8...","beyondTheVeil":"\u9762\u7EB1\u4E4B\u5916\uFF0C\u6240\u6709\u5154\u5B50\u6D1E\u5408\u4E3A\u4E00\u4F53...","sequence":"1-2-3-4-5...\u795E\u5723\u7684\u8DF3\u8DC3\u5E8F\u5217\u5B8C\u6210\u4E86\uFF01","hyperElite":"\u8D85\u7EA7\u7CBE\u82F1\u5154\u5B50\u72B6\u6001\u89E3\u9501 \uD83D\uDC07\uD83D\uDC07\uD83D\uDC07","eventHorizon":"\u8D8A\u8FC7\u5B87\u5B99\u5154\u5B50\u6D1E\u7684\u4E8B\u4EF6\u89C6\u754C...","matrixAwakens":"\u5154\u5B50\u6D1E\u77E9\u9635\u51FA\u73B0\u6545\u969C...\u4F60\u770B\u5230\u4E86\u73B0\u5B9E\u80CC\u540E\u7684\u80E1\u841D\u535C","luckyForever":"\u6BCF\u4E00\u53EA\u722A\u5B50\uFF0C\u6BCF\u4E00\u6B21\u8DF3\u8DC3\uFF0C\u6BCF\u4E00\u6B21\u98A4\u52A8...\u6C38\u8FDC\u88AB\u795D\u798F","twentyK":"\u4E24\u4E07\u3002\u4F60\u4E0D\u518D\u662F\u4E00\u53EA\u5154\u5B50\u3002\u4F60\u5C31\u662F\u90A3\u53EA\u5154\u5B50\u3002","singularity":"\u5154\u5B50\u5947\u70B9\u3002\u6240\u6709\u5154\u5B50\u90FD\u662F\u4F60\u3002\u4F60\u5C31\u662F\u6240\u6709\u5154\u5B50\u3002","tripleAscension":"\u5B87\u5B99\u4E4B\u5154\u7684\u4E09\u91CD\u5347\u5929\uFF01","ultimateAnswer":"42,000 - \u7EC8\u6781\u7B54\u6848\u4ECE\u4E00\u5F00\u59CB\u5C31\u662F\u80E1\u841D\u535C","eternity":"\u267E\uFE0F \u6C38\u6052\u7684\u5154\u5B50\u6D1E\u6CA1\u6709\u5C3D\u5934\u3002\u4F60\u4E5F\u662F\u3002\u267E\uFE0F"},"powerups":{"bonusPoints":"\uD83E\uDD55 +{{count}} \u5956\u52B1\u5206\u6570\uFF01","clickStreak":"\uD83D\uDD25 {{count}}\u8FDE\u51FB\uFF01","fire":"\uD83D\uDD25 \u706B\u7130\u529B\u91CF\u6FC0\u6D3B\uFF01"},"table":{"achievement":"\u6210\u5C31","progress":"\u8FDB\u5EA6"},"reset":{"confirm":"\u786E\u5B9A\u8981\u91CD\u7F6E\u6240\u6709\u8FDB\u5EA6\u5417\uFF1F\u6B64\u64CD\u4F5C\u65E0\u6CD5\u64A4\u6D88\u3002"}}');

});


parcelRegister("bpR7q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $bd9c5c6835e005a1$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "create", function () { return $bd9c5c6835e005a1$export$185802fd694ee1f5; });
// canvas-confetti v1.9.4 built on 2025-10-25T05:14:56.640Z
var $bd9c5c6835e005a1$var$module = {};
// source content
/* globals Map */ (function main(global, module, isWorker, workerSize) {
    var canUseWorker = !!(global.Worker && global.Blob && global.Promise && global.OffscreenCanvas && global.OffscreenCanvasRenderingContext2D && global.HTMLCanvasElement && global.HTMLCanvasElement.prototype.transferControlToOffscreen && global.URL && global.URL.createObjectURL);
    var canUsePaths = typeof Path2D === 'function' && typeof DOMMatrix === 'function';
    var canDrawBitmap = function() {
        // this mostly supports ssr
        if (!global.OffscreenCanvas) return false;
        try {
            var canvas = new OffscreenCanvas(1, 1);
            var ctx = canvas.getContext('2d');
            ctx.fillRect(0, 0, 1, 1);
            var bitmap = canvas.transferToImageBitmap();
            ctx.createPattern(bitmap, 'no-repeat');
        } catch (e) {
            return false;
        }
        return true;
    }();
    function noop() {}
    // create a promise if it exists, otherwise, just
    // call the function directly
    function promise(func) {
        var ModulePromise = module.exports.Promise;
        var Prom = ModulePromise !== void 0 ? ModulePromise : global.Promise;
        if (typeof Prom === 'function') return new Prom(func);
        func(noop, noop);
        return null;
    }
    var bitmapMapper = function(skipTransform, map) {
        // see https://github.com/catdad/canvas-confetti/issues/209
        // creating canvases is actually pretty expensive, so we should create a
        // 1:1 map for bitmap:canvas, so that we can animate the confetti in
        // a performant manner, but also not store them forever so that we don't
        // have a memory leak
        return {
            transform: function(bitmap) {
                if (skipTransform) return bitmap;
                if (map.has(bitmap)) return map.get(bitmap);
                var canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
                var ctx = canvas.getContext('2d');
                ctx.drawImage(bitmap, 0, 0);
                map.set(bitmap, canvas);
                return canvas;
            },
            clear: function() {
                map.clear();
            }
        };
    }(canDrawBitmap, new Map());
    var raf = function() {
        var TIME = Math.floor(1000 / 60);
        var frame, cancel;
        var frames = {};
        var lastFrameTime = 0;
        if (typeof requestAnimationFrame === 'function' && typeof cancelAnimationFrame === 'function') {
            frame = function(cb) {
                var id = Math.random();
                frames[id] = requestAnimationFrame(function onFrame(time) {
                    if (lastFrameTime === time || lastFrameTime + TIME - 1 < time) {
                        lastFrameTime = time;
                        delete frames[id];
                        cb();
                    } else frames[id] = requestAnimationFrame(onFrame);
                });
                return id;
            };
            cancel = function(id) {
                if (frames[id]) cancelAnimationFrame(frames[id]);
            };
        } else {
            frame = function(cb) {
                return setTimeout(cb, TIME);
            };
            cancel = function(timer) {
                return clearTimeout(timer);
            };
        }
        return {
            frame: frame,
            cancel: cancel
        };
    }();
    var getWorker = function() {
        var worker;
        var prom;
        var resolves = {};
        function decorate(worker) {
            function execute(options, callback) {
                worker.postMessage({
                    options: options || {},
                    callback: callback
                });
            }
            worker.init = function initWorker(canvas) {
                var offscreen = canvas.transferControlToOffscreen();
                worker.postMessage({
                    canvas: offscreen
                }, [
                    offscreen
                ]);
            };
            worker.fire = function fireWorker(options, size, done) {
                if (prom) {
                    execute(options, null);
                    return prom;
                }
                var id = Math.random().toString(36).slice(2);
                prom = promise(function(resolve) {
                    function workerDone(msg) {
                        if (msg.data.callback !== id) return;
                        delete resolves[id];
                        worker.removeEventListener('message', workerDone);
                        prom = null;
                        bitmapMapper.clear();
                        done();
                        resolve();
                    }
                    worker.addEventListener('message', workerDone);
                    execute(options, id);
                    resolves[id] = workerDone.bind(null, {
                        data: {
                            callback: id
                        }
                    });
                });
                return prom;
            };
            worker.reset = function resetWorker() {
                worker.postMessage({
                    reset: true
                });
                for(var id in resolves){
                    resolves[id]();
                    delete resolves[id];
                }
            };
        }
        return function() {
            if (worker) return worker;
            if (!isWorker && canUseWorker) {
                var code = [
                    'var CONFETTI, SIZE = {}, module = {};',
                    '(' + main.toString() + ')(this, module, true, SIZE);',
                    'onmessage = function(msg) {',
                    '  if (msg.data.options) {',
                    '    CONFETTI(msg.data.options).then(function () {',
                    '      if (msg.data.callback) {',
                    '        postMessage({ callback: msg.data.callback });',
                    '      }',
                    '    });',
                    '  } else if (msg.data.reset) {',
                    '    CONFETTI && CONFETTI.reset();',
                    '  } else if (msg.data.resize) {',
                    '    SIZE.width = msg.data.resize.width;',
                    '    SIZE.height = msg.data.resize.height;',
                    '  } else if (msg.data.canvas) {',
                    '    SIZE.width = msg.data.canvas.width;',
                    '    SIZE.height = msg.data.canvas.height;',
                    '    CONFETTI = module.exports.create(msg.data.canvas);',
                    '  }',
                    '}'
                ].join('\n');
                try {
                    worker = new Worker(URL.createObjectURL(new Blob([
                        code
                    ])));
                } catch (e) {
                    // eslint-disable-next-line no-console
                    typeof console !== 'undefined' && typeof console.warn === 'function' && console.warn("\uD83C\uDF8A Could not load worker", e);
                    return null;
                }
                decorate(worker);
            }
            return worker;
        };
    }();
    var defaults = {
        particleCount: 50,
        angle: 90,
        spread: 45,
        startVelocity: 45,
        decay: 0.9,
        gravity: 1,
        drift: 0,
        ticks: 200,
        x: 0.5,
        y: 0.5,
        shapes: [
            'square',
            'circle'
        ],
        zIndex: 100,
        colors: [
            '#26ccff',
            '#a25afd',
            '#ff5e7e',
            '#88ff5a',
            '#fcff42',
            '#ffa62d',
            '#ff36ff'
        ],
        // probably should be true, but back-compat
        disableForReducedMotion: false,
        scalar: 1
    };
    function convert(val, transform) {
        return transform ? transform(val) : val;
    }
    function isOk(val) {
        return !(val === null || val === undefined);
    }
    function prop(options, name, transform) {
        return convert(options && isOk(options[name]) ? options[name] : defaults[name], transform);
    }
    function onlyPositiveInt(number) {
        return number < 0 ? 0 : Math.floor(number);
    }
    function randomInt(min, max) {
        // [min, max)
        return Math.floor(Math.random() * (max - min)) + min;
    }
    function toDecimal(str) {
        return parseInt(str, 16);
    }
    function colorsToRgb(colors) {
        return colors.map(hexToRgb);
    }
    function hexToRgb(str) {
        var val = String(str).replace(/[^0-9a-f]/gi, '');
        if (val.length < 6) val = val[0] + val[0] + val[1] + val[1] + val[2] + val[2];
        return {
            r: toDecimal(val.substring(0, 2)),
            g: toDecimal(val.substring(2, 4)),
            b: toDecimal(val.substring(4, 6))
        };
    }
    function getOrigin(options) {
        var origin = prop(options, 'origin', Object);
        origin.x = prop(origin, 'x', Number);
        origin.y = prop(origin, 'y', Number);
        return origin;
    }
    function setCanvasWindowSize(canvas) {
        canvas.width = document.documentElement.clientWidth;
        canvas.height = document.documentElement.clientHeight;
    }
    function setCanvasRectSize(canvas) {
        var rect = canvas.getBoundingClientRect();
        canvas.width = rect.width;
        canvas.height = rect.height;
    }
    function getCanvas(zIndex) {
        var canvas = document.createElement('canvas');
        canvas.style.position = 'fixed';
        canvas.style.top = '0px';
        canvas.style.left = '0px';
        canvas.style.pointerEvents = 'none';
        canvas.style.zIndex = zIndex;
        return canvas;
    }
    function ellipse(context, x, y, radiusX, radiusY, rotation, startAngle, endAngle, antiClockwise) {
        context.save();
        context.translate(x, y);
        context.rotate(rotation);
        context.scale(radiusX, radiusY);
        context.arc(0, 0, 1, startAngle, endAngle, antiClockwise);
        context.restore();
    }
    function randomPhysics(opts) {
        var radAngle = opts.angle * (Math.PI / 180);
        var radSpread = opts.spread * (Math.PI / 180);
        return {
            x: opts.x,
            y: opts.y,
            wobble: Math.random() * 10,
            wobbleSpeed: Math.min(0.11, Math.random() * 0.1 + 0.05),
            velocity: opts.startVelocity * 0.5 + Math.random() * opts.startVelocity,
            angle2D: -radAngle + (0.5 * radSpread - Math.random() * radSpread),
            tiltAngle: (Math.random() * 0.5 + 0.25) * Math.PI,
            color: opts.color,
            shape: opts.shape,
            tick: 0,
            totalTicks: opts.ticks,
            decay: opts.decay,
            drift: opts.drift,
            random: Math.random() + 2,
            tiltSin: 0,
            tiltCos: 0,
            wobbleX: 0,
            wobbleY: 0,
            gravity: opts.gravity * 3,
            ovalScalar: 0.6,
            scalar: opts.scalar,
            flat: opts.flat
        };
    }
    function updateFetti(context, fetti) {
        fetti.x += Math.cos(fetti.angle2D) * fetti.velocity + fetti.drift;
        fetti.y += Math.sin(fetti.angle2D) * fetti.velocity + fetti.gravity;
        fetti.velocity *= fetti.decay;
        if (fetti.flat) {
            fetti.wobble = 0;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar;
            fetti.wobbleY = fetti.y + 10 * fetti.scalar;
            fetti.tiltSin = 0;
            fetti.tiltCos = 0;
            fetti.random = 1;
        } else {
            fetti.wobble += fetti.wobbleSpeed;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar * Math.cos(fetti.wobble);
            fetti.wobbleY = fetti.y + 10 * fetti.scalar * Math.sin(fetti.wobble);
            fetti.tiltAngle += 0.1;
            fetti.tiltSin = Math.sin(fetti.tiltAngle);
            fetti.tiltCos = Math.cos(fetti.tiltAngle);
            fetti.random = Math.random() + 2;
        }
        var progress = fetti.tick++ / fetti.totalTicks;
        var x1 = fetti.x + fetti.random * fetti.tiltCos;
        var y1 = fetti.y + fetti.random * fetti.tiltSin;
        var x2 = fetti.wobbleX + fetti.random * fetti.tiltCos;
        var y2 = fetti.wobbleY + fetti.random * fetti.tiltSin;
        context.fillStyle = 'rgba(' + fetti.color.r + ', ' + fetti.color.g + ', ' + fetti.color.b + ', ' + (1 - progress) + ')';
        context.beginPath();
        if (canUsePaths && fetti.shape.type === 'path' && typeof fetti.shape.path === 'string' && Array.isArray(fetti.shape.matrix)) context.fill(transformPath2D(fetti.shape.path, fetti.shape.matrix, fetti.x, fetti.y, Math.abs(x2 - x1) * 0.1, Math.abs(y2 - y1) * 0.1, Math.PI / 10 * fetti.wobble));
        else if (fetti.shape.type === 'bitmap') {
            var rotation = Math.PI / 10 * fetti.wobble;
            var scaleX = Math.abs(x2 - x1) * 0.1;
            var scaleY = Math.abs(y2 - y1) * 0.1;
            var width = fetti.shape.bitmap.width * fetti.scalar;
            var height = fetti.shape.bitmap.height * fetti.scalar;
            var matrix = new DOMMatrix([
                Math.cos(rotation) * scaleX,
                Math.sin(rotation) * scaleX,
                -Math.sin(rotation) * scaleY,
                Math.cos(rotation) * scaleY,
                fetti.x,
                fetti.y
            ]);
            // apply the transform matrix from the confetti shape
            matrix.multiplySelf(new DOMMatrix(fetti.shape.matrix));
            var pattern = context.createPattern(bitmapMapper.transform(fetti.shape.bitmap), 'no-repeat');
            pattern.setTransform(matrix);
            context.globalAlpha = 1 - progress;
            context.fillStyle = pattern;
            context.fillRect(fetti.x - width / 2, fetti.y - height / 2, width, height);
            context.globalAlpha = 1;
        } else if (fetti.shape === 'circle') context.ellipse ? context.ellipse(fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI) : ellipse(context, fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI);
        else if (fetti.shape === 'star') {
            var rot = Math.PI / 2 * 3;
            var innerRadius = 4 * fetti.scalar;
            var outerRadius = 8 * fetti.scalar;
            var x = fetti.x;
            var y = fetti.y;
            var spikes = 5;
            var step = Math.PI / spikes;
            while(spikes--){
                x = fetti.x + Math.cos(rot) * outerRadius;
                y = fetti.y + Math.sin(rot) * outerRadius;
                context.lineTo(x, y);
                rot += step;
                x = fetti.x + Math.cos(rot) * innerRadius;
                y = fetti.y + Math.sin(rot) * innerRadius;
                context.lineTo(x, y);
                rot += step;
            }
        } else {
            context.moveTo(Math.floor(fetti.x), Math.floor(fetti.y));
            context.lineTo(Math.floor(fetti.wobbleX), Math.floor(y1));
            context.lineTo(Math.floor(x2), Math.floor(y2));
            context.lineTo(Math.floor(x1), Math.floor(fetti.wobbleY));
        }
        context.closePath();
        context.fill();
        return fetti.tick < fetti.totalTicks;
    }
    function animate(canvas, fettis, resizer, size, done) {
        var animatingFettis = fettis.slice();
        var context = canvas.getContext('2d');
        var animationFrame;
        var destroy;
        var prom = promise(function(resolve) {
            function onDone() {
                animationFrame = destroy = null;
                context.clearRect(0, 0, size.width, size.height);
                bitmapMapper.clear();
                done();
                resolve();
            }
            function update() {
                if (isWorker && !(size.width === workerSize.width && size.height === workerSize.height)) {
                    size.width = canvas.width = workerSize.width;
                    size.height = canvas.height = workerSize.height;
                }
                if (!size.width && !size.height) {
                    resizer(canvas);
                    size.width = canvas.width;
                    size.height = canvas.height;
                }
                context.clearRect(0, 0, size.width, size.height);
                animatingFettis = animatingFettis.filter(function(fetti) {
                    return updateFetti(context, fetti);
                });
                if (animatingFettis.length) animationFrame = raf.frame(update);
                else onDone();
            }
            animationFrame = raf.frame(update);
            destroy = onDone;
        });
        return {
            addFettis: function(fettis) {
                animatingFettis = animatingFettis.concat(fettis);
                return prom;
            },
            canvas: canvas,
            promise: prom,
            reset: function() {
                if (animationFrame) raf.cancel(animationFrame);
                if (destroy) destroy();
            }
        };
    }
    function confettiCannon(canvas, globalOpts) {
        var isLibCanvas = !canvas;
        var allowResize = !!prop(globalOpts || {}, 'resize');
        var hasResizeEventRegistered = false;
        var globalDisableForReducedMotion = prop(globalOpts, 'disableForReducedMotion', Boolean);
        var shouldUseWorker = canUseWorker && !!prop(globalOpts || {}, 'useWorker');
        var worker = shouldUseWorker ? getWorker() : null;
        var resizer = isLibCanvas ? setCanvasWindowSize : setCanvasRectSize;
        var initialized = canvas && worker ? !!canvas.__confetti_initialized : false;
        var preferLessMotion = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion)').matches;
        var animationObj;
        function fireLocal(options, size, done) {
            var particleCount = prop(options, 'particleCount', onlyPositiveInt);
            var angle = prop(options, 'angle', Number);
            var spread = prop(options, 'spread', Number);
            var startVelocity = prop(options, 'startVelocity', Number);
            var decay = prop(options, 'decay', Number);
            var gravity = prop(options, 'gravity', Number);
            var drift = prop(options, 'drift', Number);
            var colors = prop(options, 'colors', colorsToRgb);
            var ticks = prop(options, 'ticks', Number);
            var shapes = prop(options, 'shapes');
            var scalar = prop(options, 'scalar');
            var flat = !!prop(options, 'flat');
            var origin = getOrigin(options);
            var temp = particleCount;
            var fettis = [];
            var startX = canvas.width * origin.x;
            var startY = canvas.height * origin.y;
            while(temp--)fettis.push(randomPhysics({
                x: startX,
                y: startY,
                angle: angle,
                spread: spread,
                startVelocity: startVelocity,
                color: colors[temp % colors.length],
                shape: shapes[randomInt(0, shapes.length)],
                ticks: ticks,
                decay: decay,
                gravity: gravity,
                drift: drift,
                scalar: scalar,
                flat: flat
            }));
            // if we have a previous canvas already animating,
            // add to it
            if (animationObj) return animationObj.addFettis(fettis);
            animationObj = animate(canvas, fettis, resizer, size, done);
            return animationObj.promise;
        }
        function fire(options) {
            var disableForReducedMotion = globalDisableForReducedMotion || prop(options, 'disableForReducedMotion', Boolean);
            var zIndex = prop(options, 'zIndex', Number);
            if (disableForReducedMotion && preferLessMotion) return promise(function(resolve) {
                resolve();
            });
            if (isLibCanvas && animationObj) // use existing canvas from in-progress animation
            canvas = animationObj.canvas;
            else if (isLibCanvas && !canvas) {
                // create and initialize a new canvas
                canvas = getCanvas(zIndex);
                document.body.appendChild(canvas);
            }
            if (allowResize && !initialized) // initialize the size of a user-supplied canvas
            resizer(canvas);
            var size = {
                width: canvas.width,
                height: canvas.height
            };
            if (worker && !initialized) worker.init(canvas);
            initialized = true;
            if (worker) canvas.__confetti_initialized = true;
            function onResize() {
                if (worker) {
                    // TODO this really shouldn't be immediate, because it is expensive
                    var obj = {
                        getBoundingClientRect: function() {
                            if (!isLibCanvas) return canvas.getBoundingClientRect();
                        }
                    };
                    resizer(obj);
                    worker.postMessage({
                        resize: {
                            width: obj.width,
                            height: obj.height
                        }
                    });
                    return;
                }
                // don't actually query the size here, since this
                // can execute frequently and rapidly
                size.width = size.height = null;
            }
            function done() {
                animationObj = null;
                if (allowResize) {
                    hasResizeEventRegistered = false;
                    global.removeEventListener('resize', onResize);
                }
                if (isLibCanvas && canvas) {
                    if (document.body.contains(canvas)) document.body.removeChild(canvas);
                    canvas = null;
                    initialized = false;
                }
            }
            if (allowResize && !hasResizeEventRegistered) {
                hasResizeEventRegistered = true;
                global.addEventListener('resize', onResize, false);
            }
            if (worker) return worker.fire(options, size, done);
            return fireLocal(options, size, done);
        }
        fire.reset = function() {
            if (worker) worker.reset();
            if (animationObj) animationObj.reset();
        };
        return fire;
    }
    // Make default export lazy to defer worker creation until called.
    var defaultFire;
    function getDefaultFire() {
        if (!defaultFire) defaultFire = confettiCannon(null, {
            useWorker: true,
            resize: true
        });
        return defaultFire;
    }
    function transformPath2D(pathString, pathMatrix, x, y, scaleX, scaleY, rotation) {
        var path2d = new Path2D(pathString);
        var t1 = new Path2D();
        t1.addPath(path2d, new DOMMatrix(pathMatrix));
        var t2 = new Path2D();
        // see https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix/DOMMatrix
        t2.addPath(t1, new DOMMatrix([
            Math.cos(rotation) * scaleX,
            Math.sin(rotation) * scaleX,
            -Math.sin(rotation) * scaleY,
            Math.cos(rotation) * scaleY,
            x,
            y
        ]));
        return t2;
    }
    function shapeFromPath(pathData) {
        if (!canUsePaths) throw new Error('path confetti are not supported in this browser');
        var path, matrix;
        if (typeof pathData === 'string') path = pathData;
        else {
            path = pathData.path;
            matrix = pathData.matrix;
        }
        var path2d = new Path2D(path);
        var tempCanvas = document.createElement('canvas');
        var tempCtx = tempCanvas.getContext('2d');
        if (!matrix) {
            // attempt to figure out the width of the path, up to 1000x1000
            var maxSize = 1000;
            var minX = maxSize;
            var minY = maxSize;
            var maxX = 0;
            var maxY = 0;
            var width, height;
            // do some line skipping... this is faster than checking
            // every pixel and will be mostly still correct
            for(var x = 0; x < maxSize; x += 2){
                for(var y = 0; y < maxSize; y += 2)if (tempCtx.isPointInPath(path2d, x, y, 'nonzero')) {
                    minX = Math.min(minX, x);
                    minY = Math.min(minY, y);
                    maxX = Math.max(maxX, x);
                    maxY = Math.max(maxY, y);
                }
            }
            width = maxX - minX;
            height = maxY - minY;
            var maxDesiredSize = 10;
            var scale = Math.min(maxDesiredSize / width, maxDesiredSize / height);
            matrix = [
                scale,
                0,
                0,
                scale,
                -Math.round(width / 2 + minX) * scale,
                -Math.round(height / 2 + minY) * scale
            ];
        }
        return {
            type: 'path',
            path: path,
            matrix: matrix
        };
    }
    function shapeFromText(textData) {
        var text, scalar = 1, color = '#000000', // see https://nolanlawson.com/2022/04/08/the-struggle-of-using-native-emoji-on-the-web/
        fontFamily = '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif';
        if (typeof textData === 'string') text = textData;
        else {
            text = textData.text;
            scalar = 'scalar' in textData ? textData.scalar : scalar;
            fontFamily = 'fontFamily' in textData ? textData.fontFamily : fontFamily;
            color = 'color' in textData ? textData.color : color;
        }
        // all other confetti are 10 pixels,
        // so this pixel size is the de-facto 100% scale confetti
        var fontSize = 10 * scalar;
        var font = '' + fontSize + 'px ' + fontFamily;
        var canvas = new OffscreenCanvas(fontSize, fontSize);
        var ctx = canvas.getContext('2d');
        ctx.font = font;
        var size = ctx.measureText(text);
        var width = Math.ceil(size.actualBoundingBoxRight + size.actualBoundingBoxLeft);
        var height = Math.ceil(size.actualBoundingBoxAscent + size.actualBoundingBoxDescent);
        var padding = 2;
        var x = size.actualBoundingBoxLeft + padding;
        var y = size.actualBoundingBoxAscent + padding;
        width += padding + padding;
        height += padding + padding;
        canvas = new OffscreenCanvas(width, height);
        ctx = canvas.getContext('2d');
        ctx.font = font;
        ctx.fillStyle = color;
        ctx.fillText(text, x, y);
        var scale = 1 / scalar;
        return {
            type: 'bitmap',
            // TODO these probably need to be transfered for workers
            bitmap: canvas.transferToImageBitmap(),
            matrix: [
                scale,
                0,
                0,
                scale,
                -width * scale / 2,
                -height * scale / 2
            ]
        };
    }
    module.exports = function() {
        return getDefaultFire().apply(this, arguments);
    };
    module.exports.reset = function() {
        getDefaultFire().reset();
    };
    module.exports.create = confettiCannon;
    module.exports.shapeFromPath = shapeFromPath;
    module.exports.shapeFromText = shapeFromText;
})(function() {
    if (typeof window !== 'undefined') return window;
    if (typeof self !== 'undefined') return self;
    return this || {};
}(), $bd9c5c6835e005a1$var$module, false);
var // end source content
$bd9c5c6835e005a1$export$2e2bcd8739ae039 = $bd9c5c6835e005a1$var$module.exports;
var $bd9c5c6835e005a1$export$185802fd694ee1f5 = $bd9c5c6835e005a1$var$module.exports.create;

});

"use strict";

var $8a992fbd81573bde$var$_achievements = $8a992fbd81573bde$var$_interopRequireDefault((parcelRequire("i8qGU")));

var $8a992fbd81573bde$var$_messages = $8a992fbd81573bde$var$_interopRequireDefault((parcelRequire("lVnrG")));
var $a87d1a13adc38fef$exports = {};
"use strict";
Object.defineProperty($a87d1a13adc38fef$exports, "__esModule", {
    value: true
});
$a87d1a13adc38fef$exports.AchievementManager = void 0;
var $e6b4755c893fae30$exports = {};
"use strict";
Object.defineProperty($e6b4755c893fae30$exports, "__esModule", {
    value: true
});
$e6b4755c893fae30$exports.flashMessage = $e6b4755c893fae30$var$flashMessage;

var $e6b4755c893fae30$var$_i18n = $e6b4755c893fae30$var$_interopRequireDefault((parcelRequire("fAcbY")));
function $e6b4755c893fae30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $e6b4755c893fae30$var$flashMessage(clickCount, messages) {
    const container = document.getElementById("flash-messages-container") || $e6b4755c893fae30$var$createMessagesContainer();
    const messageObj = messages.find((msg)=>msg.clicks === clickCount);
    if (messageObj) {
        const messageElement = document.createElement("div");
        messageElement.className = "flash-message";
        messageElement.innerText = messageObj.translationVars ? $e6b4755c893fae30$var$_i18n.default.t(messageObj.messageKey, messageObj.translationVars) : $e6b4755c893fae30$var$_i18n.default.t(messageObj.messageKey);
        container.appendChild(messageElement);
        // Adjust positions of existing messages
        const existingMessages = container.getElementsByClassName("flash-message");
        let totalHeight = 0;
        for(let i = 0; i < existingMessages.length - 1; i++){
            const msg = existingMessages[i];
            msg.style.transform = `translateY(${totalHeight}px)`;
            totalHeight += msg.offsetHeight + 5; // 5px for margin
        }
        // Position and fade in new message
        messageElement.style.opacity = "0";
        requestAnimationFrame(()=>{
            messageElement.style.display = "block";
            messageElement.style.transition = "opacity 0.3s ease-in-out, transform 0.3s ease-in-out";
            messageElement.style.opacity = "1";
            messageElement.style.transform = `translateY(${totalHeight}px)`;
        });
        // Fade out after delay
        setTimeout(()=>{
            messageElement.style.opacity = "0";
            setTimeout(()=>{
                messageElement.remove();
                // Readjust positions of remaining messages
                const remainingMessages = container.getElementsByClassName("flash-message");
                let newTotalHeight = 0;
                for(let i = 0; i < remainingMessages.length; i++){
                    const msg = remainingMessages[i];
                    msg.style.transform = `translateY(${newTotalHeight}px)`;
                    newTotalHeight += msg.offsetHeight + 5;
                }
                // Remove container if empty
                if (container.children.length === 0) container.remove();
            }, 300);
        }, 2700);
    }
}
function $e6b4755c893fae30$var$createMessagesContainer() {
    const container = document.createElement("div");
    container.id = "flash-messages-container";
    document.body.appendChild(container);
    return container;
}



var $a87d1a13adc38fef$var$_i18n = $a87d1a13adc38fef$var$_interopRequireDefault((parcelRequire("fAcbY")));
function $a87d1a13adc38fef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
class $a87d1a13adc38fef$var$AchievementManager {
    constructor(achievementsData){
        this.achievements = achievementsData.achievements;
        this.loadSavedAchievements();
    }
    loadSavedAchievements() {
        const savedAchievements = localStorage.getItem("achievements");
        if (savedAchievements) Object.assign(this.achievements, JSON.parse(savedAchievements));
    }
    updateAchievementsTable(clicks) {
        const table = document.getElementById("achievements-table");
        const tbody = document.getElementById("achievements-body");
        tbody.innerHTML = "";
        const achievementsArray = Object.entries(this.achievements).map(([name, achievement])=>({
                name: name,
                ...achievement
            })).sort((a, b)=>a.threshold - b.threshold);
        let lastEarned = null;
        const nextUnearned = [];
        for (const achievement of achievementsArray){
            if (achievement.earned) lastEarned = achievement;
            else if (nextUnearned.length < 2) nextUnearned.push(achievement);
        }
        let hasEarned = false;
        const isMobile = window.innerWidth <= 768;
        const achievementsToShow = isMobile ? nextUnearned.slice(0, 1) : [
            lastEarned,
            ...nextUnearned
        ].filter((a)=>a !== null);
        for (const achievement of achievementsToShow){
            const row = document.createElement("tr");
            const progress = Math.min(clicks / achievement.threshold * 100, 100).toFixed(0);
            row.innerHTML = `
                <td class="${achievement.earned ? "earned" : "locked"}">${$a87d1a13adc38fef$var$_i18n.default.t(achievement.messageKey)}</td>
                <td>${$a87d1a13adc38fef$var$_i18n.default.t("achievements.progress", {
                progress: progress
            })}</td>
            `;
            tbody.appendChild(row);
            if (achievement.earned) hasEarned = true;
        }
        table.style.display = isMobile && achievementsToShow.length > 0 || hasEarned ? "table" : "none";
    }
    checkAchievements(clicks) {
        let earned = false;
        for (const [name, achievement] of Object.entries(this.achievements))if (!achievement.earned && clicks >= achievement.threshold) {
            achievement.earned = true;
            earned = true;
            this.screenShake();
            this.flashAchievement(achievement);
        }
        if (earned) localStorage.setItem("achievements", JSON.stringify(this.achievements));
        this.updateAchievementsTable(clicks);
    }
    screenShake() {
        document.body.style.transform = "translate(5px, 5px)";
        setTimeout(()=>{
            document.body.style.transform = "translate(-5px, -5px)";
            setTimeout(()=>{
                document.body.style.transform = "translate(0, 0)";
            }, 50);
        }, 50);
    }
    flashAchievement(achievement) {
        (0, $e6b4755c893fae30$exports.flashMessage)(achievement.threshold, [
            {
                clicks: achievement.threshold,
                messageKey: achievement.messageKey
            }
        ]);
    }
    reset() {
        for (const key of Object.keys(this.achievements))this.achievements[key].earned = false;
        localStorage.removeItem("achievements");
        this.updateAchievementsTable(0);
    }
    showAchievementsModal() {
        const modal = document.getElementById("modal");
        const modalAchievements = document.getElementById("modal-achievements");
        modalAchievements.innerHTML = "";
        const earnedAchievements = Object.entries(this.achievements).map(([name, achievement])=>({
                name: name,
                ...achievement
            })).filter((achievement)=>achievement.earned).sort((a, b)=>a.threshold - b.threshold);
        if (earnedAchievements.length === 0) {
            const noAchievementsDiv = document.createElement("div");
            noAchievementsDiv.style.textAlign = "center";
            noAchievementsDiv.style.padding = "20px";
            noAchievementsDiv.innerText = $a87d1a13adc38fef$var$_i18n.default.t("achievements.noAchievements");
            modalAchievements.appendChild(noAchievementsDiv);
        } else for (const achievement of earnedAchievements){
            const achievementDiv = document.createElement("div");
            achievementDiv.style.margin = "10px 0";
            achievementDiv.style.padding = "10px";
            achievementDiv.style.borderBottom = "2px solid #333";
            const earnedDiv = document.createElement("div");
            earnedDiv.className = "earned";
            earnedDiv.textContent = $a87d1a13adc38fef$var$_i18n.default.t(achievement.messageKey);
            achievementDiv.appendChild(earnedDiv);
            modalAchievements.appendChild(achievementDiv);
        }
        modal.style.display = "block";
    }
}
$a87d1a13adc38fef$exports.AchievementManager = $a87d1a13adc38fef$var$AchievementManager;


var $b60044e050f897de$exports = {};
"use strict";
Object.defineProperty($b60044e050f897de$exports, "__esModule", {
    value: true
});
$b60044e050f897de$exports.ClickTracker = void 0;
// ABOUTME: Tracks click speed and streak data for gameplay feedback.
// ABOUTME: Used by app.js to feed click velocity into powerup spawn timing.
class $b60044e050f897de$var$ClickTracker {
    constructor(){
        this.lastClickTime = Date.now();
        this.clickSpeed = 0;
        this.streakCount = 0;
    }
    updateClickSpeed() {
        const now = Date.now();
        const timeDiff = (now - this.lastClickTime) / 500;
        this.clickSpeed = 1 / timeDiff;
        if (timeDiff < 1) this.streakCount++;
        else this.streakCount = 0;
        this.lastClickTime = now;
        return {
            speed: this.clickSpeed,
            streak: this.streakCount
        };
    }
    getStreak() {
        return this.streakCount;
    }
    getClickSpeed() {
        return this.clickSpeed;
    }
}
$b60044e050f897de$exports.ClickTracker = $b60044e050f897de$var$ClickTracker;


var $5825678eb68e4677$exports = {};
"use strict";
Object.defineProperty($5825678eb68e4677$exports, "__esModule", {
    value: true
});
$5825678eb68e4677$exports.PowerupManager = void 0;

var $5825678eb68e4677$var$_canvasConfetti = $5825678eb68e4677$var$_interopRequireDefault((parcelRequire("bpR7q")));

var $5825678eb68e4677$var$_carrotPowerup = $5825678eb68e4677$var$_interopRequireDefault({});
var $90a905614a3a4231$exports = {};
"use strict";
Object.defineProperty($90a905614a3a4231$exports, "__esModule", {
    value: true
});
$90a905614a3a4231$exports.FireCursor = void 0;
// Inspired by: http://fabiansanglard.net/doom_fire_psx/
const $90a905614a3a4231$var$DPR = window.devicePixelRatio || 1;
const $90a905614a3a4231$var$CELL_WIDTH = 8 * $90a905614a3a4231$var$DPR;
const $90a905614a3a4231$var$CELL_HEIGHT = 8 * $90a905614a3a4231$var$DPR;
const $90a905614a3a4231$var$FLAME_COLOR_DEPTH = 24;
const $90a905614a3a4231$var$FLAME_COLOR_TABLE = [
    [
        0,
        "rgba(230, 230, 250, 0.4)"
    ],
    // transparent lavender
    [
        0.1,
        "rgba(255, 255, 0, 0.4)"
    ],
    // transparent yellow
    [
        0.3,
        "rgba(255, 215, 0, 0.4)"
    ],
    // transparent gold
    [
        0.5,
        "rgba(255, 105, 180, 0.4)"
    ],
    // transparent hotpink
    [
        0.6,
        "rgba(255, 99, 71, 0.4)"
    ],
    // transparent tomato
    [
        0.8,
        "rgba(72, 61, 139, 0.4)"
    ],
    // transparent darkslateblue
    [
        1,
        "rgba(34, 34, 34, 0.9)"
    ] // very transparent dark
];
const $90a905614a3a4231$var$SPREAD_FROM = [
    "bottom",
    "bottom",
    "bottom",
    "bottom",
    "bottom",
    "bottom",
    "bottom",
    "bottom",
    "bottom",
    "bottom",
    "left",
    "left",
    "right",
    "right",
    "top"
];
function $90a905614a3a4231$var$getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function $90a905614a3a4231$var$createGradientArray(size, colorStops) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d", {
        alpha: true
    });
    canvas.style.background = "transparent";
    canvas.width = size;
    canvas.height = 1;
    const gradient = ctx.createLinearGradient(0, 0, size, 0);
    for (const args of colorStops)gradient.addColorStop(...args);
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, size, 1);
    return Array(size).fill(null).map((_, x)=>{
        const data = ctx.getImageData(x, 0, 1, 1).data;
        const alpha = Math.max(0.2, Math.min(0.95, 1 - x / size));
        return `rgba(${data[0]}, ${data[1]}, ${data[2]}, ${alpha})`;
    });
}
class $90a905614a3a4231$var$Pixel {
    constructor(x, y, arr, idx){
        this.x = x;
        this.y = y;
        this.idx = idx;
        this.arr = arr;
    }
    setSides({ top: top, left: left, bottom: bottom, right: right }) {
        this.top = top;
        this.left = left;
        this.bottom = bottom;
        this.right = right;
    }
    draw = ({ ctx: ctx })=>{
        const fill = this.arr[this.idx];
        ctx.fillStyle = fill;
        ctx.fillRect(this.x, this.y, $90a905614a3a4231$var$CELL_WIDTH, $90a905614a3a4231$var$CELL_HEIGHT);
    };
    update = ()=>{
        const side = $90a905614a3a4231$var$SPREAD_FROM[$90a905614a3a4231$var$getRandomInt(0, $90a905614a3a4231$var$SPREAD_FROM.length - 1)];
        const dest = this[side];
        if (dest && dest.idx < this.idx) {
            const rand = $90a905614a3a4231$var$getRandomInt(-1, 4);
            this.idx = dest.idx + rand;
        } else this.idx += 1;
        if (this.idx > this.arr.length - 1) this.idx = this.arr.length - 1;
        else if (this.idx < 0) this.idx = 0;
    };
}
class $90a905614a3a4231$var$FireCursor {
    constructor(canvas){
        this.canvas = canvas;
        canvas.width = window.innerWidth * $90a905614a3a4231$var$DPR;
        canvas.height = window.innerHeight * $90a905614a3a4231$var$DPR;
        canvas.style.width = `${window.innerWidth}px`;
        canvas.style.height = `${window.innerHeight}px`;
        this.ctx = canvas.getContext("2d");
        this.bounds = {
            w: window.innerWidth * $90a905614a3a4231$var$DPR,
            h: window.innerHeight * $90a905614a3a4231$var$DPR,
            center: {
                x: window.innerWidth * $90a905614a3a4231$var$DPR / 2,
                y: window.innerHeight * $90a905614a3a4231$var$DPR / 2
            }
        };
        this.pointer = {
            position: {
                x: 0,
                y: 0
            }
        };
        this.tick = 0;
        this.matrix = new $90a905614a3a4231$var$Matrix();
        this.matrix.setup({
            bounds: this.bounds
        });
        this.setupEventListeners();
    }
    setupEventListeners() {
        window.addEventListener("mousemove", (e)=>{
            this.pointer.position.x = e.clientX * $90a905614a3a4231$var$DPR;
            this.pointer.position.y = e.clientY * $90a905614a3a4231$var$DPR;
        });
        window.addEventListener("resize", ()=>{
            this.canvas.width = window.innerWidth * $90a905614a3a4231$var$DPR;
            this.canvas.height = window.innerHeight * $90a905614a3a4231$var$DPR;
            this.bounds.w = window.innerWidth * $90a905614a3a4231$var$DPR;
            this.bounds.h = window.innerHeight * $90a905614a3a4231$var$DPR;
            this.bounds.center.x = window.innerWidth * $90a905614a3a4231$var$DPR / 2;
            this.bounds.center.y = window.innerHeight * $90a905614a3a4231$var$DPR / 2;
            this.matrix.resize({
                bounds: this.bounds
            });
        });
    }
    startAnimation() {
        const animate = ()=>{
            this.ctx.clearRect(0, 0, this.bounds.w, this.bounds.h);
            this.matrix.draw({
                ctx: this.ctx,
                pointer: this.pointer,
                tick: this.tick,
                bounds: this.bounds
            });
            this.tick++;
            requestAnimationFrame(animate);
        };
        animate();
    }
}
$90a905614a3a4231$exports.FireCursor = $90a905614a3a4231$var$FireCursor;
class $90a905614a3a4231$var$Matrix {
    createMatrix({ bounds: bounds }) {
        const colors = $90a905614a3a4231$var$createGradientArray($90a905614a3a4231$var$FLAME_COLOR_DEPTH, $90a905614a3a4231$var$FLAME_COLOR_TABLE);
        this.rows = Math.ceil(bounds.h / $90a905614a3a4231$var$CELL_HEIGHT);
        this.columns = Math.ceil(bounds.w / $90a905614a3a4231$var$CELL_WIDTH);
        const table = Array(this.rows).fill(Array(this.columns).fill(null));
        this.pixels = table.map((row, y)=>row.map((col, x)=>new $90a905614a3a4231$var$Pixel(x * $90a905614a3a4231$var$CELL_WIDTH, y * $90a905614a3a4231$var$CELL_HEIGHT, colors, y >= this.rows - 2 ? 0 : colors.length - 1)));
        for(let row = 0; row < this.rows; row++)for(let col = 0; col < this.columns; col++){
            const bounds = {
                top: this.pixels[row - 1] && this.pixels[row - 1][col],
                left: this.pixels[row][col - 1],
                bottom: this.pixels[row + 1] && this.pixels[row + 1][col],
                right: this.pixels[row][col + 1]
            };
            this.pixels[row][col].setSides(bounds);
        }
    }
    setup = (context)=>this.createMatrix(context);
    resize = (context)=>this.createMatrix(context);
    draw = ({ ctx: ctx, pointer: pointer, tick: tick, bounds: bounds })=>{
        const { x: x, y: y } = pointer.position;
        let pointCol;
        let pointRow;
        if (x !== null && y !== null) {
            pointCol = Math.floor(x / $90a905614a3a4231$var$CELL_WIDTH);
            pointRow = Math.floor(y / $90a905614a3a4231$var$CELL_HEIGHT);
        } else {
            const z = tick / 10;
            const s = bounds.h / 4;
            const { center: c } = bounds;
            pointCol = Math.floor((c.x + Math.sin(z) * s) / $90a905614a3a4231$var$CELL_WIDTH);
            pointRow = Math.floor((c.y + Math.cos(z) * s) / $90a905614a3a4231$var$CELL_HEIGHT);
        }
        for(let row = 0; row < this.rows; row++)for(let col = 0; col < this.columns; col++){
            const pixel = this.pixels[row][col];
            if (pointRow === row && pointCol === col) pixel.idx = 0;
            pixel.draw({
                ctx: ctx
            });
            pixel.update();
        }
    };
}



function $5825678eb68e4677$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
// ABOUTME: Manages powerup spawning, activation, and scaling for the click game.
// ABOUTME: Egg powerups grant fire mode, carrots give bonus points, both scale with progression.
class $5825678eb68e4677$var$PowerupManager {
    constructor({ getClickSpeed: getClickSpeed, getClickCount: getClickCount }){
        this.active = false;
        this.multiplier = 1;
        this.timeout = null;
        this.timerElement = document.getElementById("timer");
        this.mobileTimerElement = null;
        this.fireCursor = null;
        this.getClickSpeed = getClickSpeed;
        this.getClickCount = getClickCount;
        this.setupMobileTimer();
    }
    setupMobileTimer() {
        this.mobileTimerElement = document.createElement("div");
        this.mobileTimerElement.id = "mobile-timer";
        document.getElementById("button-container").prepend(this.mobileTimerElement);
    }
    // Calculate fire multiplier based on progression
    getScaledMultiplier() {
        const clicks = this.getClickCount();
        if (clicks >= 5000) return 5;
        if (clicks >= 1000) return 3;
        return 2;
    }
    // Calculate carrot bonus based on progression
    getScaledCarrotBonus() {
        const clicks = this.getClickCount();
        if (clicks >= 5000) return 250;
        if (clicks >= 1000) return 100;
        return 50;
    }
    spawnPowerup() {
        const powerup = document.createElement("div");
        powerup.id = "powerup";
        powerup.style.left = `${Math.random() * (window.innerWidth - 40)}px`;
        powerup.style.top = "0";
        powerup.style.position = "fixed";
        powerup.style.animation = "fall 3s linear forwards";
        this.setupPowerupAnimation();
        this.setupPowerupClickHandler(powerup);
        document.body.appendChild(powerup);
        setTimeout(()=>powerup.remove(), 3000);
    }
    setupPowerupAnimation() {
        if (!document.querySelector("#powerup-animation")) {
            const style = document.createElement("style");
            style.id = "powerup-animation";
            style.textContent = `
                @keyframes fall {
                    from { top: -50px; }
                    to { top: calc(100vh - 50px); }
                }
            `;
            document.head.appendChild(style);
        }
    }
    setupPowerupClickHandler(powerup) {
        powerup.addEventListener("click", (e)=>{
            e.stopPropagation();
            this.createConfettiExplosion(e);
            this.activate();
            (0, $e6b4755c893fae30$exports.flashMessage)(0, [
                {
                    clicks: 0,
                    messageKey: "powerups.fire"
                }
            ]);
            powerup.remove();
        });
    }
    createConfettiExplosion(e) {
        const count = 200;
        const defaults = {
            origin: {
                x: e.clientX / window.innerWidth,
                y: e.clientY / window.innerHeight
            },
            spread: 360,
            startVelocity: 45,
            scalar: 2,
            ticks: 100,
            colors: [
                "#ff0000",
                "#000000"
            ],
            shapes: [
                "square",
                "circle"
            ]
        };
        (0, $5825678eb68e4677$var$_canvasConfetti.default)({
            ...defaults,
            particleCount: count,
            gravity: 0.8
        });
        (0, $5825678eb68e4677$var$_canvasConfetti.default)({
            ...defaults,
            particleCount: count,
            gravity: 1.2,
            scalar: 1.5
        });
    }
    activate() {
        this.active = true;
        this.multiplier = this.getScaledMultiplier();
        this.timerElement.style.display = "block";
        // Initialize fire cursor
        const canvas = document.createElement("canvas");
        canvas.style.position = "fixed";
        canvas.style.top = "0";
        canvas.style.left = "0";
        canvas.style.width = "100%";
        canvas.style.height = "100%";
        canvas.style.pointerEvents = "none";
        canvas.style.zIndex = "9999";
        document.body.appendChild(canvas);
        this.fireCursor = new $90a905614a3a4231$exports.FireCursor(canvas);
        this.fireCursor.startAnimation();
        let timeLeft = 30;
        clearInterval(this.timeout);
        this.timeout = setInterval(()=>{
            timeLeft--;
            this.timerElement.textContent = `${timeLeft}s (${this.multiplier}x)`;
            this.mobileTimerElement.textContent = `${timeLeft}s (${this.multiplier}x)`;
            if (timeLeft <= 0) this.deactivate();
        }, 1000);
    }
    deactivate() {
        clearInterval(this.timeout);
        this.active = false;
        this.multiplier = 1;
        this.timerElement.style.display = "none";
        this.mobileTimerElement.textContent = "";
        // Remove fire cursor
        if (this.fireCursor) {
            this.fireCursor.canvas.remove();
            this.fireCursor = null;
        }
    }
    spawnRandomCarrot() {
        const bonus = this.getScaledCarrotBonus();
        const carrot = document.createElement("div");
        carrot.style.position = "absolute";
        carrot.style.left = `${Math.random() * (window.innerWidth - 50)}px`;
        carrot.style.top = `${Math.random() * (window.innerHeight - 50)}px`;
        carrot.style.width = "50px";
        carrot.style.height = "50px";
        carrot.style.cursor = "pointer";
        carrot.style.backgroundImage = `url("${$5825678eb68e4677$var$_carrotPowerup.default}")`;
        carrot.style.backgroundSize = "contain";
        carrot.style.filter = "drop-shadow(3px 3px 3px rgba(0,0,0,0.5))";
        carrot.onclick = (e)=>{
            this.createConfettiExplosion(e);
            (0, $e6b4755c893fae30$exports.flashMessage)(bonus, [
                {
                    clicks: bonus,
                    messageKey: "powerups.bonusPoints",
                    translationVars: {
                        count: bonus
                    }
                }
            ]);
            carrot.remove();
            document.dispatchEvent(new CustomEvent("powerupCollected", {
                detail: {
                    bonus: bonus
                }
            }));
        };
        document.body.appendChild(carrot);
        setTimeout(()=>carrot.remove(), 3000);
    }
    // Spawn timer reads live click speed each cycle
    startPowerupSpawnTimer() {
        const minDelay = 30000;
        const maxDelay = 60000;
        const clickSpeed = this.getClickSpeed();
        const speedMultiplier = Math.max(0.1, Math.min(1, clickSpeed / 5));
        const delay = maxDelay - (maxDelay - minDelay) * speedMultiplier;
        setTimeout(()=>{
            this.spawnPowerup();
            this.startPowerupSpawnTimer();
        }, delay);
    }
    getMultiplier() {
        return this.multiplier;
    }
    isActive() {
        return this.active;
    }
    // Debug methods
    debug = {
        triggerFirePowerup: (e = {
            clientX: window.innerWidth / 2,
            clientY: window.innerHeight / 2
        })=>{
            this.createConfettiExplosion(e);
            this.activate();
            (0, $e6b4755c893fae30$exports.flashMessage)(0, [
                {
                    clicks: 0,
                    messageKey: "powerups.fire"
                }
            ]);
        }
    };
}
$5825678eb68e4677$exports.PowerupManager = $5825678eb68e4677$var$PowerupManager;


var $9d1e84ad7b4fc981$exports = {};
"use strict";
Object.defineProperty($9d1e84ad7b4fc981$exports, "__esModule", {
    value: true
});
$9d1e84ad7b4fc981$exports.VisualEffects = void 0;

var $9d1e84ad7b4fc981$var$_canvasConfetti = $9d1e84ad7b4fc981$var$_interopRequireDefault((parcelRequire("bpR7q")));
function $9d1e84ad7b4fc981$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
// ABOUTME: Manages visual feedback effects (confetti, vibration, background color, screen shake).
// ABOUTME: Provides escalating haptic/visual responses to player clicks and achievements.
class $9d1e84ad7b4fc981$var$VisualEffects {
    constructor(){
        this.setupVibrationPatterns();
    }
    setupVibrationPatterns() {
        this.patterns = {
            small: 200,
            large: [
                200,
                100,
                200
            ],
            evenBigger: [
                200,
                100,
                200,
                100,
                200
            ]
        };
    }
    createClickConfetti(e) {
        (0, $9d1e84ad7b4fc981$var$_canvasConfetti.default)({
            particleCount: 100,
            spread: 70,
            gravity: 0.4,
            shapes: [
                "star",
                "circle",
                "square"
            ],
            colors: [
                "#FFB6C1",
                "#87CEEB",
                "#98FB98",
                "#DDA0DD",
                "#F0E68C"
            ],
            origin: {
                x: e.clientX / window.innerWidth,
                y: e.clientY / window.innerHeight
            }
        });
    }
    vibrate(pattern) {
        if (!window.navigator.vibrate) return;
        window.navigator.vibrate(this.patterns[pattern]);
    }
    blendBackgroundColor(clickCounter) {
        const colors = [
            "#FFB6C1",
            "#87CEEB",
            "#98FB98",
            "#DDA0DD",
            "#F0E68C"
        ];
        const currentColorIndex = Math.floor(clickCounter / 25) % colors.length;
        const nextColorIndex = (currentColorIndex + 1) % colors.length;
        const nextColor = colors[nextColorIndex];
        document.body.style.transition = "background-color 1s ease-in-out";
        document.body.style.backgroundColor = nextColor;
    }
    screenShake() {
        document.body.style.transform = "translate(5px, 5px)";
        setTimeout(()=>{
            document.body.style.transform = "translate(-5px, -5px)";
            setTimeout(()=>{
                document.body.style.transform = "translate(0, 0)";
            }, 50);
        }, 50);
    }
}
$9d1e84ad7b4fc981$exports.VisualEffects = $9d1e84ad7b4fc981$var$VisualEffects;




var $8a992fbd81573bde$var$_i18n = $8a992fbd81573bde$var$_interopRequireWildcard((parcelRequire("fAcbY")));
function $8a992fbd81573bde$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($8a992fbd81573bde$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $8a992fbd81573bde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
// ABOUTME: Main application entry point for the Nakazawa bunny clicker game.
// ABOUTME: Wires together click tracking, achievements, powerups, visual effects, and i18n.
const $8a992fbd81573bde$var$achievementManager = new $a87d1a13adc38fef$exports.AchievementManager($8a992fbd81573bde$var$_achievements.default);
const $8a992fbd81573bde$var$visualEffects = new $9d1e84ad7b4fc981$exports.VisualEffects();
const $8a992fbd81573bde$var$clickTracker = new $b60044e050f897de$exports.ClickTracker();
let $8a992fbd81573bde$var$clickCounter = Number.parseInt(localStorage.getItem("clickCount") || "0");
// PowerupManager reads live click speed and count for scaling
const $8a992fbd81573bde$var$powerupManager = new $5825678eb68e4677$exports.PowerupManager({
    getClickSpeed: ()=>$8a992fbd81573bde$var$clickTracker.getClickSpeed(),
    getClickCount: ()=>$8a992fbd81573bde$var$clickCounter
});
// Expose powerupManager globally for debugging
window.powerupManager = $8a992fbd81573bde$var$powerupManager;
const $8a992fbd81573bde$var$clickCounterElement = document.getElementById("click-counter");
const $8a992fbd81573bde$var$mobileCounterElement = document.createElement("div");
$8a992fbd81573bde$var$mobileCounterElement.id = "mobile-counter";
document.getElementById("button-container").prepend($8a992fbd81573bde$var$mobileCounterElement);
const $8a992fbd81573bde$var$fullscreenButton = document.getElementById("fullscreen-button");
// Initialize counter and button container with hidden state
$8a992fbd81573bde$var$clickCounterElement.style.display = "none";
$8a992fbd81573bde$var$mobileCounterElement.style.display = "none";
document.getElementById("button-container").style.display = "none";
$8a992fbd81573bde$var$clickCounterElement.innerText = `${$8a992fbd81573bde$var$clickCounter}`;
$8a992fbd81573bde$var$mobileCounterElement.innerText = `${$8a992fbd81573bde$var$clickCounter}`;
// Initialize achievements table
$8a992fbd81573bde$var$achievementManager.updateAchievementsTable($8a992fbd81573bde$var$clickCounter);
// Update achievements table on window resize
window.addEventListener("resize", ()=>{
    $8a992fbd81573bde$var$achievementManager.updateAchievementsTable($8a992fbd81573bde$var$clickCounter);
});
var $16352665577ed085$exports = {};
$16352665577ed085$exports = import.meta.resolve("ez3XV");


// Register Service Worker
if ("serviceWorker" in navigator) window.addEventListener("load", ()=>{
    navigator.serviceWorker.register($16352665577ed085$exports).then((registration)=>{
        console.log("ServiceWorker registration successful");
    }).catch((err)=>{
        console.log("ServiceWorker registration failed: ", err);
    });
});
// Start the powerup spawn timer (reads live click speed each cycle)
$8a992fbd81573bde$var$powerupManager.startPowerupSpawnTimer();
// Initialize translations and setup
async function $8a992fbd81573bde$var$initializeApp() {
    // Wait for i18next to initialize
    await $8a992fbd81573bde$var$_i18n.i18nInstance;
    // Initialize translations for static content
    const translationElements = document.querySelectorAll("[data-i18n]");
    const updatePageTranslations = ()=>{
        for (const element of translationElements){
            const key = element.getAttribute("data-i18n");
            element.textContent = $8a992fbd81573bde$var$_i18n.default.t(key);
        }
    };
    // Set initial translations
    updatePageTranslations();
    // Handle language changes
    const languageSelect = document.getElementById("language-select");
    // Set initial language value after i18next has detected the language
    const currentLanguage = $8a992fbd81573bde$var$_i18n.default.language.split("-")[0]; // Handle cases like 'en-US' -> 'en'
    languageSelect.value = currentLanguage;
    languageSelect.addEventListener("change", async (event)=>{
        await $8a992fbd81573bde$var$_i18n.default.changeLanguage(event.target.value);
        updatePageTranslations();
        // Update any dynamic content that needs translation
        $8a992fbd81573bde$var$achievementManager.updateAchievementsTable($8a992fbd81573bde$var$clickCounter);
    });
}
// Start initialization
$8a992fbd81573bde$var$initializeApp().catch(console.error);
// Listen for powerup collection
document.addEventListener("powerupCollected", (e)=>{
    $8a992fbd81573bde$var$clickCounter += e.detail.bonus;
    localStorage.setItem("clickCount", $8a992fbd81573bde$var$clickCounter.toString());
    $8a992fbd81573bde$var$clickCounterElement.innerText = `${$8a992fbd81573bde$var$clickCounter}`;
    $8a992fbd81573bde$var$mobileCounterElement.innerText = `${$8a992fbd81573bde$var$clickCounter}`;
    $8a992fbd81573bde$var$visualEffects.screenShake();
    $8a992fbd81573bde$var$visualEffects.vibrate("large");
});
document.addEventListener("click", (e)=>{
    $8a992fbd81573bde$var$clickTracker.updateClickSpeed();
    $8a992fbd81573bde$var$visualEffects.createClickConfetti(e);
    $8a992fbd81573bde$var$clickCounter += $8a992fbd81573bde$var$powerupManager.getMultiplier();
    localStorage.setItem("clickCount", $8a992fbd81573bde$var$clickCounter.toString());
    $8a992fbd81573bde$var$clickCounterElement.innerText = `${$8a992fbd81573bde$var$clickCounter}`;
    $8a992fbd81573bde$var$mobileCounterElement.innerText = `${$8a992fbd81573bde$var$clickCounter}`;
    // Show counter at 10 clicks
    if ($8a992fbd81573bde$var$clickCounter >= 10) {
        $8a992fbd81573bde$var$clickCounterElement.style.display = "block";
        $8a992fbd81573bde$var$mobileCounterElement.style.display = "block";
    }
    // Show menu at 20 clicks
    if ($8a992fbd81573bde$var$clickCounter >= 20) document.getElementById("button-container").style.display = "flex";
    (0, $e6b4755c893fae30$exports.flashMessage)($8a992fbd81573bde$var$clickCounter, $8a992fbd81573bde$var$_messages.default.messages);
    // Check achievements
    $8a992fbd81573bde$var$achievementManager.checkAchievements($8a992fbd81573bde$var$clickCounter);
    // Random carrot spawn chance
    if (Math.random() < 0.01) $8a992fbd81573bde$var$powerupManager.spawnRandomCarrot();
    // Haptic feedback and streak messages
    if ($8a992fbd81573bde$var$clickCounter % 100 === 0) {
        $8a992fbd81573bde$var$visualEffects.vibrate("evenBigger");
        // Show the streak message to the player
        (0, $e6b4755c893fae30$exports.flashMessage)(0, [
            {
                clicks: 0,
                messageKey: "powerups.clickStreak",
                translationVars: {
                    count: $8a992fbd81573bde$var$clickCounter
                }
            }
        ]);
    } else if ($8a992fbd81573bde$var$clickCounter % 10 === 0) $8a992fbd81573bde$var$visualEffects.vibrate("large");
    else $8a992fbd81573bde$var$visualEffects.vibrate("small");
    if ($8a992fbd81573bde$var$clickCounter % 25 === 0) $8a992fbd81573bde$var$visualEffects.blendBackgroundColor($8a992fbd81573bde$var$clickCounter);
});
// Button functionality
const $8a992fbd81573bde$var$achievementsButton = document.getElementById("achievements-button");
const $8a992fbd81573bde$var$resetButton = document.getElementById("reset-button");
const $8a992fbd81573bde$var$modal = document.getElementById("modal");
const $8a992fbd81573bde$var$closeBtn = document.querySelector(".close");
$8a992fbd81573bde$var$fullscreenButton.addEventListener("click", ()=>{
    if (!document.fullscreenElement) document.documentElement.requestFullscreen().catch((err)=>{
        console.warn("Fullscreen request denied:", err);
    });
    else if (document.exitFullscreen) document.exitFullscreen();
});
$8a992fbd81573bde$var$achievementsButton.addEventListener("click", ()=>{
    const modalAchievements = document.getElementById("modal-achievements");
    // Clear existing content safely
    while(modalAchievements.firstChild)modalAchievements.removeChild(modalAchievements.firstChild);
    // Filter and sort earned achievements
    const earnedAchievements = Object.entries($8a992fbd81573bde$var$achievementManager.achievements).map(([name, achievement])=>({
            name: name,
            ...achievement
        })).filter((achievement)=>achievement.earned).sort((a, b)=>a.threshold - b.threshold);
    if (earnedAchievements.length === 0) {
        const noAchievementsDiv = document.createElement("div");
        noAchievementsDiv.style.textAlign = "center";
        noAchievementsDiv.style.padding = "20px";
        noAchievementsDiv.innerText = $8a992fbd81573bde$var$_i18n.default.t("achievements.noAchievements");
        modalAchievements.appendChild(noAchievementsDiv);
    } else for (const achievement of earnedAchievements){
        const achievementDiv = document.createElement("div");
        achievementDiv.style.margin = "10px 0";
        achievementDiv.style.padding = "10px";
        achievementDiv.style.borderBottom = "2px solid #333";
        const earnedDiv = document.createElement("div");
        earnedDiv.className = "earned";
        earnedDiv.textContent = $8a992fbd81573bde$var$_i18n.default.t(achievement.messageKey);
        achievementDiv.appendChild(earnedDiv);
        modalAchievements.appendChild(achievementDiv);
    }
    $8a992fbd81573bde$var$modal.style.display = "block";
});
// Debug powerup button
const $8a992fbd81573bde$var$debugPowerupButton = document.getElementById("debug-powerup");
if ($8a992fbd81573bde$var$debugPowerupButton) $8a992fbd81573bde$var$debugPowerupButton.addEventListener("click", ()=>{
    $8a992fbd81573bde$var$powerupManager.spawnPowerup();
});
$8a992fbd81573bde$var$resetButton.addEventListener("click", ()=>{
    if (confirm($8a992fbd81573bde$var$_i18n.default.t("reset.confirm"))) {
        localStorage.clear();
        $8a992fbd81573bde$var$clickCounter = 0;
        $8a992fbd81573bde$var$achievementManager.reset();
        $8a992fbd81573bde$var$clickCounterElement.style.display = "none";
        location.reload();
    }
});
$8a992fbd81573bde$var$closeBtn.addEventListener("click", ()=>{
    $8a992fbd81573bde$var$modal.style.display = "none";
});
window.addEventListener("click", (event)=>{
    if (event.target === $8a992fbd81573bde$var$modal) $8a992fbd81573bde$var$modal.style.display = "none";
});
// Handle PWA installation prompt
let $8a992fbd81573bde$var$deferredPrompt;
window.addEventListener("beforeinstallprompt", (e)=>{
    e.preventDefault();
    $8a992fbd81573bde$var$deferredPrompt = e;
});


//# sourceMappingURL=repo.272f44f2.js.map
